
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9h92o", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5BRby = parcelRequire("5BRby");

var $2apnq = parcelRequire("2apnq");

var $49235 = parcelRequire("49235");

var $12NzK = parcelRequire("12NzK");

var $geFaw = parcelRequire("geFaw");

var $gd0Sp = parcelRequire("gd0Sp");
(0, $2apnq.provideHealthcheck)();
const $2e164b6c775efd10$var$container = document.createElement('div');
$2e164b6c775efd10$var$container.id = 'profilecard-app';
document.body && document.body.appendChild($2e164b6c775efd10$var$container);
(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
    id: "profilecard-next"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $12NzK.ProfileCardLegacy), {
    TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber)
})))), $2e164b6c775efd10$var$container);

});
parcelRegister("2apnq", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $2d3550a09830cc5e$export$90dcee7ddb8a0c0c);

var $1ybV0 = parcelRequire("1ybV0");
const $2d3550a09830cc5e$var$globalObj = window || $parcel$global;
const $2d3550a09830cc5e$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d3550a09830cc5e$var$failingHealthcheck = (callback)=>callback({
        isSuccess: false
    });
const $2d3550a09830cc5e$export$90dcee7ddb8a0c0c = (healthcheck = $2d3550a09830cc5e$var$defaultHealthcheck)=>{
    const isHealthcheckAllFailEnabled = (0, $1ybV0.ff)('fe.platform.healthcheck.allfail.enabled');
    if (isHealthcheckAllFailEnabled) {
        $2d3550a09830cc5e$var$globalObj.performHealthcheck = $2d3550a09830cc5e$var$failingHealthcheck;
        return;
    }
    $2d3550a09830cc5e$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("12NzK", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $c05a2c6fef331800$export$bed540ccfa8743c4);
$parcel$export(module.exports, "ProfileCardLegacy", () => $c05a2c6fef331800$export$dd0591e04a6e8ce6);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k8Qyf = parcelRequire("k8Qyf");

var $4ksts = parcelRequire("4ksts");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $fK6zo = parcelRequire("fK6zo");


var $dIJJY = parcelRequire("dIJJY");

var $4w3h5 = parcelRequire("4w3h5");

var $NILIK = parcelRequire("NILIK");

var $bv8gI = parcelRequire("bv8gI");
const $c05a2c6fef331800$export$bed540ccfa8743c4 = (props)=>{
    const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData } = props;
    const intl = (0, $4ksts.useIntlV2)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: (0, $2f37035f7aaf1787$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NILIK.default), {
        TenantContextSubscriber: TenantContextSubscriberComponent,
        externalProfileClient: externalProfileClient,
        analyticsData: analyticsData
    }, (atlassianAccountId, profileClient, cloudId, baseUrl)=>{
        if (atlassianAccountId !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fK6zo.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dIJJY.default), {
                profileClient: profileClient,
                cloudId: cloudId,
                accountId: accountId,
                actions: (0, $bv8gI.getSpaActions)(accountId, baseUrl, intl, push, actions),
                position: position,
                onProfileClick: (profileAccountId)=>push(`${baseUrl}/jira/people/${profileAccountId}`),
                addFlag: showFlag,
                dismissFlag: dismissFlag,
                testId: testId,
                trigger: trigger,
                prepopulatedData: prepopulatedData
            }, children));
        return children;
    }));
};
const $c05a2c6fef331800$export$dd0591e04a6e8ce6 = (props)=>{
    const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, actions: actions } = props;
    const intl = (0, $4ksts.useIntlV2)();
    const onLoadError = (error, analyticsEvent)=>{
        if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${analyticsEvent.payload.actionSubject} ${analyticsEvent.payload.action}`, `${analyticsEvent.payload.actionSubject}${analyticsEvent.payload.action}`, {
            error: error
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: (0, $2f37035f7aaf1787$export$50632e21ea714398)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NILIK.default), {
        TenantContextSubscriber: TenantContextSubscriberComponent,
        externalProfileClient: externalProfileClient,
        onLoadError: onLoadError
    }, (atlassianAccountId, profileClient, cloudId, baseUrl)=>// @ts-expect-error - TS2769 - No overload matches this call.
        atlassianAccountId !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c05a2c6fef331800$var$LegacyProfileCardStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fK6zo.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4w3h5.default), {
                profileClient: profileClient,
                cloudId: cloudId,
                baseUrl: baseUrl,
                onGetActions: (accountId, onActionCleanup)=>(0, $bv8gI.getSpaActions)(accountId, baseUrl, intl, push, actions, onActionCleanup),
                onProfileClick: (profileAccountId)=>push(`${baseUrl}/jira/people/${profileAccountId}`)
            }))) : null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c05a2c6fef331800$var$LegacyProfileCardStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ksts", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $32efc9cfc8f5c011$export$d82607073b68786);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1IqwQ = parcelRequire("1IqwQ");
const $32efc9cfc8f5c011$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatRelativeTime: formatRelativeTime, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $5JgJ2.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eUqFw.useMemo)(()=>{
        const modifiedIntl = {
            // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
            now: ()=>Date.now(),
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatHTMLMessage: (descriptor, values)=>formatMessage(descriptor, values, {
                    ignoreTag: true
                }),
            formatNumber: formatNumber,
            formatRelative: (date, opts)=>{
                const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                return formatRelativeTime(time, unit, opts);
            },
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatRelativeTime,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("dIJJY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fccd41ace13b158$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
parcelRequire("j2NCp");
var $1I4cW = parcelRequire("1I4cW");

var $1ybV0 = parcelRequire("1ybV0");

var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");

var $g8JvH = parcelRequire("g8JvH");

const $7fccd41ace13b158$var$PEOPLE_PROFILE_PATH = '/people/';
const $7fccd41ace13b158$var$ProfileCardTriggerWithAnalyticsNew = (0, $g8JvH.AnalyticsEventToProps)((0, $7543475b40b0a31d$export$a1455360a24a2234), {
    analytics: ''
})((0, $1I4cW.default));
// eslint-disable-next-line jira/react/no-class-components
class $7fccd41ace13b158$var$ProfileCardView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            position: 'top-start',
            trigger: 'hover'
        };
    }
    render() {
        const { children: children, position: position, trigger: trigger, accountId: accountId, cloudId: cloudId, profileClient: profileClient, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData } = this.props;
        const ProfileCardComponent = $7fccd41ace13b158$var$ProfileCardTriggerWithAnalyticsNew;
        return(// Stop the propagation of the click event when clicking on the profile card pop up,
        // to avoid closing the popup and opening the people picker when clicking the info inside.
        // Don't stop propagation when clicking the people picker directly.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fccd41ace13b158$var$Wrapper, {
            ref: this.profileCardWrapperRef,
            onClick: (event)=>{
                if (this.profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                !this.profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProfileCardComponent, {
            cloudId: cloudId,
            userId: accountId,
            resourceClient: profileClient,
            position: position,
            trigger: trigger,
            testId: testId,
            actions: actions,
            reportingLinesProfileUrl: $7fccd41ace13b158$var$PEOPLE_PROFILE_PATH,
            prepopulatedData: prepopulatedData,
            onReportingLinesClick: // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
            onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : null,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            addFlag: (flag)=>{
                const flagId = (0, $eo17r.toFlagId)(flag.id);
                addFlag({
                    id: flagId,
                    render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                            ...flag,
                            onDismissed: ()=>{
                                dismissFlag(flagId);
                            },
                            ...props
                        })
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)))));
    }
    constructor(...args){
        super(...args);
        this.profileCardWrapperRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7fccd41ace13b158$export$2e2bcd8739ae039 = $7fccd41ace13b158$var$ProfileCardView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fccd41ace13b158$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ibjraq": (0, $9t7rW.default)((0, $1ybV0.ff)('nin-resizable-columns_8z4eo') && '100%')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f4g5r _1l8r1osq",
            __cmplp.className
        ])
    });
});
$7fccd41ace13b158$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("j2NCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5f762d9b5740e9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withOuterListeners", () => (parcelRequire("icLG8")).default);
$parcel$export(module.exports, "TeamProfileCard", () => (parcelRequire("g8DVf")).default);
$parcel$export(module.exports, "ProfileCardTrigger", () => (parcelRequire("1I4cW")).default);
$parcel$export(module.exports, "ProfileClient", () => (parcelRequire("lsiAJ")).default);
$parcel$export(module.exports, "UserProfileClient", () => (parcelRequire("b4hs7")).default);
$parcel$export(module.exports, "DELAY_MS_SHOW", () => $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
// Avoid exporting new components in this file as they will affect the bundle size of all consumers
// importing directly from @atlaskit/profilecard.

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");

var $6uyUT = parcelRequire("6uyUT");

var $94Fw4 = parcelRequire("94Fw4");

var $ehM5E = parcelRequire("ehM5E");

var $6aOtB = parcelRequire("6aOtB");

var $1I4cW = parcelRequire("1I4cW");


var $icLG8 = parcelRequire("icLG8");

var $g8DVf = parcelRequire("g8DVf");

var $b5p0p = parcelRequire("b5p0p");

var $eKJ5n = parcelRequire("eKJ5n");
var $ce5f762d9b5740e9$export$2e2bcd8739ae039 = (0, $6aOtB.default);

});
parcelRegister("lsiAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b7dde52ef02eed$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $9KeXL = parcelRequire("9KeXL");

var $kmpkL = parcelRequire("kmpkL");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
class $84b7dde52ef02eed$var$ProfileCardClient {
    constructor(config, clients){
        this.userClient = clients?.userClient || new (0, $b4hs7.default)(config);
        this.teamClient = clients?.teamClient || new (0, $kWhjG.default)(config);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $9KeXL.default)(config);
        this.tcClient = $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        return this.tcClient?.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
}
function $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $dfBCt.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $kmpkL.default)({
        ...config,
        teamCentralUrl: teamCentralUrl
    }) : undefined;
}
var $84b7dde52ef02eed$export$2e2bcd8739ae039 = $84b7dde52ef02eed$var$ProfileCardClient;

});
parcelRegister("9KeXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a501e1692a6dcaf$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $lBUiV = parcelRequire("lBUiV");
class $4a501e1692a6dcaf$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        if (id.type === 'identity') return (0, $lBUiV.getAgentDetailsByUserId)(id.value, this.options.productIdentifier || 'rovo', cloudId);
        return (0, $lBUiV.getAgentDetailsByAgentId)(id.value, this.options.productIdentifier || 'rovo', cloudId);
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('IF is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3825798267526520$export$a9f8c9f412cf5664);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$AGENT_SUBJECT = 'rovoAgenrProfilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3825798267526520$var$USER_SUBJECT;
        case 'team':
            return $3825798267526520$var$TEAM_SUBJECT;
        case 'agent':
            return $3825798267526520$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>{
    return $3825798267526520$var$createEvent('ui', 'triggered', $3825798267526520$var$getActionSubject(type), undefined, {
        method: method
    });
};
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', $3825798267526520$var$getActionSubject(type), actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3825798267526520$export$a9f8c9f412cf5664 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$AGENT_SUBJECT, 'request', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("4eGN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3adc3d48b40454$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $7c3adc3d48b40454$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("bl3OJ", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d2cc0f3532818141$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d2cc0f3532818141$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d2cc0f3532818141$export$d9ad65d422ee3f8c);

var $j4C9S = parcelRequire("j4C9S");
const $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d2cc0f3532818141$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return !!error && $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $j4C9S.AGGError)) return !!error.errorType && $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d2cc0f3532818141$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $j4C9S.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $j4C9S.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $j4C9S.DirectoryGraphQLErrors) || causeError instanceof (0, $j4C9S.AGGErrors)) return $d2cc0f3532818141$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d2cc0f3532818141$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $j4C9S.DirectoryGraphQLErrors)(errors, traceId);
};
const $d2cc0f3532818141$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $j4C9S.AGGErrors)(errors, traceId);
};

});
parcelRegister("j4C9S", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $343a8316fe4e3587$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $343a8316fe4e3587$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $343a8316fe4e3587$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $343a8316fe4e3587$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $343a8316fe4e3587$export$60d8267243755b9c);
class $343a8316fe4e3587$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $343a8316fe4e3587$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $343a8316fe4e3587$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});


parcelRegister("lBUiV", function(module, exports) {

$parcel$export(module.exports, "getAgentDetailsByAgentId", () => $809c396fa2b42ce6$export$c9fa23b298652f7f);
$parcel$export(module.exports, "getAgentDetailsByUserId", () => $809c396fa2b42ce6$export$7446f7cf554ee3f9);

var $6oOPK = parcelRequire("6oOPK");
async function $809c396fa2b42ce6$export$c9fa23b298652f7f(agentId, product, cloudId) {
    const headers = (0, $6oOPK.createHeaders)(product, cloudId);
    return await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: headers
    })).then((response)=>response.json());
}
async function $809c396fa2b42ce6$export$7446f7cf554ee3f9(userId, product, cloudId) {
    const headers = (0, $6oOPK.createHeaders)(product, cloudId);
    return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${userId}`, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: headers
    })).then((response)=>{
        return response.json();
    });
}

});
parcelRegister("6oOPK", function(module, exports) {

$parcel$export(module.exports, "createHeaders", () => $d85581b87885252e$export$197579c449ddabf4);
$parcel$export(module.exports, "getAAIDFromARI", () => $d85581b87885252e$export$3761e66a04602cbd);
const $d85581b87885252e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d85581b87885252e$export$197579c449ddabf4 = (product, cloudId)=>{
    const config = {
        headers: {
            'X-Product': product,
            'X-Experience-Id': 'profile-card',
            'X-Cloudid': cloudId
        }
    };
    return new Headers({
        ...config.headers || {}
    });
};
const $d85581b87885252e$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d85581b87885252e$export$470b0d72e4fdc43a, '');
};

});



parcelRegister("kmpkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8fb2ad4171564c$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $6WG70 = parcelRequire("6WG70");
const $ab8fb2ad4171564c$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $ab8fb2ad4171564c$export$f8c05b360e45cd0 = (featureKey, context)=>({
        query: `
    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {
      isFeatureEnabled(featureKey: $featureKey, context: $context) {
        enabled
      }
    }
  `,
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    });
function $ab8fb2ad4171564c$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch(`/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
let $ab8fb2ad4171564c$var$isTCReadyPromiseMap = new Map();
class $ab8fb2ad4171564c$var$TeamCentralCardClient extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.featureFlagKeys = new Map();
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $ab8fb2ad4171564c$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = $ab8fb2ad4171564c$var$hasTCWorkspace(config);
                $ab8fb2ad4171564c$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    async makeFeatureFlagCheckRequest(featureKey, context) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$f8c05b360e45cd0(featureKey, context);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=isFeatureKeyEnabled`, query);
        return response.isFeatureEnabled.enabled;
    }
    async makeRequest(userId) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
        return response.reportingLines;
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    getFlagEnabled(featureKey, productIdentifier) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!featureKey) return Promise.reject(new Error('featureKey missing'));
                if (this.featureFlagKeys.has(featureKey)) return Promise.resolve(this.featureFlagKeys.get(featureKey));
                if (this.bypassOnFailure) return Promise.resolve(false);
                const context = [
                    {
                        key: 'productIdentifier',
                        value: productIdentifier || 'unset'
                    }
                ];
                return new Promise((resolve)=>{
                    this.makeFeatureFlagCheckRequest(featureKey, context).then((enabled)=>{
                        this.featureFlagKeys.set(featureKey, enabled);
                        resolve(enabled);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        resolve(false);
                    });
                });
            }
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $ab8fb2ad4171564c$export$2e2bcd8739ae039 = $ab8fb2ad4171564c$var$TeamCentralCardClient;

});
parcelRegister("6WG70", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $415b57eeeceb8e81$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $415b57eeeceb8e81$export$a14afb5f82fe705);

var $j4C9S = parcelRequire("j4C9S");

var $bl3OJ = parcelRequire("bl3OJ");
const $415b57eeeceb8e81$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $415b57eeeceb8e81$var$id = (headers)=>headers;
async function $415b57eeeceb8e81$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleDirectoryGraphQLErrors));
}
async function $415b57eeeceb8e81$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleAGGErrors));
}
async function $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id, handleErrors) {
    const headers = processHeaders($415b57eeeceb8e81$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $j4C9S.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});


parcelRegister("kWhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e65ba6df7e3eef$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $k39sp = parcelRequire("k39sp");
class $26e65ba6df7e3eef$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $k39sp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("k39sp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $b92dd34bfd4aec4a$export$26a8aad0c7182dd6);

var $6WG70 = parcelRequire("6WG70");
const $b92dd34bfd4aec4a$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $b92dd34bfd4aec4a$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $b92dd34bfd4aec4a$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $b92dd34bfd4aec4a$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $b92dd34bfd4aec4a$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $b92dd34bfd4aec4a$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$b92dd34bfd4aec4a$var$TEAM_FRAGMENT}
    }
  }
}`;
const $b92dd34bfd4aec4a$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $b92dd34bfd4aec4a$export$4968f4e0119a5d9c,
        variables: {
            teamId: $b92dd34bfd4aec4a$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $b92dd34bfd4aec4a$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $b92dd34bfd4aec4a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $b92dd34bfd4aec4a$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $6WG70.AGGQuery)(url, query, $b92dd34bfd4aec4a$export$1229c72526c01df2);
    return $b92dd34bfd4aec4a$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("b4hs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3ff2ca38ed950$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $3vXh8 = parcelRequire("3vXh8");

var $j9Z8Z = parcelRequire("j9Z8Z");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $6WG70 = parcelRequire("6WG70");
const $80b3ff2ca38ed950$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $80b3ff2ca38ed950$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
const $80b3ff2ca38ed950$export$8230f28f7ae567ea = (userId)=>({
        query: `query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
		}
	}`,
        variables: {
            userId: userId
        }
    });
const $80b3ff2ca38ed950$var$getUserInSiteUserBase = (cloudId, userId)=>{
    return fetch(new Request(`/gateway/api/teams/site/${cloudId}/users/${userId}/exists`, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'X-header-client-id': 'ptc-fe'
        }
    })).then((response)=>response.json());
};
const $80b3ff2ca38ed950$var$queryAGGUser = async (url, userId)=>{
    const query = $80b3ff2ca38ed950$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $6WG70.AGGQuery)(url, query);
    return user;
};
class $80b3ff2ca38ed950$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if ((0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query')) {
            if (!this.options.gatewayGraphqlUrl) throw new Error('options.gatewayGraphqlUrl is a required parameter');
            const userCheckPromise = $80b3ff2ca38ed950$var$getUserInSiteUserBase(cloudId, userId);
            const userQueryPromise = $80b3ff2ca38ed950$var$queryAGGUser(this.options.gatewayGraphqlUrl, userId);
            const checkUserPresentInSiteRes = await userCheckPromise;
            if (!checkUserPresentInSiteRes.isPresent) // Use this error message to not trouble SLO, check out getErrorAttributes for reference
            throw new Error('Unable to fetch user: User does not exist in this site');
            const user = await userQueryPromise;
            let timestring;
            const localWeekdayIndex = new Date().getDay().toString();
            if (user.zoneinfo) {
                if ((0, $j9Z8Z.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $j9Z8Z.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
                else timestring = (0, $j9Z8Z.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
            }
            return {
                ...user,
                isBot: user.__typename === 'AppUser',
                status: user.accountStatus,
                statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
                avatarUrl: user.picture,
                email: user.email,
                fullName: user.name,
                location: user.extendedProfile?.location,
                meta: user.extendedProfile?.jobTitle,
                nickname: user.nickname,
                companyName: user.extendedProfile?.organization,
                timestring: timestring
            };
        } else {
            if (!this.options.url) throw new Error('options.url is a required parameter');
            const query = $80b3ff2ca38ed950$export$bfbf383663068c37(cloudId, userId);
            const response = await (0, $6WG70.directoryGraphqlQuery)(this.options.url, query);
            return $80b3ff2ca38ed950$export$b26b7f9bcf400835(response);
        }
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("j9Z8Z", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $8973c96ca3937b75$export$f0dfd716e7b023cd);
parcelRequire("isoj5");
var $hhZDn = parcelRequire("hhZDn");
const $8973c96ca3937b75$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $hhZDn.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("isoj5", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("hhZDn")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $hhZDn = parcelRequire("hhZDn");





});
parcelRegister("hhZDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c963d570fe7b6c77$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $7ue53 = parcelRequire("7ue53");

var $iPYJi = parcelRequire("iPYJi");
function $c963d570fe7b6c77$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $7ue53.default)((0, $iPYJi.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("1WmNj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $169ce3b937cd7b12$var$cloneObject;

var $169ce3b937cd7b12$var$_index = $169ce3b937cd7b12$var$_interopRequireDefault((parcelRequire("5aZTm")));
function $169ce3b937cd7b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $169ce3b937cd7b12$var$cloneObject(dirtyObject) {
    return (0, $169ce3b937cd7b12$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("5aZTm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c4de5622d0e6607$var$assign;
function $3c4de5622d0e6607$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("7ue53", function(module, exports) {

$parcel$export(module.exports, "default", () => $573641d4461c49f9$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $fIcie = parcelRequire("fIcie");

var $MQM8H = parcelRequire("MQM8H");
var $573641d4461c49f9$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $573641d4461c49f9$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($573641d4461c49f9$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $MQM8H.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $fIcie.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("Yg8hb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b521e49771b7554$var$format;

var $0b521e49771b7554$var$_index = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("ky7sH")));

var $0b521e49771b7554$var$_index2 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("1Bbnz")));

var $0b521e49771b7554$var$_index3 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("emeRN")));

var $0b521e49771b7554$var$_index4 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $0b521e49771b7554$var$_index5 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("69lef")));

var $0b521e49771b7554$var$_index6 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("frLM1")));

var $0b521e49771b7554$var$_index7 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("YdpzT")));

var $4ug6M = parcelRequire("4ug6M");

var $0b521e49771b7554$var$_index9 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $0b521e49771b7554$var$_index10 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $0b521e49771b7554$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0b521e49771b7554$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0b521e49771b7554$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0b521e49771b7554$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0b521e49771b7554$var$doubleQuoteRegExp = /''/g;
var $0b521e49771b7554$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $0b521e49771b7554$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $0b521e49771b7554$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $0b521e49771b7554$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $0b521e49771b7554$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $0b521e49771b7554$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $0b521e49771b7554$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $0b521e49771b7554$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $0b521e49771b7554$var$_index4.default)(dirtyDate);
    if (!(0, $0b521e49771b7554$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $0b521e49771b7554$var$_index7.default)(originalDate);
    var utcDate = (0, $0b521e49771b7554$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0b521e49771b7554$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $0b521e49771b7554$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($0b521e49771b7554$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0b521e49771b7554$var$cleanEscapedString(substring);
        var formatter = $0b521e49771b7554$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $4ug6M.isProtectedWeekYearToken)(substring)) (0, $4ug6M.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $4ug6M.isProtectedDayOfYearToken)(substring)) (0, $4ug6M.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0b521e49771b7554$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0b521e49771b7554$var$cleanEscapedString(input) {
    return input.match($0b521e49771b7554$var$escapedStringRegExp)[1].replace($0b521e49771b7554$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ky7sH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef5cc5628cfb5940$var$isValid;

var $ef5cc5628cfb5940$var$_index = $ef5cc5628cfb5940$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $ef5cc5628cfb5940$var$_index2 = $ef5cc5628cfb5940$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $ef5cc5628cfb5940$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $ef5cc5628cfb5940$var$isValid(dirtyDate) {
    (0, $ef5cc5628cfb5940$var$_index2.default)(1, arguments);
    var date = (0, $ef5cc5628cfb5940$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("8Ab9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63fa569256896d17$var$toDate;

var $63fa569256896d17$var$_index = $63fa569256896d17$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $63fa569256896d17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $63fa569256896d17$var$toDate(argument) {
    (0, $63fa569256896d17$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("lLZWw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd9e094e4a9a8b8d$var$requiredArgs;
function $fd9e094e4a9a8b8d$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("1Bbnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a212d2f4ff6049$var$_index = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("dWxGM")));

var $12a212d2f4ff6049$var$_index2 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("hpyHJ")));

var $12a212d2f4ff6049$var$_index3 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("loKOy")));

var $12a212d2f4ff6049$var$_index4 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("2Jhnc")));

var $12a212d2f4ff6049$var$_index5 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("3BeWb")));
function $12a212d2f4ff6049$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $12a212d2f4ff6049$var$locale = {
    code: 'en-US',
    formatDistance: $12a212d2f4ff6049$var$_index.default,
    formatLong: $12a212d2f4ff6049$var$_index2.default,
    formatRelative: $12a212d2f4ff6049$var$_index3.default,
    localize: $12a212d2f4ff6049$var$_index4.default,
    match: $12a212d2f4ff6049$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $12a212d2f4ff6049$var$_default = $12a212d2f4ff6049$var$locale;
module.exports.default = $12a212d2f4ff6049$var$_default;
module.exports = module.exports.default;

});
parcelRegister("dWxGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a26ad313d3dbf920$var$formatDistance;
var $a26ad313d3dbf920$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $a26ad313d3dbf920$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $a26ad313d3dbf920$var$formatDistanceLocale[token] === 'string') result = $a26ad313d3dbf920$var$formatDistanceLocale[token];
    else if (count === 1) result = $a26ad313d3dbf920$var$formatDistanceLocale[token].one;
    else result = $a26ad313d3dbf920$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("hpyHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cacfb1041f875450$var$_index = $cacfb1041f875450$var$_interopRequireDefault((parcelRequire("9kdSS")));
function $cacfb1041f875450$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cacfb1041f875450$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cacfb1041f875450$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cacfb1041f875450$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cacfb1041f875450$var$formatLong = {
    date: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cacfb1041f875450$var$_default = $cacfb1041f875450$var$formatLong;
module.exports.default = $cacfb1041f875450$var$_default;
module.exports = module.exports.default;

});
parcelRegister("9kdSS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ca0c06639ff0707$var$buildFormatLongFn;
function $6ca0c06639ff0707$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("loKOy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f940273ff769021c$var$formatRelative;
var $f940273ff769021c$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $f940273ff769021c$var$formatRelative(token, _date, _baseDate, _options) {
    return $f940273ff769021c$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("2Jhnc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fcd42ac6af0f70a$var$_index = $1fcd42ac6af0f70a$var$_interopRequireDefault((parcelRequire("aHQcG")));
function $1fcd42ac6af0f70a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1fcd42ac6af0f70a$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $1fcd42ac6af0f70a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1fcd42ac6af0f70a$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $1fcd42ac6af0f70a$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $1fcd42ac6af0f70a$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $1fcd42ac6af0f70a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $1fcd42ac6af0f70a$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $1fcd42ac6af0f70a$var$localize = {
    ordinalNumber: $1fcd42ac6af0f70a$var$ordinalNumber,
    era: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1fcd42ac6af0f70a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1fcd42ac6af0f70a$var$_default = $1fcd42ac6af0f70a$var$localize;
module.exports.default = $1fcd42ac6af0f70a$var$_default;
module.exports = module.exports.default;

});
parcelRegister("aHQcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7cb66a0f1c81e8df$var$buildLocalizeFn;
function $7cb66a0f1c81e8df$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("3BeWb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29f06a0f5c74a5cd$var$_index = $29f06a0f5c74a5cd$var$_interopRequireDefault((parcelRequire("bpnBt")));

var $29f06a0f5c74a5cd$var$_index2 = $29f06a0f5c74a5cd$var$_interopRequireDefault((parcelRequire("a2pHz")));
function $29f06a0f5c74a5cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $29f06a0f5c74a5cd$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $29f06a0f5c74a5cd$var$parseOrdinalNumberPattern = /\d+/i;
var $29f06a0f5c74a5cd$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $29f06a0f5c74a5cd$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $29f06a0f5c74a5cd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $29f06a0f5c74a5cd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $29f06a0f5c74a5cd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $29f06a0f5c74a5cd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $29f06a0f5c74a5cd$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $29f06a0f5c74a5cd$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $29f06a0f5c74a5cd$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $29f06a0f5c74a5cd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $29f06a0f5c74a5cd$var$match = {
    ordinalNumber: (0, $29f06a0f5c74a5cd$var$_index.default)({
        matchPattern: $29f06a0f5c74a5cd$var$matchOrdinalNumberPattern,
        parsePattern: $29f06a0f5c74a5cd$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $29f06a0f5c74a5cd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $29f06a0f5c74a5cd$var$_default = $29f06a0f5c74a5cd$var$match;
module.exports.default = $29f06a0f5c74a5cd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bpnBt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84e456a5d66783af$var$buildMatchPatternFn;
function $84e456a5d66783af$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("a2pHz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74ee071a34dc674f$var$buildMatchFn;
function $74ee071a34dc674f$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $74ee071a34dc674f$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $74ee071a34dc674f$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $74ee071a34dc674f$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $74ee071a34dc674f$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("emeRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a73ea6f79e2df726$var$subMilliseconds;

var $a73ea6f79e2df726$var$_index = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $a73ea6f79e2df726$var$_index2 = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("ddIDm")));

var $a73ea6f79e2df726$var$_index3 = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $a73ea6f79e2df726$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $a73ea6f79e2df726$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $a73ea6f79e2df726$var$_index3.default)(2, arguments);
    var amount = (0, $a73ea6f79e2df726$var$_index.default)(dirtyAmount);
    return (0, $a73ea6f79e2df726$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("4Zzm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a2848f4741c5f55$var$toInteger;
function $3a2848f4741c5f55$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("ddIDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99ff1c97c8892d76$var$addMilliseconds;

var $99ff1c97c8892d76$var$_index = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $99ff1c97c8892d76$var$_index2 = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $99ff1c97c8892d76$var$_index3 = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $99ff1c97c8892d76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $99ff1c97c8892d76$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $99ff1c97c8892d76$var$_index3.default)(2, arguments);
    var timestamp = (0, $99ff1c97c8892d76$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $99ff1c97c8892d76$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("69lef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47a40ced54ac5b5e$var$_index = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("1eXm0")));

var $47a40ced54ac5b5e$var$_index2 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("a357h")));

var $47a40ced54ac5b5e$var$_index3 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("2NIDC")));

var $47a40ced54ac5b5e$var$_index4 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("4IzFf")));

var $47a40ced54ac5b5e$var$_index5 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("2jCJh")));

var $47a40ced54ac5b5e$var$_index6 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("a4ShE")));

var $47a40ced54ac5b5e$var$_index7 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("e1No1")));
function $47a40ced54ac5b5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $47a40ced54ac5b5e$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $47a40ced54ac5b5e$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $47a40ced54ac5b5e$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $47a40ced54ac5b5e$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $47a40ced54ac5b5e$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $47a40ced54ac5b5e$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $47a40ced54ac5b5e$var$_index4.default)(date); // Padding
        return (0, $47a40ced54ac5b5e$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $47a40ced54ac5b5e$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $47a40ced54ac5b5e$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $47a40ced54ac5b5e$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $47a40ced54ac5b5e$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $47a40ced54ac5b5e$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $47a40ced54ac5b5e$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $47a40ced54ac5b5e$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $47a40ced54ac5b5e$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $47a40ced54ac5b5e$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $47a40ced54ac5b5e$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $47a40ced54ac5b5e$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $47a40ced54ac5b5e$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $47a40ced54ac5b5e$var$_index7.default)(timestamp, token.length);
    }
};
function $47a40ced54ac5b5e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $47a40ced54ac5b5e$var$_index7.default)(minutes, 2);
}
function $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $47a40ced54ac5b5e$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $47a40ced54ac5b5e$var$formatTimezone(offset, dirtyDelimiter);
}
function $47a40ced54ac5b5e$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $47a40ced54ac5b5e$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $47a40ced54ac5b5e$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $47a40ced54ac5b5e$var$_default = $47a40ced54ac5b5e$var$formatters;
module.exports.default = $47a40ced54ac5b5e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1eXm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7523b2f31c3a54$var$_index = $0e7523b2f31c3a54$var$_interopRequireDefault((parcelRequire("e1No1")));
function $0e7523b2f31c3a54$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $0e7523b2f31c3a54$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $0e7523b2f31c3a54$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $0e7523b2f31c3a54$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $0e7523b2f31c3a54$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $0e7523b2f31c3a54$var$_default = $0e7523b2f31c3a54$var$formatters;
module.exports.default = $0e7523b2f31c3a54$var$_default;
module.exports = module.exports.default;

});
parcelRegister("e1No1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a36777d041aab5c3$var$addLeadingZeros;
function $a36777d041aab5c3$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("a357h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $750e273c1140fb1f$var$getUTCDayOfYear;

var $750e273c1140fb1f$var$_index = $750e273c1140fb1f$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $750e273c1140fb1f$var$_index2 = $750e273c1140fb1f$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $750e273c1140fb1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $750e273c1140fb1f$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $750e273c1140fb1f$var$getUTCDayOfYear(dirtyDate) {
    (0, $750e273c1140fb1f$var$_index2.default)(1, arguments);
    var date = (0, $750e273c1140fb1f$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $750e273c1140fb1f$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("2NIDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20a2c88eb21c009b$var$getUTCISOWeek;

var $20a2c88eb21c009b$var$_index = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $20a2c88eb21c009b$var$_index2 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("byKqb")));

var $20a2c88eb21c009b$var$_index3 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("brY09")));

var $20a2c88eb21c009b$var$_index4 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $20a2c88eb21c009b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $20a2c88eb21c009b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $20a2c88eb21c009b$var$getUTCISOWeek(dirtyDate) {
    (0, $20a2c88eb21c009b$var$_index4.default)(1, arguments);
    var date = (0, $20a2c88eb21c009b$var$_index.default)(dirtyDate);
    var diff = (0, $20a2c88eb21c009b$var$_index2.default)(date).getTime() - (0, $20a2c88eb21c009b$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $20a2c88eb21c009b$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("byKqb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86a6e0fae70def86$var$startOfUTCISOWeek;

var $86a6e0fae70def86$var$_index = $86a6e0fae70def86$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $86a6e0fae70def86$var$_index2 = $86a6e0fae70def86$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $86a6e0fae70def86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $86a6e0fae70def86$var$startOfUTCISOWeek(dirtyDate) {
    (0, $86a6e0fae70def86$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $86a6e0fae70def86$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("brY09", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8560c262329c0d69$var$startOfUTCISOWeekYear;

var $8560c262329c0d69$var$_index = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("4IzFf")));

var $8560c262329c0d69$var$_index2 = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("byKqb")));

var $8560c262329c0d69$var$_index3 = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $8560c262329c0d69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8560c262329c0d69$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $8560c262329c0d69$var$_index3.default)(1, arguments);
    var year = (0, $8560c262329c0d69$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8560c262329c0d69$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("4IzFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f6efa924cd5b42$var$getUTCISOWeekYear;

var $36f6efa924cd5b42$var$_index = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $36f6efa924cd5b42$var$_index2 = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("byKqb")));

var $36f6efa924cd5b42$var$_index3 = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $36f6efa924cd5b42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $36f6efa924cd5b42$var$getUTCISOWeekYear(dirtyDate) {
    (0, $36f6efa924cd5b42$var$_index3.default)(1, arguments);
    var date = (0, $36f6efa924cd5b42$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $36f6efa924cd5b42$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $36f6efa924cd5b42$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("2jCJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1afb65f8744277f0$var$getUTCWeek;

var $1afb65f8744277f0$var$_index = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $1afb65f8744277f0$var$_index2 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $1afb65f8744277f0$var$_index3 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("4CnVl")));

var $1afb65f8744277f0$var$_index4 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $1afb65f8744277f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1afb65f8744277f0$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $1afb65f8744277f0$var$getUTCWeek(dirtyDate, options) {
    (0, $1afb65f8744277f0$var$_index4.default)(1, arguments);
    var date = (0, $1afb65f8744277f0$var$_index.default)(dirtyDate);
    var diff = (0, $1afb65f8744277f0$var$_index2.default)(date, options).getTime() - (0, $1afb65f8744277f0$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $1afb65f8744277f0$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("cyfBq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9234c3639838f220$var$startOfUTCWeek;

var $9234c3639838f220$var$_index = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $9234c3639838f220$var$_index2 = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $9234c3639838f220$var$_index3 = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $9234c3639838f220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $9234c3639838f220$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $9234c3639838f220$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $9234c3639838f220$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $9234c3639838f220$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $9234c3639838f220$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("4CnVl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35cd44d4e287df9b$var$startOfUTCWeekYear;

var $35cd44d4e287df9b$var$_index = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $35cd44d4e287df9b$var$_index2 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("a4ShE")));

var $35cd44d4e287df9b$var$_index3 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $35cd44d4e287df9b$var$_index4 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $35cd44d4e287df9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $35cd44d4e287df9b$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $35cd44d4e287df9b$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $35cd44d4e287df9b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $35cd44d4e287df9b$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $35cd44d4e287df9b$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $35cd44d4e287df9b$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("a4ShE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $756462b7c370905f$var$getUTCWeekYear;

var $756462b7c370905f$var$_index = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $756462b7c370905f$var$_index2 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $756462b7c370905f$var$_index3 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $756462b7c370905f$var$_index4 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $756462b7c370905f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $756462b7c370905f$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $756462b7c370905f$var$_index4.default)(1, arguments);
    var date = (0, $756462b7c370905f$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $756462b7c370905f$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $756462b7c370905f$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $756462b7c370905f$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $756462b7c370905f$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("frLM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $02e6f1480420e419$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $02e6f1480420e419$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $02e6f1480420e419$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $02e6f1480420e419$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $02e6f1480420e419$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $02e6f1480420e419$var$timeLongFormatter(timePattern, formatLong));
}
var $02e6f1480420e419$var$longFormatters = {
    p: $02e6f1480420e419$var$timeLongFormatter,
    P: $02e6f1480420e419$var$dateTimeLongFormatter
};
var $02e6f1480420e419$var$_default = $02e6f1480420e419$var$longFormatters;
module.exports.default = $02e6f1480420e419$var$_default;
module.exports = module.exports.default;

});

parcelRegister("YdpzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b5001f709e33659$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $0b5001f709e33659$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("4ug6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $34467589fadf6150$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $34467589fadf6150$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $34467589fadf6150$var$throwProtectedError;
var $34467589fadf6150$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $34467589fadf6150$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $34467589fadf6150$var$isProtectedDayOfYearToken(token) {
    return $34467589fadf6150$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $34467589fadf6150$var$isProtectedWeekYearToken(token) {
    return $34467589fadf6150$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $34467589fadf6150$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("fIcie", function(module, exports) {

$parcel$export(module.exports, "default", () => $b704803901ba91de$export$2e2bcd8739ae039);

var $3duP9 = parcelRequire("3duP9");

var $5joVX = parcelRequire("5joVX");
var $b704803901ba91de$var$MILLISECONDS_IN_MINUTE = 60000;
var $b704803901ba91de$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $b704803901ba91de$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $b704803901ba91de$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $b704803901ba91de$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b704803901ba91de$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b704803901ba91de$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $3duP9.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $3duP9.default)('long', date, options);
        }
    }
};
function $b704803901ba91de$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $5joVX.default)(timeZone, originalDate, true) / $b704803901ba91de$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $b704803901ba91de$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $b704803901ba91de$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $b704803901ba91de$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $b704803901ba91de$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $b704803901ba91de$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $b704803901ba91de$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $b704803901ba91de$var$formatTimezone(offset, dirtyDelimeter);
}
function $b704803901ba91de$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $b704803901ba91de$var$addLeadingZeros(minutes, 2);
}
var $b704803901ba91de$export$2e2bcd8739ae039 = $b704803901ba91de$var$formatters;

});
parcelRegister("3duP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $257a7efc9a6a7864$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $257a7efc9a6a7864$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $257a7efc9a6a7864$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $257a7efc9a6a7864$var$partsTimeZone(dtf, date) : $257a7efc9a6a7864$var$hackyTimeZone(dtf, date);
}
function $257a7efc9a6a7864$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $257a7efc9a6a7864$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $257a7efc9a6a7864$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("5joVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de211721fa9aed9$export$2e2bcd8739ae039);

var $fu1or = parcelRequire("fu1or");

var $469iB = parcelRequire("469iB");
var $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR = 3600000;
var $3de211721fa9aed9$var$MILLISECONDS_IN_MINUTE = 60000;
var $3de211721fa9aed9$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $3de211721fa9aed9$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $3de211721fa9aed9$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $3de211721fa9aed9$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$3de211721fa9aed9$var$validateTimezone(hours)) return NaN;
        return -(hours * $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $3de211721fa9aed9$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$3de211721fa9aed9$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $3de211721fa9aed9$var$MILLISECONDS_IN_HOUR + minutes * $3de211721fa9aed9$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($3de211721fa9aed9$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $3de211721fa9aed9$var$toUtcDate(date);
        var offset = $3de211721fa9aed9$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $3de211721fa9aed9$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $3de211721fa9aed9$var$toUtcDate(date) {
    return (0, $469iB.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $3de211721fa9aed9$var$calcOffset(date, timezoneString) {
    var tokens = (0, $fu1or.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $469iB.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $3de211721fa9aed9$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $3de211721fa9aed9$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $3de211721fa9aed9$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $3de211721fa9aed9$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $3de211721fa9aed9$var$validIANATimezoneCache = {};
function $3de211721fa9aed9$var$isValidTimezoneIANAString(timeZoneString) {
    if ($3de211721fa9aed9$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $3de211721fa9aed9$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("fu1or", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45abcffef27852f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $b45abcffef27852f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $b45abcffef27852f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $b45abcffef27852f$var$partsOffset(dtf, date) : $b45abcffef27852f$var$hackyOffset(dtf, date);
}
var $b45abcffef27852f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $b45abcffef27852f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $b45abcffef27852f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $b45abcffef27852f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $b45abcffef27852f$var$dtfCache = {};
function $b45abcffef27852f$var$getDateTimeFormat(timeZone) {
    if (!$b45abcffef27852f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $b45abcffef27852f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $b45abcffef27852f$var$dtfCache[timeZone];
}

});

parcelRegister("469iB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbeef8f33537542$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $2fbeef8f33537542$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("MQM8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $092d6be9aa48deb7$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $5joVX = parcelRequire("5joVX");

var $cK6LU = parcelRequire("cK6LU");
var $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR = 3600000;
var $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE = 60000;
var $092d6be9aa48deb7$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $092d6be9aa48deb7$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cK6LU.default)
};
function $092d6be9aa48deb7$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $092d6be9aa48deb7$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $092d6be9aa48deb7$var$splitDateString(argument);
    var parseYearResult = $092d6be9aa48deb7$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $092d6be9aa48deb7$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $092d6be9aa48deb7$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $5joVX.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $092d6be9aa48deb7$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $092d6be9aa48deb7$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $092d6be9aa48deb7$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $092d6be9aa48deb7$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $092d6be9aa48deb7$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $092d6be9aa48deb7$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $092d6be9aa48deb7$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $092d6be9aa48deb7$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $092d6be9aa48deb7$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $092d6be9aa48deb7$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $092d6be9aa48deb7$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $092d6be9aa48deb7$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$092d6be9aa48deb7$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $092d6be9aa48deb7$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$092d6be9aa48deb7$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $092d6be9aa48deb7$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateWeekDate(year, week)) return new Date(NaN);
        return $092d6be9aa48deb7$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $092d6be9aa48deb7$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$092d6be9aa48deb7$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $092d6be9aa48deb7$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $092d6be9aa48deb7$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $092d6be9aa48deb7$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $092d6be9aa48deb7$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR + minutes * $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $092d6be9aa48deb7$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$092d6be9aa48deb7$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $092d6be9aa48deb7$var$MILLISECONDS_IN_HOUR + minutes * $092d6be9aa48deb7$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $092d6be9aa48deb7$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $092d6be9aa48deb7$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $092d6be9aa48deb7$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $092d6be9aa48deb7$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $092d6be9aa48deb7$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $092d6be9aa48deb7$var$isLeapYearIndex(year);
        if (isLeapYear && date > $092d6be9aa48deb7$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $092d6be9aa48deb7$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $092d6be9aa48deb7$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $092d6be9aa48deb7$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $092d6be9aa48deb7$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $092d6be9aa48deb7$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cK6LU", function(module, exports) {

$parcel$export(module.exports, "default", () => $946f08a27a12da04$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $946f08a27a12da04$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $946f08a27a12da04$export$2e2bcd8739ae039 = $946f08a27a12da04$var$tzPattern;

});



parcelRegister("iPYJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $db6c190bd1e807d1$export$2e2bcd8739ae039);

var $5joVX = parcelRequire("5joVX");

var $MQM8H = parcelRequire("MQM8H");
function $db6c190bd1e807d1$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $MQM8H.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $5joVX.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("6uyUT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ab452e3339485e67$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $fM5iV = parcelRequire("fM5iV");
var $1n3pn = parcelRequire("1n3pn");
var $920hm = parcelRequire("920hm");

var $3vXh8 = parcelRequire("3vXh8");

var $4x5z4 = parcelRequire("4x5z4");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $dDnjt = parcelRequire("dDnjt");

var $kCTG1 = parcelRequire("kCTG1");

var $1Z0pV = parcelRequire("1Z0pV");

var $2TnXV = parcelRequire("2TnXV");

var $1c2zu = parcelRequire("1c2zu");

var $iRjU7 = parcelRequire("iRjU7");
const $ab452e3339485e67$var$styles = (0, $1ZAYh.xcss)({
    paddingBlockStart: 'space.400',
    paddingInline: 'space.200'
});
const $ab452e3339485e67$var$avatarStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.300',
    left: 'space.200'
});
const $ab452e3339485e67$var$cardContainerStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    position: 'relative'
});
const $ab452e3339485e67$var$AgentProfileCard = ({ agent: agent, isLoading: isLoading, isCreatedByViewingUser: isCreatedByViewingUser, cloudId: cloudId, onOpenChat: onOpenChat, product: product = 'rovo', hasError: hasError, errorType: errorType })=>{
    const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onOpenChat: onOpenChatFullScreecn, onConversationStarter: onConversationStarter } = (0, $2TnXV.useAgentUrlActions)({
        cloudId: cloudId || ''
    });
    const { isStarred: isStarred, setFavourite: setFavourite } = (0, $iRjU7.useSetFavouriteAgent)({
        agentId: agent?.id,
        cloudId: cloudId,
        isStarred: !!agent?.favourite,
        product: product
    });
    const { deleteAgent: deleteAgent } = (0, $1c2zu.useDeleteAgent)({
        cloudId: cloudId,
        product: product
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const handleOnDelete = async ()=>{
        if (agent) await deleteAgent(agent.id);
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoading && agent) fireAnalytics((0, $3vXh8.profileCardRendered)('agent', 'content'));
    }, [
        agent,
        fireAnalytics,
        isLoading
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4x5z4.default), {
        profileType: "agent",
        fireAnalytics: fireAnalytics
    }));
    if (hasError || !agent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        errorType: errorType,
        fireAnalytics: fireAnalytics
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ab452e3339485e67$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.AgentBanner), {
        height: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ab452e3339485e67$var$avatarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fM5iV.AgentAvatar), {
        size: "xlarge"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        xcss: $ab452e3339485e67$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileInfo), {
        agentName: agent.name,
        isStarred: isStarred,
        onStarToggle: setFavourite,
        isHidden: agent.visibility === 'PRIVATE',
        creatorRender: agent.creatorInfo?.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileCreator), {
            creator: {
                type: agent.creatorInfo?.type,
                name: agent.creatorInfo?.name || '',
                profileLink: agent.creatorInfo?.profileLink || ''
            },
            isLoading: false,
            onCreatorLinkClick: ()=>{}
        }),
        starCountRender: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentStarCount), {
            starCount: agent.favourite_count,
            isLoading: false
        }),
        agentDescription: agent.description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Z0pV.ConversationStarters), {
        isAgentDefault: agent.is_default,
        userDefinedConversationStarters: agent.user_defined_conversation_starters,
        onConversationStarterClick: (conversationStarter)=>{
            onConversationStarter({
                agentId: agent.id,
                prompt: 'conversationStarter'
            });
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDnjt.AgentActions), {
        isAgentCreatedByCurrentUser: isCreatedByViewingUser,
        onEditAgent: ()=>onEditAgent(agent.id),
        onCopyAgent: ()=>onCopyAgent(agent.id),
        onDuplicateAgent: ()=>onDuplicateAgent(agent.id),
        onDeleteAgent: handleOnDelete,
        onChatClick: ()=>onOpenChat ? onOpenChat(agent.id) : onOpenChatFullScreecn()
    })));
};
var $ab452e3339485e67$export$2e2bcd8739ae039 = $ab452e3339485e67$var$AgentProfileCard;

});
parcelRegister("fM5iV", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $c46244c3a4e4701a$export$38b71b080e1832c8);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1n3pn = parcelRequire("1n3pn");
/**
 * This solution has been derived from this codepen: https://codepen.io/anyen-ltovn/pen/qBYYzea
 */ const $c46244c3a4e4701a$var$agentAvatarStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
});
const $c46244c3a4e4701a$var$innerShapeStyles = (0, $1ZAYh.xcss)({
    height: '95%',
    width: '95%',
    clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
});
const $c46244c3a4e4701a$var$imageStyles = (0, $1ZAYh.xcss)({
    objectFit: 'cover',
    height: '100%',
    width: '100%'
});
const $c46244c3a4e4701a$var$avatarContentContainer = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $c46244c3a4e4701a$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentNamedId: agentNamedId, showBorder: showBorder = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        "aria-label": label,
        xcss: $c46244c3a4e4701a$var$agentAvatarStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $eri7S.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $eri7S.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c46244c3a4e4701a$var$innerShapeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c46244c3a4e4701a$var$avatarContentContainer
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "img",
        xcss: $c46244c3a4e4701a$var$imageStyles,
        src: imageUrl,
        alt: name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.GeneratedAvatar), {
        agentId: agentId,
        agentNamedId: agentNamedId,
        size: size
    }))));
};

});
parcelRegister("1n3pn", function(module, exports) {

$parcel$export(module.exports, "AgentBanner", () => $301f5eef7defe046$export$6efaefb8ad2fba40);
$parcel$export(module.exports, "GeneratedAvatar", () => $301f5eef7defe046$export$96bb253b7de22616);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5TKhN = parcelRequire("5TKhN");

var $gintv = parcelRequire("gintv");

var $dLzpK = parcelRequire("dLzpK");

var $4MSOB = parcelRequire("4MSOB");

var $7bSsT = parcelRequire("7bSsT");

var $7NM53 = parcelRequire("7NM53");

var $19LR2 = parcelRequire("19LR2");

var $a4vlK = parcelRequire("a4vlK");

var $6Je5I = parcelRequire("6Je5I");

var $fksEs = parcelRequire("fksEs");

var $fGiBX = parcelRequire("fGiBX");

var $54k0x = parcelRequire("54k0x");

var $bTTug = parcelRequire("bTTug");

var $8zvm7 = parcelRequire("8zvm7");

var $8zaiw = parcelRequire("8zaiw");

var $3oTAZ = parcelRequire("3oTAZ");

var $3ptGp = parcelRequire("3ptGp");

var $7zNkv = parcelRequire("7zNkv");

var $lLzmU = parcelRequire("lLzmU");

var $89yuV = parcelRequire("89yuV");

var $pHJ36 = parcelRequire("pHJ36");
const $301f5eef7defe046$var$yellowColor = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $301f5eef7defe046$var$purpleColor = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $301f5eef7defe046$var$greenColor = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $301f5eef7defe046$var$blueColor = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $301f5eef7defe046$var$colorList = [
    $301f5eef7defe046$var$yellowColor,
    $301f5eef7defe046$var$purpleColor,
    $301f5eef7defe046$var$greenColor,
    $301f5eef7defe046$var$blueColor
];
const $301f5eef7defe046$var$avatarList = [
    (0, $19LR2.CustomerInsightAvatar),
    (0, $4MSOB.BacklogBuddyAvatar),
    (0, $a4vlK.DecisionDirectorAvatar),
    (0, $7bSsT.CommsCrafterAvatar),
    (0, $5TKhN.AutoDevAvatar),
    (0, $8zvm7.OkrOracleAvatar),
    (0, $7NM53.CultureAvatar),
    (0, $89yuV.SocialMediaScribeAvatar),
    (0, $pHJ36.TeamConnectionAvatar),
    (0, $fGiBX.HireWriterAvatar),
    (0, $8zaiw.OpsAgentAvatar),
    (0, $lLzmU.ResearchScoutAvatar),
    (0, $7zNkv.ReleaseNotesAvatar),
    (0, $bTTug.MyUserManualAvatar),
    (0, $3oTAZ.PitchPerfectorAvatar),
    (0, $5TKhN.AutoDevAvatar),
    (0, $gintv.AutoFixAvatar),
    (0, $dLzpK.AutoReviewAvatar),
    (0, $54k0x.MarketingMessageMaestroAvatar),
    (0, $6Je5I.FeatureFlagAvatar),
    (0, $3ptGp.ProductRequirementAvatar)
];
const $301f5eef7defe046$export$a834793a4d0d739e = $301f5eef7defe046$var$avatarList.length * $301f5eef7defe046$var$colorList.length;
const $301f5eef7defe046$var$imageStyles = (0, $1ZAYh.xcss)({
    objectFit: 'cover',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $301f5eef7defe046$var$outOfTheBoxAgentAvatar = {
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4vlK.DecisionDirectorAvatar), {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$greenColor.primary,
                secondaryColor: $301f5eef7defe046$var$greenColor.secondary
            }),
        color: $301f5eef7defe046$var$greenColor
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTTug.MyUserManualAvatar), {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$yellowColor.primary,
                secondaryColor: $301f5eef7defe046$var$yellowColor.secondary
            }),
        color: $301f5eef7defe046$var$yellowColor
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ptGp.ProductRequirementAvatar), {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$yellowColor.primary,
                secondaryColor: $301f5eef7defe046$var$yellowColor.secondary
            }),
        color: $301f5eef7defe046$var$yellowColor
    }
};
const $301f5eef7defe046$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, size: size })=>{
    if (typeof agentNamedId === 'string' && $301f5eef7defe046$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $301f5eef7defe046$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    if (agentId) {
        // Take the last 8 characters of the agentId because JS can't handle 16 digit numbers
        const agentIdSubset = agentId.slice(-8).replace(/-/g, '');
        let agentIdNumber = parseInt(agentIdSubset, 16);
        if (isNaN(agentIdNumber)) agentIdNumber = 0;
        /**
		 * this create all possible combinations of avatars and colors
		 * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
		 * then choose 1 based on agentId
		 */ const totalCombinations = $301f5eef7defe046$var$avatarList.length * $301f5eef7defe046$var$colorList.length;
        const combinationIndex = agentIdNumber % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $301f5eef7defe046$var$colorList.length);
        const colorIndex = combinationIndex % $301f5eef7defe046$var$colorList.length;
        const Avatar = $301f5eef7defe046$var$avatarList[avatarIndex];
        const color = $301f5eef7defe046$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fksEs.GenericAvatar), {
            size: (0, $eri7S.AVATAR_SIZES)[size],
            primaryColor: $301f5eef7defe046$var$blueColor.primary,
            secondaryColor: $301f5eef7defe046$var$blueColor.secondary
        }),
        color: $301f5eef7defe046$var$blueColor
    };
};
const $301f5eef7defe046$var$bannerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $301f5eef7defe046$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, height: height })=>{
    const { color: color } = $301f5eef7defe046$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $301f5eef7defe046$var$bannerStyles,
        style: {
            backgroundColor: color.primary,
            height: `${height}px`
        }
    });
};
const $301f5eef7defe046$export$96bb253b7de22616 = ({ agentNamedId: agentNamedId, agentId: agentId, size: size })=>{
    const { render: render, color: color } = $301f5eef7defe046$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        size: size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $301f5eef7defe046$var$imageStyles,
        style: {
            backgroundColor: color.primary
        }
    }, render);
};

});
parcelRegister("5TKhN", function(module, exports) {

$parcel$export(module.exports, "AutoDevAvatar", () => $3444d93806696fba$export$924fd2eb3b80e770);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $3444d93806696fba$export$924fd2eb3b80e770 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38723",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38723)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.1825 42.0567C27.4637 41.2946 26.8066 40.3889 26.0573 39.5292L26.41 39.6078C26.6455 39.6557 26.8801 39.717 27.116 39.7836L27.3024 39.8348L27.4918 39.8679L27.876 39.9295C28.0059 39.9463 28.1355 39.9698 28.2648 39.9713C28.3959 39.9714 28.5274 39.9647 28.6592 39.9547C28.6403 39.8853 28.6692 39.8293 28.7039 39.8633L28.7015 39.9507C28.8733 39.8943 29.0302 39.8852 29.1782 39.8583C29.3245 39.833 29.4631 39.8203 29.602 39.8043C29.7393 39.7865 29.8765 39.772 30.0076 39.7214C30.1389 39.6676 30.2685 39.5899 30.3972 39.4751C30.3972 39.4751 30.3617 39.6029 30.3615 39.6063C31.399 39.297 32.5486 38.7195 33.509 37.878C34.4804 37.0494 35.2286 35.9634 35.6719 34.9133L35.6548 34.9183L35.6455 34.9072C35.6027 34.9433 35.5384 35.026 35.4613 35.1225C35.3794 35.2169 35.2845 35.3285 35.1968 35.4341C35.1106 35.5415 35.0282 35.6426 34.9677 35.7189C34.9055 35.7935 34.8623 35.8362 34.8623 35.8362C34.8847 35.6277 34.9215 35.4292 35.007 35.256C35.0876 35.0806 35.2007 34.922 35.3061 34.7541C35.4163 34.5885 35.5415 34.4261 35.6519 34.2571C35.7526 34.0838 35.8486 33.9049 35.9148 33.7195L36.0176 33.7655C35.8886 34.086 35.8359 34.3959 35.8172 34.5254C36.1337 33.99 36.5204 33.1077 36.6709 32.1623C36.838 31.2219 36.8003 30.252 36.6576 29.6456C36.5746 29.6808 36.7833 30.0547 36.5128 30.1533C36.4913 29.8459 36.4445 29.5409 36.3929 29.2558C36.5723 29.2372 36.5371 29.4123 36.5738 29.4414C36.5883 29.3754 36.5811 29.1572 36.5545 28.8257C36.5454 28.6595 36.4958 28.4706 36.4563 28.2575C36.4332 28.1506 36.4121 28.0388 36.3863 27.9215C36.3554 27.8054 36.3145 27.6882 36.2759 27.5628C36.1965 27.3169 36.1185 27.0509 35.9879 26.7913C35.8676 26.5294 35.75 26.2525 35.5807 25.994C35.5004 25.8626 35.4201 25.7312 35.3383 25.598C35.2582 25.4633 35.1516 25.3478 35.0591 25.2236C34.9614 25.1006 34.8671 24.9778 34.771 24.8566C34.6713 24.7384 34.5574 24.6323 34.4504 24.5235C33.5943 23.6528 32.6226 23.0787 32.0206 22.8816C31.4184 22.6626 31.2239 22.7066 31.6728 23.1559L31.58 23.2121C31.709 23.2928 31.8334 23.368 31.956 23.4448C32.0771 23.5197 32.1946 23.5975 32.2991 23.6926C32.5101 23.8813 32.7297 24.0659 32.9188 24.3299C32.9949 24.3731 32.9917 24.3947 33.0472 24.3195C33.0739 24.3222 33.1206 24.3271 33.1349 24.2898C33.2614 24.1073 33.3641 24.305 33.4364 24.3547C33.3042 24.4725 33.3302 24.6117 33.4416 24.7548C33.5511 24.9026 33.7242 25.0789 33.9335 25.2405C33.9863 25.2814 34.039 25.3222 34.0951 25.3634C34.1442 25.4073 34.195 25.453 34.2424 25.4983C34.3441 25.5864 34.4393 25.6704 34.5265 25.7485C34.7098 25.8973 34.8315 26.038 34.8627 26.1002C34.7375 26.212 34.8038 26.3268 34.8988 26.4394C34.9938 26.5521 35.1204 26.6697 35.0881 26.7759C35.0716 26.7709 34.9761 26.7407 34.9594 26.739C34.9287 26.7965 35.0005 26.954 35.1184 27.1516C35.1738 27.2534 35.2559 27.358 35.3133 27.4803C35.3758 27.6014 35.4398 27.7243 35.5008 27.8436C35.6347 28.0783 35.71 28.3086 35.7369 28.4344C35.7636 28.5636 35.7282 28.5903 35.588 28.4494C35.581 28.629 35.6061 28.807 35.5967 28.9982C35.5924 29.1883 35.5946 29.3824 35.6032 29.5805C35.5866 29.98 35.5904 30.4002 35.5461 30.8356C35.4762 31.7068 35.3111 32.6423 34.9972 33.5421C34.685 34.4405 34.2226 35.298 33.649 35.984C33.4985 36.1488 33.3625 36.3236 33.2017 36.4655C33.041 36.6073 32.8854 36.748 32.7257 36.8732C32.5568 36.9872 32.39 37.0931 32.2288 37.1911C32.0661 37.2872 31.8872 37.3497 31.7264 37.4157L31.7669 37.4384C31.7416 37.4408 31.6959 37.4951 31.6561 37.4623C31.5877 37.6053 31.3922 37.7638 31.223 37.9065C31.1378 37.9753 31.0578 38.0395 30.9962 38.082C30.9332 38.1193 30.8946 38.1423 30.8946 38.1423L30.5607 38.3607L30.3904 38.4696L30.2112 38.5606C30.2112 38.5606 30.1244 38.577 29.99 38.6019C29.8553 38.6301 29.669 38.6766 29.4625 38.6991C29.359 38.7137 29.2534 38.7332 29.1477 38.7559C29.042 38.7787 28.9376 38.8068 28.8343 38.818C28.6287 38.8524 28.4404 38.9038 28.3008 38.9804C28.1223 38.9856 27.9436 38.9435 27.7664 38.9286C27.5884 38.9017 27.4103 38.9002 27.2356 38.8485C26.9908 38.7895 26.0919 38.6595 25.4612 38.5404C25.8807 37.9717 27.4374 37.3385 27.57 36.7621L28.3342 36.4179C28.7605 36.1501 28.5417 35.0485 27.8834 35.493C26.7498 36.3099 24.9778 36.8215 24.2746 38.2645L24.2881 38.2624C24.2881 38.2624 24.0737 38.5286 24.0564 38.4863C23.9855 38.6662 23.9727 38.9329 23.9727 38.9329C24.1136 39.5914 25.0757 40.3601 25.5582 40.4589C25.4193 40.5254 28.2934 43.2146 28.181 42.0549L28.1825 42.0567Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.0077 6.00108C17.6634 6.93211 18.2306 8.00818 18.9041 9.04887L18.5367 8.90986C18.2907 8.82193 18.0478 8.71975 17.8043 8.61175L17.6115 8.52777L17.4128 8.46294L17.009 8.33736C16.8718 8.29921 16.736 8.25395 16.5971 8.23231C16.4561 8.212 16.3135 8.19884 16.1702 8.18924C16.1798 8.26682 16.14 8.32261 16.1079 8.28074L16.1241 8.18706C15.9304 8.22124 15.7602 8.20679 15.5968 8.21283C15.4355 8.21753 15.2844 8.20974 15.1325 8.20551C14.9819 8.20351 14.8321 8.19792 14.6833 8.23204C14.5336 8.26972 14.3822 8.33327 14.226 8.43696C14.226 8.43696 14.2839 8.30486 14.2846 8.30129C13.1205 8.47383 11.7944 8.91777 10.631 9.67493C9.45782 10.4165 8.48502 11.4695 7.84587 12.5309L7.86508 12.5282L7.8734 12.5415C7.92496 12.5093 8.00699 12.4303 8.1048 12.3383C8.20754 12.2494 8.32684 12.144 8.43754 12.0439C8.54686 11.9416 8.65111 11.8456 8.72807 11.7728C8.80642 11.7022 8.85952 11.6629 8.85952 11.6629C8.8033 11.8837 8.73305 12.0917 8.61426 12.2649C8.5004 12.4412 8.3542 12.5944 8.21493 12.7587C8.07074 12.9199 7.911 13.0753 7.76605 13.24C7.63096 13.411 7.50004 13.5887 7.40021 13.7779L7.29671 13.7126C7.48499 13.3876 7.58946 13.0624 7.62964 12.9259C7.20643 13.4531 6.65411 14.3428 6.34608 15.3368C6.02111 16.3228 5.91189 17.3722 5.97174 18.0468C6.06652 18.0217 5.89975 17.5871 6.20598 17.5229C6.18162 17.857 6.18496 18.1923 6.19636 18.5072C6.00046 18.4994 6.0654 18.3165 6.03039 18.2795C6.00461 18.3482 5.97872 18.5842 5.95614 18.945C5.94023 19.1251 5.9644 19.336 5.97403 19.5715C5.98238 19.6901 5.98783 19.8136 5.99744 19.9438C6.01275 20.0736 6.03866 20.2059 6.06092 20.3468C6.10834 20.6237 6.15121 20.9219 6.25159 21.2215C6.34059 21.5219 6.42443 21.838 6.56665 22.1423C6.63276 22.2961 6.69886 22.4498 6.76637 22.6058C6.83172 22.7631 6.92854 22.9038 7.00894 23.0518C7.09502 23.1992 7.17759 23.3459 7.26228 23.4911C7.35127 23.6337 7.45743 23.7655 7.55577 23.8991C8.3425 24.9682 9.29943 25.736 9.91673 26.041C10.5309 26.3696 10.747 26.3523 10.3333 25.7996L10.4418 25.7535C10.3155 25.6466 10.1932 25.5465 10.0732 25.445C9.95447 25.3457 9.84009 25.2438 9.74225 25.1253C9.54444 24.8897 9.33661 24.6572 9.17392 24.344C9.09872 24.2857 9.10544 24.263 9.03417 24.3353C9.00586 24.3282 8.95629 24.3158 8.93519 24.3537C8.77091 24.5305 8.69088 24.3019 8.62073 24.2373C8.78123 24.131 8.77476 23.9771 8.67693 23.806C8.58199 23.63 8.423 23.4136 8.22266 23.2074C8.17222 23.1553 8.12178 23.1032 8.06781 23.0502C8.02167 22.9954 7.97414 22.9384 7.93015 22.8823C7.83434 22.7718 7.74484 22.6667 7.66306 22.5692C7.48876 22.3808 7.37954 22.2106 7.35565 22.1389C7.50755 22.0379 7.45396 21.9042 7.36915 21.7683C7.28433 21.6324 7.16626 21.4863 7.21744 21.377C7.23437 21.385 7.33248 21.4321 7.35017 21.4366C7.39213 21.3794 7.33916 21.1989 7.24283 20.9681C7.19896 20.8499 7.12678 20.7247 7.08392 20.5843C7.03537 20.4444 6.98542 20.3022 6.93826 20.1644C6.83043 19.8912 6.7849 19.6318 6.77541 19.4922C6.76668 19.3491 6.8089 19.3259 6.93796 19.4991C6.9732 19.3069 6.97368 19.1116 7.01335 18.9073C7.04733 18.7034 7.07497 18.4942 7.09631 18.2797C7.17589 17.8523 7.23666 17.3997 7.3515 16.9379C7.56134 16.0114 7.88338 15.0303 8.36015 14.1105C8.83476 13.1921 9.46472 12.3407 10.1878 11.6913C10.3753 11.5371 10.5486 11.3701 10.7435 11.2422C10.9384 11.1144 11.1276 10.987 11.3186 10.877C11.5181 10.7804 11.7138 10.6923 11.9024 10.6117C12.0924 10.5334 12.2945 10.4938 12.4777 10.4476L12.4376 10.4169C12.4653 10.4182 12.5228 10.3669 12.5606 10.4083C12.6562 10.265 12.8911 10.1246 13.0952 9.99721C13.1975 9.93641 13.2935 9.87964 13.3664 9.84341C13.4399 9.81298 13.4849 9.7942 13.4849 9.7942L13.878 9.61076L14.078 9.51991L14.2849 9.44963C14.2849 9.44963 14.3808 9.44546 14.5293 9.43944C14.6786 9.42985 14.8862 9.40854 15.112 9.41623C15.2256 9.41651 15.3421 9.41191 15.4594 9.4037C15.5767 9.3955 15.6933 9.38148 15.8062 9.38532C16.0328 9.38008 16.2433 9.35388 16.4054 9.29299C16.5982 9.31499 16.784 9.38787 16.9724 9.43129C17.1598 9.48764 17.3511 9.51676 17.5311 9.59944C17.7854 9.70073 18.7326 9.9794 19.3929 10.2049C18.8536 10.752 17.0809 11.193 16.8491 11.7927L15.9736 12.0451C15.4736 12.2675 15.5389 13.4866 16.3159 13.1099C17.6618 12.406 19.6476 12.1292 20.627 10.6851L20.6121 10.6852C20.6121 10.6852 20.884 10.4319 20.8961 10.48C21.0001 10.2975 21.0551 10.0125 21.0551 10.0125C21.0052 9.2821 20.0887 8.30642 19.5847 8.12568C19.7445 8.07549 17.0672 4.7381 17.009 6.00331L17.0077 6.00108Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7263 17.4769H19.2806L20.7156 21.3007L24.745 20.6313L27.0244 24.5776L24.43 27.7319L27.0244 30.8863L24.745 34.8326L20.7156 34.1632L19.2806 37.9869H14.7263L13.2913 34.1632L9.26189 34.8326L6.98251 30.8863L9.57689 27.7319L6.98251 24.5776L9.26189 20.6313L13.2913 21.3007L14.7263 17.4769ZM17.0056 31.5732C19.1275 31.5732 20.8513 29.8538 20.8513 27.7276C20.8513 25.6013 19.1319 23.8819 17.0056 23.8819C14.8794 23.8819 13.16 25.6013 13.16 27.7276C13.16 29.8538 14.8794 31.5732 17.0056 31.5732Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.41 10.0875H28.9669L30.0869 13.0713L33.2281 12.5463L35.0044 15.6263L32.9787 18.0894L35.0044 20.5482L33.2281 23.6282L30.0869 23.1075L28.9669 26.0913H25.41L24.29 23.1075L21.1487 23.6282L19.3725 20.5482L21.3981 18.0894L19.3725 15.6307L21.1487 12.5506L24.29 13.0756L25.41 10.0919V10.0875ZM27.1862 21.0906C28.8444 21.0906 30.1875 19.7475 30.1875 18.0894C30.1875 16.4313 28.8444 15.0881 27.1862 15.0881C25.5281 15.0881 24.185 16.4313 24.185 18.0894C24.185 19.7475 25.5281 21.0906 27.1862 21.0906Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.7406 20.6269L20.7113 21.3007L20.0988 19.66L19.3681 20.5482L21.1488 23.6282L24.29 23.1032L25.41 26.0869H25.7731L27.02 24.5732L24.7406 20.6269Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.7406 20.6269L20.7113 21.3007L20.0988 19.66L19.3681 20.5482L21.1488 23.6282L24.29 23.1032L25.41 26.0869H25.7731L27.02 24.5732L24.7406 20.6269Z",
        fill: primaryColor
    }));

});

parcelRegister("gintv", function(module, exports) {

$parcel$export(module.exports, "AutoFixAvatar", () => $bc38cce80b930a55$export$e83caff46c768c68);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $bc38cce80b930a55$export$e83caff46c768c68 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38827",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38827)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.4348 41.2002C22.0455 40.0423 21.7917 38.7624 21.4178 37.4864L21.7529 37.7418C21.9789 37.9074 22.1974 38.0868 22.4147 38.2724L22.5872 38.4177L22.7716 38.5452L23.1484 38.7978C23.2778 38.8791 23.4035 38.9671 23.5397 39.0319C23.6785 39.0959 23.821 39.1531 23.9654 39.2068C23.9793 39.1241 24.0373 39.0789 24.0575 39.1318L24.0122 39.2232C24.2217 39.2473 24.3923 39.3142 24.5622 39.358C24.7294 39.4025 24.8824 39.4568 25.0373 39.5076C25.1915 39.5558 25.3438 39.6073 25.5073 39.6178C25.6726 39.6249 25.8477 39.6059 26.0401 39.5471C26.0401 39.5471 25.9402 39.6652 25.9383 39.6686C27.1879 39.8475 28.6872 39.7969 30.115 39.3744C31.5481 38.971 32.8704 38.1861 33.8523 37.2905L33.8318 37.2874L33.8273 37.2711C33.7644 37.2884 33.6559 37.3446 33.5272 37.4093C33.3944 37.4692 33.2395 37.5411 33.095 37.6101C32.9513 37.6818 32.8148 37.7486 32.7134 37.7999C32.6112 37.8485 32.5446 37.8727 32.5446 37.8727C32.67 37.6628 32.8058 37.4706 32.9809 37.3289C33.152 37.1824 33.3491 37.0697 33.5426 36.9434C33.7402 36.8218 33.952 36.7109 34.1514 36.5858C34.3426 36.4514 34.5316 36.3088 34.6921 36.1448L34.7785 36.2437C34.4855 36.5201 34.2786 36.8225 34.1955 36.9506C34.792 36.538 35.6321 35.7924 36.2529 34.8647C36.8888 33.9504 37.3222 32.9049 37.4671 32.193C37.362 32.1898 37.4004 32.6877 37.066 32.66C37.1932 32.324 37.2924 31.9782 37.377 31.651C37.5761 31.7189 37.4533 31.8872 37.478 31.9359C37.5255 31.8731 37.6243 31.6385 37.758 31.2744C37.8295 31.0941 37.8692 30.8698 37.9313 30.6248C37.959 30.5003 37.9912 30.3717 38.0212 30.2349C38.0451 30.0968 38.059 29.9528 38.0792 29.8011C38.1152 29.502 38.1624 29.1822 38.1509 28.8435C38.1513 28.5074 38.1618 28.1568 38.1087 27.8004C38.0878 27.6221 38.0669 27.4438 38.0452 27.2628C38.0262 27.0811 37.9697 26.9067 37.9323 26.73C37.889 26.5521 37.8489 26.376 37.8063 26.2008C37.7584 26.027 37.6896 25.859 37.6294 25.6915C37.1477 24.3516 36.3989 23.2694 35.8575 22.767C35.3267 22.2412 35.0992 22.1928 35.3554 22.8877L35.2297 22.9019C35.3269 23.0504 35.422 23.1907 35.5143 23.3318C35.606 23.4702 35.6924 23.61 35.7567 23.7618C35.888 24.0645 36.0305 24.3672 36.1019 24.739C36.1614 24.8219 36.1475 24.8432 36.243 24.7907C36.2699 24.8066 36.317 24.8346 36.3503 24.802C36.5734 24.6705 36.5857 24.9301 36.638 25.0179C36.4405 25.0782 36.4 25.2383 36.4483 25.4441C36.492 25.6541 36.5892 25.9253 36.7321 26.1986C36.768 26.2676 36.8039 26.3366 36.8432 26.4076C36.8739 26.478 36.9053 26.5512 36.9334 26.6224C36.9981 26.7652 37.0579 26.9007 37.1121 27.026C37.2337 27.273 37.2939 27.4814 37.2965 27.5625C37.1094 27.6199 37.1236 27.7737 37.1692 27.9394C37.2149 28.105 37.2915 28.2914 37.2055 28.3881C37.1905 28.3747 37.1041 28.2962 37.0872 28.2862C37.0266 28.3321 37.0258 28.5339 37.0542 28.8007C37.0632 28.9356 37.0991 29.0864 37.1002 29.2439C37.1073 29.4026 37.1151 29.5641 37.1214 29.7201C37.1487 30.034 37.1161 30.3147 37.0831 30.4611C37.0483 30.6109 36.9978 30.6219 36.9181 30.4042C36.8231 30.5911 36.7628 30.7918 36.6595 30.9897C36.5622 31.1889 36.4698 31.3955 36.3822 31.6095C36.1696 32.0245 35.9686 32.4713 35.7092 32.9109C35.21 33.7992 34.5786 34.7094 33.807 35.5091C33.038 36.3081 32.1298 36.9906 31.1876 37.437C30.9478 37.5382 30.7184 37.6569 30.4789 37.7286C30.2395 37.8004 30.006 37.8735 29.7759 37.9281C29.5413 37.9664 29.313 37.9971 29.0945 38.0222C28.8753 38.0446 28.6553 38.0234 28.4528 38.0149L28.4846 38.0587C28.4566 38.0489 28.3817 38.0841 28.3556 38.03C28.2134 38.148 27.929 38.2205 27.6802 38.289C27.5563 38.3202 27.4403 38.3492 27.3543 38.3642C27.2693 38.3729 27.2173 38.3785 27.2173 38.3785L26.7571 38.4468L26.5236 38.479L26.2894 38.4879C26.2894 38.4879 26.1895 38.4629 26.035 38.4236C25.8786 38.3878 25.6586 38.3462 25.4289 38.2692C25.3122 38.2341 25.1909 38.2032 25.0679 38.1757C24.9448 38.1483 24.8206 38.127 24.7057 38.0885C24.4711 38.0246 24.2466 37.9871 24.0614 38.0001C23.8699 37.9184 23.7011 37.7867 23.5208 37.6844C23.3454 37.5691 23.1576 37.4806 22.9978 37.3405C22.7674 37.1586 21.8788 36.5822 21.269 36.1483C21.9908 35.7508 23.9484 35.8399 24.3702 35.2943L25.3475 35.3028C25.9296 35.2272 26.2355 33.9538 25.3214 34.1032C23.7223 34.4151 21.596 34.092 20.1471 35.277L20.1624 35.2814C20.1624 35.2814 19.8055 35.4586 19.8077 35.4054C19.6449 35.5613 19.5012 35.8375 19.5012 35.8375C19.329 36.6037 19.9727 37.8872 20.4355 38.2273C20.2559 38.23 21.9871 42.4805 22.4341 41.1975L22.4348 41.2002Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21.204 3.96983C21.8102 5.11251 22.2958 6.40601 22.9063 7.67481L22.5121 7.46575C22.2475 7.33159 21.9884 7.18179 21.7293 7.02535L21.5241 6.90323L21.3094 6.80183L20.8723 6.60271C20.7231 6.54015 20.5766 6.46979 20.4231 6.42559C20.2671 6.38259 20.1083 6.34742 19.9482 6.31617C19.9479 6.40496 19.8951 6.46214 19.8649 6.41038L19.8965 6.30713C19.6734 6.31803 19.4836 6.27746 19.2986 6.26096C19.1162 6.24325 18.947 6.21291 18.7764 6.18648C18.6071 6.16275 18.4391 6.13509 18.2665 6.1523C18.0925 6.17342 17.9128 6.22343 17.722 6.318C17.722 6.318 17.806 6.1774 17.8074 6.17348C16.471 6.20187 14.9133 6.51298 13.4942 7.20026C12.0665 7.86859 10.82 8.91644 9.94841 10.0213L9.97044 10.021L9.97791 10.0372C10.0406 10.0083 10.1443 9.93096 10.2677 9.84122C10.3961 9.7557 10.5456 9.65392 10.6846 9.55695C10.8224 9.45729 10.9536 9.36393 11.0507 9.29287C11.149 9.22451 11.2145 9.18781 11.2145 9.18781C11.1196 9.42863 11.0108 9.65289 10.8522 9.83113C10.6988 10.0136 10.5122 10.1653 10.3318 10.3306C10.1463 10.4917 9.94415 10.6441 9.75731 10.8091C9.58069 10.9825 9.40782 11.164 9.26833 11.363L9.16102 11.2746C9.41954 10.9353 9.58366 10.5837 9.64841 10.4355C9.09629 10.9694 8.34701 11.8931 7.85811 12.9693C7.35128 14.034 7.07851 15.2011 7.04972 15.9698C7.16012 15.955 7.03417 15.4415 7.38841 15.4128C7.31332 15.7858 7.26924 16.1642 7.23719 16.5205C7.01754 16.4839 7.11681 16.287 7.08263 16.2404C7.04378 16.3141 6.98096 16.5763 6.90404 16.9796C6.86042 17.1804 6.85757 17.4215 6.83484 17.6882C6.82733 17.8231 6.81585 17.963 6.80812 18.1111C6.80686 18.2595 6.81718 18.4124 6.82216 18.5743C6.83611 18.8931 6.84188 19.2353 6.91227 19.5871C6.96972 19.9384 7.01911 20.3065 7.13595 20.6697C7.18853 20.8524 7.24109 21.0351 7.29491 21.2205C7.34612 21.4071 7.43514 21.5795 7.50464 21.7577C7.58061 21.9361 7.65274 22.1131 7.72746 22.2889C7.8074 22.4622 7.90824 22.6259 7.99999 22.7905C8.73405 24.1075 9.70288 25.1092 10.355 25.5409C11.0002 25.9988 11.2462 26.0102 10.8588 25.3283L10.9877 25.2918C10.8606 25.1534 10.7371 25.0231 10.6163 24.8916C10.4967 24.7628 10.3823 24.6316 10.289 24.4842C10.0997 24.1905 9.89865 23.8988 9.76 23.5226C9.68357 23.4462 9.69438 23.4216 9.60375 23.4929C9.57286 23.4809 9.51878 23.4598 9.48959 23.4995C9.27924 23.6754 9.22167 23.4063 9.15183 23.3236C9.34786 23.2266 9.36252 23.0523 9.27667 22.8455C9.1948 22.6337 9.04651 22.3671 8.85015 22.1062C8.80075 22.0403 8.75134 21.9743 8.69808 21.9069C8.65391 21.8386 8.60847 21.7676 8.56691 21.6981C8.4747 21.5599 8.38884 21.4287 8.31059 21.3071C8.14104 21.07 8.04224 20.8627 8.02555 20.7784C8.21114 20.6862 8.16982 20.5279 8.09362 20.3627C8.01742 20.1975 7.90522 20.016 7.97848 19.9001C7.99642 19.9115 8.10025 19.9787 8.11956 19.9862C8.17499 19.9278 8.14104 19.7168 8.06542 19.4429C8.03283 19.3036 7.96935 19.1522 7.94108 18.9879C7.90634 18.8232 7.87033 18.6559 7.83683 18.4939C7.75428 18.1707 7.73999 17.8718 7.7492 17.7132C7.75978 17.5506 7.81067 17.5305 7.93139 17.7442C7.99852 17.5325 8.02693 17.3125 8.10077 17.0879C8.16813 16.8631 8.22912 16.6313 8.28377 16.3926C8.4344 15.9224 8.56745 15.4209 8.76271 14.917C9.13133 13.9029 9.63418 12.8432 10.3026 11.8747C10.9685 10.9074 11.7998 10.0379 12.7073 9.4092C12.9405 9.26225 13.1597 9.09873 13.3975 8.98247C13.6353 8.86622 13.8667 8.74966 14.0977 8.65297C14.3362 8.57254 14.5694 8.50115 14.7934 8.43728C15.0186 8.37611 15.2521 8.36035 15.465 8.33441L15.4243 8.2941C15.4553 8.29951 15.5274 8.24982 15.5641 8.30188C15.6923 8.15406 15.9769 8.02936 16.2251 7.91491C16.3491 7.861 16.4653 7.81071 16.5527 7.78028C16.6399 7.75648 16.6933 7.74173 16.6933 7.74173L17.1623 7.59108L17.4007 7.51723L17.6439 7.46755C17.6439 7.46755 17.7526 7.47653 17.9208 7.49093C18.0904 7.50142 18.3274 7.50702 18.5806 7.54788C18.7086 7.5644 18.8406 7.57584 18.974 7.58333C19.1073 7.59081 19.2407 7.59165 19.3674 7.61208C19.6235 7.63849 19.8645 7.63899 20.0557 7.59349C20.2699 7.6458 20.4689 7.75442 20.6749 7.83021C20.8781 7.92044 21.0896 7.98056 21.2806 8.09939C21.5527 8.24981 22.5803 8.69894 23.2922 9.04727C22.6065 9.58685 20.5459 9.83097 20.1992 10.4737L19.1767 10.6332C18.5814 10.8124 18.4812 12.1956 19.4105 11.8819C21.0276 11.2807 23.3047 11.252 24.6145 9.76439L24.5977 9.76234C24.5977 9.76234 24.9401 9.5157 24.9469 9.57169C25.0902 9.38082 25.1927 9.06747 25.1927 9.06747C25.2407 8.23732 24.3471 7.00712 23.805 6.73157C23.9922 6.6978 21.4512 2.5551 21.2052 3.97254L21.204 3.96983Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.8032 26.46C31.93 25.7425 32 24.9769 32 24.1719C32 23.3669 31.93 22.5794 31.8032 21.8531C31.0244 17.5263 28.0188 14.8619 23.8057 14.175C23.0882 14.0569 22.3313 14 21.5482 14C20.765 14 19.9469 14.0656 19.1988 14.1881C14.9813 14.8925 11.98 17.5525 11.2013 21.8531C11.07 22.5794 11 23.3538 11 24.1719C11 24.99 11.0657 25.7425 11.1969 26.46C11.9713 30.7563 14.9725 33.4206 19.1944 34.125C19.9425 34.2519 20.7257 34.3131 21.5438 34.3131C22.3619 34.3131 23.0838 34.2519 23.8013 34.1381C28.0232 33.4513 31.0288 30.7825 31.8032 26.46Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.9 24.4798C27.9 28.2808 24.8225 31.3633 21.0165 31.3633C20.4713 31.3633 19.9411 31.2989 19.4356 31.1799L11.6204 39.0001L6.49121 33.8709L14.3163 26.0507C14.1974 25.5502 14.1329 25.0199 14.1329 24.4798C14.1329 20.6738 17.2105 17.5913 21.0165 17.5913C21.7796 17.5913 22.5081 17.7152 23.192 17.9481L18.4791 22.6214L19.4108 26.0854L22.8749 27.0122L27.5481 22.3042C27.781 22.9831 27.9 23.7166 27.9 24.4798Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.5481 22.3042L22.8748 27.0122L19.4108 26.0854L18.4791 22.6214L23.192 17.9481C22.5081 17.7152 21.7796 17.5913 21.0164 17.5913C17.2104 17.5913 14.1329 20.6738 14.1329 24.4798C14.1329 25.0199 14.1973 25.5502 14.3163 26.0507L11.7492 28.6178C12.9088 30.8628 14.8069 32.4783 17.2253 33.3902L19.4355 31.1799C19.941 31.2989 20.4713 31.3633 21.0164 31.3633C24.8224 31.3633 27.8999 28.2808 27.8999 24.4798C27.8999 23.7166 27.781 22.9831 27.5481 22.3042Z",
        fill: primaryColor
    }));

});

parcelRegister("dLzpK", function(module, exports) {

$parcel$export(module.exports, "AutoReviewAvatar", () => $9e0a11fdc6fc0cc9$export$2dca6220da4c947);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $9e0a11fdc6fc0cc9$export$2dca6220da4c947 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38927",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38927)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.3494 12.0826C19.2594 10.3624 18.8974 8.06745 18.8395 7.24049C19.3044 8.23412 19.1223 5.65708 19.0216 5.23398C18.9788 5.66776 18.786 5.33229 18.8267 5.03741C19.5165 5.45196 19.0473 -1.57829 18.4432 2.03726C18.2868 3.74247 17.9911 7.47769 17.9483 10.1936C18.3082 11.5206 18.9809 17.0956 19.3494 12.0847V12.0826Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.5884 15.0207C12.1557 14.2044 11.6908 13.4971 10.7889 12.6317C10.8638 13.3476 10.4804 12.8561 10.4461 12.5185C11.0888 12.6531 10.2254 11.7236 9.92121 11.5953C10.009 11.7257 9.85265 11.8432 9.70698 11.6445C10.249 11.6017 8.31662 9.32388 8.13239 10.3474C8.38089 10.7064 8.11096 10.8688 8.55656 10.7128C8.07025 11.1274 8.8522 11.121 8.88434 11.1915C8.58441 11.6488 9.50346 11.7193 9.11784 11.8389C9.26566 12.7108 12.6698 16.9311 12.5884 15.0229V15.0207Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.347 22.677C8.35511 21.8864 7.25825 21.3586 5.67937 21.0808C6.33706 21.6877 5.57224 21.4398 5.23804 21.1898C6.71623 20.6492 -1.3667 20.256 1.70108 21.489C1.83819 20.8095 1.74393 21.692 2.1574 21.4419C2.47446 21.2197 2.77652 21.2924 2.77009 21.4676C2.76795 21.6621 3.61845 21.1471 3.38708 21.5146C4.09618 21.6215 10.9794 24.316 9.347 22.677Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.33589 29.6389C7.1919 30.0107 6.13576 30.5983 5.11388 31.7309C5.96009 31.5065 5.33666 32.0236 4.96604 32.139C5.33881 30.5706 0.71358 36.9298 3.35291 35.1328C2.82804 34.6498 3.57141 35.2033 3.55641 34.7438C3.7685 33.763 4.76897 33.8293 5.57448 32.6882C6.03079 31.9381 10.1654 29.8676 8.33589 29.6411V29.6389Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.3074 37.3124C15.2127 30.8463 14.8613 36.1243 15.0627 39.1202C15.474 38.2142 15.4376 39.1757 15.2534 39.5732C14.8527 38.5774 14.7906 41.6139 15.2169 40.9408C15.2212 41.054 15.2576 41.1694 15.2555 41.2763C14.6599 40.8852 15.0241 46.4346 15.8254 43.6033C15.1762 43.4195 16.2388 43.5477 15.594 42.5904C16.3352 41.6502 15.7654 38.8039 16.3074 37.3145V37.3124Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.8716 42.3639C29.0113 40.975 26.0271 31.9682 26.3827 36.8936C26.5156 37.5368 26.6869 38.9685 26.9419 39.9878C27.2375 39.0732 27.3296 39.9942 27.1775 40.3981C26.7084 39.5006 26.869 42.3618 27.2354 41.7122C27.2332 42.1161 26.9226 42.5135 27.0126 43.8298C26.8797 45.4923 27.7238 45.1397 27.7281 44.2722C27.2546 44.1675 28.2058 44.1675 27.6253 43.3084C28.1094 43.2914 27.5417 42.1503 27.8695 42.3639H27.8716Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.3733 32.1839C37.2614 31.8143 36.1752 31.5899 34.6863 31.5707C35.3933 32.0536 34.6071 31.9425 34.29 31.7203C34.9734 31.3677 33.3645 31.2929 33.0282 31.3848C33.251 31.4361 33.1375 31.6198 32.8804 31.5643C33.4267 31.2245 29.774 30.6775 30.3889 31.4532C30.3353 31.6391 30.7467 31.6006 30.8795 31.8378C30.9545 31.8378 30.9566 31.4403 31.053 31.575C30.9352 32.2032 31.67 31.7181 31.7535 31.7502C31.5029 32.3314 40.2799 33.7609 38.3754 32.1882L38.3733 32.1839Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M39.5772 21.7326C38.3732 21.6279 37.3127 21.6365 35.7724 21.7753C36.6593 22.1878 35.4918 22.2369 35.3868 21.8822C36.1045 21.6899 34.2385 21.6108 34.05 21.7967C34.2899 21.8224 34.185 22.019 33.9193 21.9912C34.1185 21.4911 29.399 21.5083 31.8991 22.5083C31.9762 22.4955 31.9227 22.1066 32.0405 22.2241C32.0062 22.863 32.6896 22.2839 32.7818 22.3074C32.8546 22.8032 33.8422 22.2219 33.6108 22.5638C34.1078 23.1515 41.8758 22.7775 39.575 21.7326H39.5772Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.6759 8.78116C30.5881 7.64649 31.7449 6.85587 31.9613 5.71692C31.5028 3.88137 27.8631 10.9415 29.0563 9.61668C29.4141 9.19572 25.2066 15.4845 26.7105 15.4887C26.7641 15.6041 27.2847 14.8904 27.1861 14.8392C27.0897 14.7451 26.944 14.7237 27.0447 14.6361C27.6253 14.9011 27.4025 13.8669 27.4732 13.7622C28.5807 13.0399 29.2984 10.0996 30.6781 8.77691L30.6759 8.78116Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.4469 18.9163C22.0894 18.9163 18.6681 22.3025 17.3688 23.9913C18.235 25.6844 22.0894 29.0663 26.4469 29.0663C30.8044 29.0663 34.6588 25.68 35.525 23.9913C34.23 22.2981 30.8044 18.9163 26.4469 18.9163ZM26.4469 20.3163C28.4769 20.3163 30.1219 21.9613 30.1219 23.9913C30.1219 26.0213 28.4769 27.6663 26.4469 27.6663C24.4169 27.6663 22.7719 26.0213 22.7719 23.9913C22.7719 21.9613 24.4169 20.3163 26.4469 20.3163Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.1931 23.9999L28.8225 27.1981L26.5125 31.2056L22.4218 30.5231L20.9737 34.4037H16.3493L14.8925 30.5231L10.8018 31.2056L8.49622 27.1981L11.1212 23.9999L8.49622 20.8018L10.8018 16.7943L14.8925 17.4724L16.3493 13.5962H20.9737L22.4218 17.4724L26.5125 16.7943L28.8268 20.8018L26.1931 23.9999Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.4469 27.6706C24.4169 27.6706 22.7719 26.0213 22.7719 23.9913C22.7719 21.9613 24.4169 20.3163 26.4469 20.3163C27.265 20.3163 28.0219 20.5831 28.6344 21.0381L28.8269 20.8019L27.8032 19.0256C27.3657 18.9556 26.9107 18.9163 26.4469 18.9163C22.0894 18.9163 18.6682 22.2981 17.3732 23.9913C18.235 25.6844 22.0894 29.0663 26.4469 29.0663C26.9063 29.0663 27.3613 29.0269 27.8075 28.9569L28.8225 27.1981L28.6257 26.9575C28.0132 27.4038 27.2607 27.6706 26.4469 27.6706Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.1931 23.9999L28.6256 26.9574C28.0131 27.4037 27.2606 27.6705 26.4469 27.6705C24.4169 27.6705 22.7719 26.0212 22.7719 23.9912C22.7719 21.9612 24.4169 20.3162 26.4469 20.3162C27.265 20.3162 28.0218 20.583 28.6343 21.038L26.1931 23.9999Z",
        fill: "#101214"
    }));

});

parcelRegister("4MSOB", function(module, exports) {

$parcel$export(module.exports, "BacklogBuddyAvatar", () => $1b71e6da520e7599$export$6690ebe55ef79618);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $1b71e6da520e7599$export$6690ebe55ef79618 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_34615",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_34615)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'lighten'
        },
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.2 33.9524C35.7545 34.5991 36.2809 35.2645 36.7841 35.9439C36.7841 35.9439 36.9425 36.1735 37.1662 36.5483C37.4038 36.9185 37.7066 37.4433 38.0048 38.0244C38.303 38.6054 38.5872 39.2567 38.7223 39.8705C38.8015 40.1798 38.8062 40.4703 38.7782 40.7233C38.7503 40.9811 38.6245 41.1638 38.5033 41.3137C38.112 41.6089 37.5482 41.6324 37.0217 41.5808C36.4859 41.5293 35.9548 41.3793 35.4376 41.2153C34.3987 40.8686 33.3876 40.4094 32.4046 39.9127C32.4046 39.9127 32.2462 39.8377 31.9992 39.7253C31.7523 39.6034 31.4215 39.4394 31.0627 39.2614C30.3499 38.9006 29.5485 38.4789 29.1618 38.3102C28.6819 38.0993 28.3511 37.9916 28.2486 38.0197C28.0529 38.0572 28.7565 38.7178 31.1652 39.9643C31.1885 39.9877 31.2817 40.0486 31.2864 40.0627C32.5816 40.6765 33.8442 41.3044 35.2094 41.7776C35.8942 42.0072 36.6024 42.2134 37.3991 42.2368C37.7905 42.2556 38.2378 42.1947 38.6664 41.9604C38.8807 41.8432 39.0811 41.6605 39.2162 41.4403C39.356 41.2153 39.4258 40.9764 39.4631 40.7421C39.4165 40.7796 39.3932 40.6577 39.4258 40.5547L39.4771 40.5968C39.4864 39.9924 39.342 39.5332 39.2162 39.1068C39.0718 38.6897 38.9227 38.3102 38.7503 37.9541C38.4102 37.2371 38.0141 36.5811 37.4457 35.883C37.4457 35.883 37.6181 36.0142 37.6228 36.0189C34.2076 30.9067 28.3092 25.1011 23.2587 20.912L23.2774 20.9401H23.2634C23.7107 21.3619 25.8166 23.358 25.8166 23.358C24.0182 22.1022 22.3222 20.2748 20.5005 18.8316L20.5564 18.7847C21.3392 19.4173 22.0473 19.9608 22.3409 20.167C20.9897 18.9721 18.8931 17.2478 16.7173 15.6546C14.5508 14.0521 12.2958 12.5995 10.7863 11.7514C10.8375 11.8451 11.8113 12.3043 11.9417 12.6042C11.1963 12.131 10.4275 11.6905 9.70535 11.2735C9.76126 11.1704 10.1619 11.4468 10.2505 11.4796C9.94762 11.2875 8.18648 10.1114 5.54476 8.95871C4.8785 8.67756 4.15634 8.4011 3.35963 8.20899C2.95429 8.12465 2.54429 8.03093 2.09235 8.02625C1.64974 8.02625 1.14189 8.05905 0.671322 8.37768C0.433707 8.52293 0.238025 8.77128 0.135524 9.03368C0.0423417 9.29608 -0.00424946 9.56785 0.000409659 9.8162C0.000409659 10.3223 0.121547 10.7674 0.265979 11.1985C0.559504 12.0513 0.978824 12.8151 1.41678 13.5414C2.29735 14.9893 3.28509 16.2591 4.17964 17.3509C5.07885 18.438 5.90351 19.3329 6.52317 19.9796C7.77647 21.2635 8.1958 21.5774 7.09158 20.2092L7.25465 20.2982C6.0526 18.9534 5.07885 17.8054 4.01191 16.2544C3.83952 16.0529 3.83486 16.0201 3.78361 16.0576C3.73236 16.0061 3.6485 15.9264 3.6485 15.9639C3.55066 16.0763 3.2385 15.5703 3.08474 15.3641C3.36429 15.3501 2.48372 14.1927 1.6544 12.8291C1.23973 12.1497 0.848369 11.414 0.634049 10.7674C0.52689 10.4441 0.461662 10.1442 0.443026 9.90054C0.433707 9.65688 0.452344 9.46945 0.489617 9.37574C0.601436 9.3242 0.717914 8.96339 1.07667 8.75253C1.4261 8.53231 1.92462 8.50419 2.15758 8.56042C2.12031 8.56042 1.91065 8.60728 1.88735 8.62602C1.98985 8.64476 2.4977 8.64945 3.17793 8.79471C3.85816 8.93059 4.69214 9.19768 5.4376 9.4882C6.92852 10.0739 8.07932 10.6784 7.1009 10.3223C10.8189 12.4262 15.8041 15.8046 20.5657 19.6281C25.3274 23.447 29.8653 27.711 32.7773 31.305L32.7493 31.2347C32.7913 31.2956 32.9497 31.4549 32.9637 31.5205C33.2991 31.8298 33.8675 32.4296 34.3428 32.9638C34.818 33.4979 35.2 33.9571 35.2 33.9571V33.9524ZM20.1977 18.9721C20.1977 18.9721 20.1837 18.9721 20.1837 18.9815C20.193 18.9581 19.2565 18.2318 19.2193 18.199L19.2705 18.1474C20.3095 18.7753 22.1498 20.9214 20.2396 19.094C20.1604 19.0518 20.1977 19.0049 20.1977 18.9721ZM11.6249 12.7776C11.4525 12.6651 11.2662 12.5386 11.0612 12.4027C13.5212 13.6491 16.3958 16.0248 18.8279 17.796C17.8262 17.4165 15.9719 15.8139 14.9142 15.0642C13.81 14.3707 12.5754 13.4383 11.6249 12.7823V12.7776ZM2.25076 14.0193L2.28804 14.0052L2.33929 14.0849C2.33929 14.0849 2.31599 14.0849 2.29735 14.0709C2.28338 14.0615 2.26008 14.038 2.25076 14.0193ZM34.4173 32.7154C34.2449 32.5983 33.779 31.9891 34.189 32.3031C34.2589 32.4155 34.5431 32.6732 34.4173 32.7154ZM9.01114 11.1095C8.95523 11.2125 8.06534 10.7487 8.13989 10.6081C8.44739 10.7627 8.73159 10.9408 9.01114 11.1095ZM38.6338 38.8725C38.8435 39.0786 38.6851 39.0552 38.6385 39.163C38.6338 39.0974 38.5593 38.8678 38.6291 38.8959V38.8725H38.6338ZM36.6956 41.7542C36.6211 41.8011 36.3462 41.787 36.2204 41.7683C35.9129 41.6605 36.5652 41.6745 36.6956 41.7542ZM29.5951 38.685C29.5485 38.7413 29.3761 38.6663 29.3715 38.582C29.4134 38.5492 29.6277 38.6241 29.6138 38.7132C29.6138 38.7132 29.6138 38.6991 29.5951 38.6897V38.685ZM4.91112 8.85094C5.24657 8.74785 6.04794 9.26797 6.51851 9.42728C6.33681 9.56317 5.58203 9.06648 5.2093 8.95871C5.08816 8.90716 4.98566 8.87436 4.91112 8.84625V8.85094ZM29.5159 26.8535C29.637 26.713 30.2707 27.547 30.5363 27.7673L30.4803 27.8141C30.1076 27.4627 29.8607 27.28 29.5299 26.8676L29.5159 26.8535ZM13.2137 13.3305C13.4187 13.3774 13.6516 13.6163 13.8147 13.7288C13.7541 13.8131 13.0459 13.3539 13.2137 13.3305ZM20.1371 18.438C20.0998 18.5551 19.8063 18.2458 19.7038 18.1802C19.7877 18.213 19.9507 18.2552 20.03 18.3208C20.0812 18.3677 20.0905 18.3864 20.1418 18.438H20.1371ZM29.1944 26.638C28.9102 26.3615 28.6027 26.0617 28.3092 25.7758L28.3698 25.7337C28.668 26.0242 28.9615 26.3147 29.255 26.5958L29.1991 26.638H29.1944ZM26.3431 23.7844L26.3896 23.7328C26.8695 24.0749 26.795 24.2576 26.3524 23.7938L26.3431 23.7844ZM32.8658 30.3257C32.8285 30.2788 32.7633 30.2039 32.726 30.1617C32.1576 29.5525 33.1407 30.2367 32.8658 30.3257ZM35.7405 33.6104C35.8011 33.6713 35.8849 33.7416 35.9362 33.8166C36.2903 34.2898 35.7545 33.8775 35.7405 33.6104Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'lighten'
        },
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.5644 38.0009C10.8469 38.4601 10.1201 38.9006 9.38396 39.3223C9.38396 39.3223 9.13703 39.4441 8.73634 39.6316C8.33566 39.819 7.78588 40.072 7.17554 40.3204C5.96417 40.8358 4.48723 41.2763 3.64393 41.2622C3.12211 41.2294 2.63756 40.9436 2.53972 40.4469C2.43256 39.9596 2.56301 39.4113 2.73074 38.9006C3.09881 37.8744 3.66722 36.9138 4.28223 35.9908C4.28223 35.9908 4.6503 35.4004 5.09757 34.7397C5.54485 34.0743 6.07599 33.3386 6.29497 32.9731C6.57451 32.5233 6.7236 32.2094 6.71429 32.1063C6.70031 31.9985 6.52326 32.1063 6.13656 32.5139C5.74985 32.9169 5.15814 33.6245 4.38939 34.7537C4.36143 34.7771 4.29155 34.8615 4.27291 34.8615C3.88154 35.4706 3.49484 36.0751 3.13608 36.6983C2.77267 37.3168 2.43722 37.9588 2.17631 38.6616C2.04585 39.0131 1.94335 39.3879 1.8921 39.7862C1.86415 40.1939 1.87346 40.6624 2.14369 41.1123C2.4279 41.5574 2.92177 41.787 3.34109 41.8573C3.76972 41.937 4.17973 41.9229 4.56643 41.862C4.51984 41.8245 4.61768 41.773 4.71553 41.7823L4.69223 41.8432C5.70326 41.623 6.45338 41.3512 7.18952 41.0795C7.921 40.7983 8.60589 40.4797 9.36066 39.9924C9.36066 39.9924 9.21157 40.147 9.20691 40.1517C14.6721 37.3871 21.3206 32.4577 26.208 28.0578L26.1754 28.0719V28.0578C25.6955 28.4373 23.4032 30.232 23.4032 30.232C24.9175 28.6388 26.9768 27.2237 28.6774 25.6306L28.7146 25.6962C27.9738 26.3756 27.3262 26.9988 27.0793 27.2612C28.463 26.0992 30.4851 24.2764 32.3814 22.3506C34.2869 20.4341 36.0574 18.4005 37.101 17.0088C37.0032 17.0463 36.4068 17.9507 36.0947 18.0397C36.6677 17.3603 37.2129 16.6621 37.7254 15.9967C37.8185 16.067 37.4878 16.4278 37.4458 16.5168C37.567 16.3809 37.9676 15.9077 38.536 15.1626C39.0951 14.4129 39.8313 13.3914 40.5115 12.0935C40.8423 11.4375 41.1778 10.7159 41.3082 9.83964C41.3548 9.40386 41.3548 8.865 41.0194 8.38706C40.8423 8.16683 40.6233 7.97471 40.3764 7.87163C40.1341 7.76854 39.8825 7.70762 39.6496 7.69357C38.6945 7.6186 37.8372 7.86694 37.0079 8.12466C36.1785 8.39643 35.3865 8.73849 34.6317 9.09929C31.6033 10.5566 29.0594 12.2903 27.6011 13.3305C26.1521 14.3895 25.7794 14.7597 27.2889 13.86L27.1771 14.0099C28.682 13.0072 29.954 12.2059 31.6266 11.3531C31.8502 11.2126 31.8828 11.2079 31.8549 11.1516C31.9108 11.1095 32.004 11.0345 31.9667 11.0251C31.8689 10.9127 32.4093 10.669 32.6376 10.5425C32.6143 10.819 33.8816 10.102 35.3119 9.40386C36.0294 9.05243 36.7889 8.71506 37.4365 8.49014C38.0795 8.26054 38.6106 8.14808 38.8156 8.13403C38.9088 8.23243 39.3001 8.18088 39.7195 8.22306C39.9291 8.25117 40.1434 8.29803 40.3158 8.39643C40.4789 8.49483 40.5907 8.6354 40.6327 8.73849C40.6187 8.70569 40.4416 8.60729 40.4277 8.59323C40.4416 8.64477 40.5441 8.7338 40.6187 8.91655C40.6839 9.09929 40.7538 9.37106 40.7165 9.70375C40.6653 10.3738 40.3484 11.2079 40.0083 11.9248C39.2955 13.368 38.536 14.4317 39.0159 13.5039C36.4907 16.9666 32.3907 21.4087 27.8946 25.565C23.4079 29.7259 18.5019 33.5823 14.5323 35.958L14.6068 35.9392C14.5416 35.972 14.3599 36.1079 14.2947 36.1126C13.9406 36.3984 13.265 36.881 12.6686 37.2793C12.0769 37.6776 11.5691 37.9963 11.5691 37.9963L11.5644 38.0009ZM28.5935 25.3073C28.5935 25.3073 28.5935 25.2932 28.5888 25.2932C28.5935 25.2932 28.6494 25.2464 28.7333 25.1714C28.8171 25.0964 28.929 24.9933 29.0408 24.8902C29.2644 24.6794 29.488 24.4685 29.5067 24.4545L29.5486 24.5107C28.7705 25.4478 26.3758 26.9566 28.4677 25.3307C28.5189 25.2557 28.5609 25.3026 28.5935 25.3073ZM35.9829 17.6929C36.118 17.5383 36.2671 17.3696 36.4348 17.1822C34.86 19.4595 32.0785 21.9663 29.9679 24.1218C30.4944 23.1846 32.3534 21.5774 33.2526 20.6403C34.1006 19.6422 35.2001 18.5504 35.9829 17.6929ZM34.068 9.88181L34.0773 9.91929L33.9934 9.96147C33.9934 9.96147 33.9934 9.93804 34.0074 9.92398C34.0167 9.90992 34.0447 9.89118 34.068 9.88181ZM12.8969 37.3918C13.0367 37.2372 13.703 36.8576 13.3349 37.2231C13.2138 37.2746 12.9202 37.523 12.8969 37.3918ZM37.9909 15.3173C37.9024 15.247 38.4708 14.4223 38.6013 14.5113C38.4056 14.7972 38.2006 15.0642 37.9909 15.3173ZM6.29031 40.8967C6.07599 41.0982 6.10394 40.9389 5.99678 40.8967C6.06667 40.8967 6.29962 40.8264 6.26701 40.8967H6.29031ZM2.29278 40.1798C2.23688 40.1189 2.18097 39.8284 2.20892 39.7019C2.25551 39.5379 2.28347 39.6269 2.28813 39.7675C2.28813 39.908 2.32074 40.1048 2.28813 40.1845L2.29278 40.1798ZM5.86633 33.3433C5.81974 33.2918 5.91292 33.1278 6.00144 33.1325C6.0294 33.1793 5.92224 33.3855 5.83837 33.3574C5.83837 33.3574 5.85235 33.3574 5.86633 33.3433ZM40.6746 11.4422C40.7631 11.7936 40.1761 12.5714 39.9571 13.0213C39.8406 12.8245 40.4183 12.1122 40.5441 11.742C40.6047 11.6202 40.642 11.5218 40.6746 11.4468V11.4422ZM19.4057 33.3761C19.5269 33.5167 18.6044 34.0227 18.3528 34.257L18.3155 34.1961C18.7162 33.8775 18.9398 33.6619 19.3917 33.3902L19.4104 33.3761H19.4057ZM35.2048 19.1971C35.1302 19.3939 34.8553 19.5907 34.7249 19.7406C34.6503 19.6703 35.2048 19.0284 35.2094 19.1971H35.2048ZM29.1293 25.326C29.0221 25.2698 29.3716 25.0261 29.4508 24.9324C29.4042 25.0074 29.339 25.1667 29.2644 25.2323C29.2132 25.2792 29.1899 25.2838 29.134 25.326H29.1293ZM19.6666 33.0903C19.9834 32.8513 20.3236 32.5889 20.6544 32.3406L20.687 32.4062C20.3562 32.6592 20.0254 32.9075 19.7039 33.1559L19.6713 33.0903H19.6666ZM22.9094 30.6865L22.956 30.7427C22.5413 31.1644 22.3782 31.0614 22.9001 30.6959L22.9094 30.6865ZM15.4734 36.1922C15.5247 36.1594 15.6085 36.1079 15.6551 36.0798C16.34 35.6018 15.52 36.4828 15.4734 36.1922ZM11.8207 38.5867C11.7555 38.6382 11.6669 38.7132 11.5877 38.7553C11.0706 39.0459 11.5504 38.5632 11.8207 38.5867Z",
        fill: secondaryColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.9388 22.845H13.6282V33.2575H34.9388V22.845Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.315 16.3788H7.00439V26.7913H28.315V16.3788Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.315 22.845H13.6282V26.7913H28.315V22.845Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.6132 26.6076L29.0238 31.1969L26.6526 28.7601L27.6763 27.7669L29.0413 29.1669L32.6069 25.6013L33.6176 26.6119L33.6132 26.6076Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.1069 13.2367C18.8661 13.1873 18.7335 12.9498 18.4436 13.0909C17.574 13.5164 16.4612 14.9083 16.1099 15.4866C15.2673 15.9168 13.7639 17.84 13.1621 18.8345C12.801 19.4763 11.7864 21.1408 11.7864 21.1408L11.6612 21.1314C11.6612 21.1314 9.71067 18.6252 8.71823 18.1127C8.54136 18.0563 8.3473 18.1103 8.1778 18.3619C8.08691 18.4512 8.75754 19.2458 8.91476 19.2552C9.06706 19.1753 9.76717 20.2004 10.1946 20.7176C11.5334 22.3445 11.7938 22.4855 12.4251 21.9636C13.4765 21.0937 18.0186 14.8847 19.1069 13.2343V13.2367Z",
        fill: "#101214"
    }));

});

parcelRegister("7bSsT", function(module, exports) {

$parcel$export(module.exports, "CommsCrafterAvatar", () => $81bb84765de22578$export$57726a005ac84f9e);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $81bb84765de22578$export$57726a005ac84f9e = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_35679",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_35679)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.7267 15.5879C30.4756 15.4232 28.6104 16.1079 27.605 15.6052C27.9106 15.6341 28.0791 11.5316 27.0708 12.2712C26.7795 12.5168 26.6424 12.9733 27.0851 13.0917C26.2625 13.4789 27.5364 15.585 25.6227 16.4633C25.5941 15.351 20.6441 17.0815 23.529 17.1335C23.5975 16.6915 23.6147 17.8356 24.4259 16.9949C27.3393 17.2953 26.1968 18.7081 27.2051 20.924C27.0623 23.9691 29.2216 21.6 28.1077 20.0948C28.8846 18.1447 26.1111 16.6251 29.433 17.4629C29.7672 16.7522 33.6004 16.706 31.7238 15.5879H31.7267Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M42.7436 22.2675C41.9524 21.8919 40.9584 22.5333 40.4871 21.7417C41.0897 21.9901 41.0098 18.7948 40.0158 19.5517C39.8958 20.0486 39.6073 19.988 40.1157 20.1584C39.2617 20.1642 40.0558 20.7131 40.0272 20.7911C39.5616 20.8027 40.17 21.0685 39.7273 20.976C39.4702 21.0281 40.2214 21.6868 39.713 21.5105C39.5502 22.227 38.7561 22.2212 38.9332 22.6575C38.9246 22.3599 36.2854 22.2906 37.0166 23.4289C37.4793 23.4058 37.4194 23.9316 37.4879 23.2469C37.6279 24.0962 37.9392 23.2468 38.0135 23.2671C38.082 23.7438 38.2191 23.0851 38.1991 23.5502C38.2677 23.8016 38.7133 22.9984 38.6247 23.5242C40.1643 23.9316 38.9018 24.3707 39.7901 25.2548C39.8787 25.665 39.6616 26.9969 40.6127 26.8727C41.8638 26.5086 40.4042 24.2349 41.1469 23.8391C41.4782 23.5387 41.9495 23.1602 42.575 23.4173C42.8835 23.4231 43.2806 22.149 42.7464 22.2646L42.7436 22.2675Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.7396 8.62231C37.0281 8.93433 39.3902 8.95745 39.3902 8.95745C39.3902 8.95745 39.8844 9.49479 39.7044 9.90215C40.1415 10.1939 40.1557 10.9162 40.0586 11.6558C40.09 12.0343 41.444 12.2192 41.2126 11.6212C41.5011 11.0694 40.5813 9.35036 41.2669 9.48903C41.2611 8.72632 42.5494 9.047 42.158 8.00694C42.0438 7.33378 41.5182 7.72381 41.4668 7.57647C39.8501 8.96033 41.3468 3.86401 39.6587 4.69607C39.5788 5.20454 39.693 6.29951 39.5131 6.68375C39.2132 7.05066 39.2303 7.48691 39.3131 7.94338C38.799 7.80182 36.631 7.93471 36.7367 8.61942L36.7396 8.62231Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.4064 5.66103C21.4724 5.42412 21.1953 6.50751 21.0497 4.67295C20.9126 3.82934 20.2956 4.06335 20.0842 4.34359C19.9557 4.51116 20.3556 5.30857 20.1985 5.38369C20.1985 5.38369 20.2156 6.04237 20.2585 6.40061C20.2128 6.01925 18.7789 6.22727 18.1162 6.5104C18.1162 6.5104 17.6449 7.0911 18.3133 7.44646C18.3533 7.4349 19.6386 7.27022 20.0043 7.41179C20.6041 7.83937 20.1414 7.94918 20.2499 8.41143C20.3584 8.8708 20.347 10.9018 21.6381 9.7173C21.6866 8.7928 21.6781 8.61365 21.5124 7.34245C21.7181 6.99288 22.0323 6.74155 22.5064 6.82244C22.7578 6.74733 22.8063 5.4559 22.4093 5.66103H22.4064Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.3165 27.4389C26.3824 27.202 26.1054 28.2854 25.9597 26.4508C25.8226 25.6072 25.2056 25.8412 24.9943 26.1215C24.8657 26.2891 25.2656 27.0865 25.1085 27.1616C25.1085 27.1616 25.1257 27.8203 25.1685 28.1785C25.1228 27.7971 23.6889 28.0052 23.0262 28.2883C23.0262 28.2883 22.555 28.869 23.2233 29.2243C23.2633 29.2128 24.5487 29.0481 24.9143 29.1897C25.5141 29.6173 25.0514 29.7271 25.1599 30.1893C25.2685 30.6487 25.257 32.6797 26.5481 31.4952C26.5967 30.5707 26.5881 30.3915 26.4224 29.1203C26.6281 28.7708 26.9423 28.5194 27.4164 28.6003C27.6678 28.5252 27.7164 27.2338 27.3193 27.4389H27.3165Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.8249 0.541599C27.8592 0.547378 29.5302 0.209329 29.3502 0.694694C29.7015 1.1945 29.3988 2.36172 29.9843 2.49751C31.5325 2.58418 30.5185 1.61342 30.7755 0.951825C31.3754 1.16851 32.0809 0.116891 31.4239 -0.339583C31.2925 -0.134458 30.9698 -0.556268 31.0012 -0.307807L30.9983 -0.414701C30.767 -0.229801 30.6299 -0.186467 30.3614 -0.562047C30.1214 -0.018901 30.9298 -2.32728 29.6558 -1.87081C29.4245 -1.68013 29.8329 -0.596698 29.3188 -0.65159C28.9103 -0.408908 28.3391 -0.58516 27.9506 -0.417593C27.6307 -0.278918 27.4422 0.0533457 27.8306 0.541599H27.8249Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.6666 17.5467C11.7009 17.5525 13.3718 17.2145 13.1919 17.6998C13.5432 18.1996 13.2404 19.3668 13.826 19.5026C15.3741 19.5893 14.3601 18.6185 14.6172 17.9569C15.217 18.1736 15.9225 17.122 15.2656 16.6655C15.1342 16.8706 14.8114 16.4488 14.8429 16.6973L14.84 16.5904C14.6086 16.7753 14.4715 16.8186 14.203 16.443C13.9631 16.9862 14.7714 14.6778 13.4975 15.1343C13.2662 15.325 13.6746 16.4084 13.1605 16.3535C12.752 16.5962 12.1807 16.4199 11.7923 16.5875C11.4724 16.7262 11.2839 17.0584 11.6723 17.5467H11.6666Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.6164 23.7293C38.4077 24.1049 39.4017 23.4635 39.873 24.2551C39.2703 24.0067 39.3502 27.202 40.3443 26.445C40.4642 25.9481 40.7527 26.0088 40.2443 25.8383C41.0983 25.8325 40.3043 25.2836 40.3328 25.2056C40.7984 25.1941 40.19 24.9283 40.6327 25.0207C40.8898 24.9687 40.1386 24.31 40.647 24.4863C40.8098 23.7698 41.6039 23.7755 41.4268 23.3393C41.4354 23.6368 44.0746 23.7062 43.3434 22.5679C42.8807 22.591 42.9407 22.0652 42.8721 22.7499C42.7321 21.9005 42.4208 22.7499 42.3465 22.7297C42.278 22.253 42.1409 22.9117 42.1609 22.4465C42.0923 22.1952 41.6467 22.9984 41.7353 22.4725C40.1957 22.0652 41.4582 21.626 40.5699 20.742C40.4814 20.3317 40.6984 18.9999 39.7473 19.1241C38.4962 19.4881 39.9558 21.7618 39.2131 22.1576C38.8818 22.4581 38.4105 22.8366 37.785 22.5794C37.4765 22.5737 37.0795 23.8478 37.6136 23.7322L37.6164 23.7293Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6722 14.4948V32.9922H29.1697V14.4948H10.6722ZM18.5997 18.4673H25.206V20.4491H18.5997V18.4673ZM18.5997 22.7504H25.206V24.7322H18.5997V22.7504ZM15.301 18.126C16.0272 18.126 16.6222 18.721 16.6222 19.4473C16.6222 20.1735 16.0272 20.7685 15.301 20.7685C14.5747 20.7685 13.9797 20.1779 13.9797 19.4473C13.9797 18.7166 14.5703 18.126 15.301 18.126ZM15.301 22.4222C16.0272 22.4222 16.6222 23.0129 16.6222 23.7435C16.6222 24.4741 16.0272 25.0647 15.301 25.0647C14.5747 25.0647 13.9797 24.4741 13.9797 23.7435C13.9797 23.0129 14.5703 22.4222 15.301 22.4222Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.681 25.9047V28.9716H18.5997V35.206H31.681V38.8897L38.1691 32.3928L31.681 25.9047Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5997 28.9716V32.9922H29.1697V28.9716H18.5997Z",
        fill: primaryColor
    }));

});

parcelRegister("7NM53", function(module, exports) {

$parcel$export(module.exports, "CultureAvatar", () => $da2a5b26902f2127$export$4408f9b5d5d155d9);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $da2a5b26902f2127$export$4408f9b5d5d155d9 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36071",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: "#FFA900"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36071)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M49 21.8675C47.0544 11.2058 42.8575 26.879 41.1102 29.6295C40.0557 25.9886 40.38 22.2032 39.8294 18.3921C39.7735 18.4993 39.6895 18.2522 39.6918 18.0121C38.1054 9.86083 34.4172 22.4363 34.1442 25.28C34.1442 25.273 34.1722 24.7485 34.1722 24.7369C30.0803 41.3168 32.3386 19.7067 30.1386 14.8117C27.9061 11.1708 26.4294 18.5832 25.9978 20.2778C25.0343 23.8721 22.2185 39.9905 21.8523 27.6389L21.8429 27.7251L21.8289 27.6878C21.7776 29.2752 21.8779 36.1281 23.6906 30.8998C20.7138 38.8437 21.6143 20.6577 21.4184 18.6601C21.8383 21.0074 21.5817 23.7439 21.7543 24.5761C21.0614 -2.83573 16.0784 26.2496 13.1483 32.2378C12.6281 30.8882 12.628 29.2099 12.5137 27.802C12.4298 28.2449 12.7727 30.9488 12.6724 31.4523C12.2781 30.1283 12.1335 22.5318 12.4111 26.2636C12.1055 25.0772 13.7432 10.982 9.46466 14.9959C6.89149 19.8442 6.98015 25.914 4.1177 30.6365C2.02278 28.7811 5.49644 13.7255 0.65338 16.7371C-1.12894 18.4503 -4.81722 33.1259 -5.65939 25.2893C-6.03499 21.8954 -6.02566 25.0982 -5.83903 26.5037C-5.89735 26.3569 -5.94868 26.21 -6 26.0608C-4.32266 34.6643 -0.317097 17.1846 1.79183 16.6718C3.05858 21.5155 1.80582 41.5336 7.21344 24.7252C7.20177 24.8161 7.12479 25.3895 7.11313 25.4641C8.18625 24.0282 8.43587 15.4901 11.016 15.1964C11.5129 15.6859 11.8302 20.4852 11.4033 17.6089C11.1793 46.0882 15.4438 30.7576 19.7177 14.8607C22.4611 19.7067 18.3833 29.3894 22.4285 34C27.1129 29.7251 25.6712 20.9375 28.8159 15.4178C30.106 17.2453 29.6418 21.5528 29.9147 24.0795L29.945 23.8954C30.1713 34.8531 32.4039 37.247 35.299 24.5178C35.7819 23.1682 38.1124 12.637 38.8076 18.7767C40.457 37.1631 40.8092 31.5665 47.0124 19.0471C48.5777 18.9562 49.0187 27.3195 48.9953 21.8698L49 21.8675Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4219 32.2245C15.4219 32.2245 10.2316 27.624 8.93398 25.6752C7.63638 23.7265 7.63638 23.0328 7.63638 21.9193C7.63638 21.2257 7.74491 20.5887 7.96668 20.013C8.19317 19.4326 8.50459 18.9325 8.90095 18.5078C9.2973 18.0831 9.75972 17.7575 10.2882 17.5263C10.8167 17.2951 11.3876 17.1819 12.0057 17.1819C12.7749 17.1819 13.4496 17.3801 14.03 17.7717C14.6104 18.1633 15.0775 18.6824 15.4267 19.3241C15.7806 18.6777 16.2477 18.1586 16.8281 17.7717C17.4084 17.3801 18.0785 17.1819 18.8429 17.1819C19.461 17.1819 20.0319 17.2951 20.5604 17.5263C21.0936 17.7575 21.556 18.0831 21.9477 18.5078C22.344 18.9325 22.6554 19.4326 22.8725 20.013C23.099 20.5887 23.2075 21.2209 23.2075 21.9193C23.2075 23.0328 23.1698 23.7312 21.9099 25.6752C20.5793 27.6193 15.4219 32.2245 15.4219 32.2245Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.0246 32.2245C26.0246 32.2245 20.8342 27.624 19.5366 25.6752C18.239 23.7265 18.239 23.0328 18.239 21.9193C18.239 21.2257 18.3476 20.5887 18.5693 20.013C18.7958 19.4326 19.1073 18.9325 19.5036 18.5078C19.9 18.0831 20.3624 17.7575 20.8909 17.5263C21.4193 17.2951 21.9903 17.1819 22.6084 17.1819C23.3775 17.1819 24.0523 17.3801 24.6326 17.7717C25.213 18.1633 25.6802 18.6824 26.0293 19.3241C26.3832 18.6777 26.8503 18.1586 27.4307 17.7717C28.0111 17.3801 28.6811 17.1819 29.4455 17.1819C30.0637 17.1819 30.6346 17.2951 31.1631 17.5263C31.6963 17.7575 32.1587 18.0831 32.5503 18.5078C32.9467 18.9325 33.2581 19.4326 33.4751 20.013C33.7016 20.5887 33.8102 21.2209 33.8102 21.9193C33.8102 23.0328 33.7724 23.7312 32.5126 25.6752C31.1819 27.6193 26.0246 32.2245 26.0246 32.2245Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.2074 21.9193C23.2074 23.0329 23.1697 23.7312 21.9099 25.6752C21.6409 26.0669 21.2209 26.5623 20.7208 27.1097C20.2206 26.5623 19.8007 26.0669 19.5412 25.6752C18.2436 23.7312 18.2436 23.0329 18.2436 21.9193C18.2436 21.2257 18.3521 20.5887 18.5739 20.013C18.7956 19.4326 19.107 18.9325 19.5034 18.5078C19.862 18.1303 20.2678 17.8283 20.7255 17.6066C21.1879 17.8283 21.5984 18.1303 21.9476 18.5078C22.344 18.9325 22.6507 19.4326 22.8724 20.013C23.0942 20.5887 23.2074 21.2257 23.2074 21.9193Z",
        fill: primaryColor
    }));

});

parcelRegister("19LR2", function(module, exports) {

$parcel$export(module.exports, "CustomerInsightAvatar", () => $c879352380461f10$export$58350b915e9fb39e);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $c879352380461f10$export$58350b915e9fb39e = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_34180",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: "#FFA900"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_34180)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28763 33.302C9.73969 33.2628 15.7885 31.7918 14.2018 31.4727C13.6133 31.6385 13.1559 31.4709 12.8616 31.9202C12.7765 31.3907 11.6224 32.2358 11.4451 32.2679C11.3654 31.8667 9.5571 32.899 9.82125 32.5264C9.00044 32.5371 7.98108 32.8259 6.92094 33.1647C6.40151 32.8099 8.62814 30.2781 7.6921 30.8255C7.7577 30.6828 8.00944 30.066 7.97575 30.4742C8.27181 30.1248 11.4948 24.776 10.1545 25.6817C9.2504 26.7854 8.57142 28.6343 7.80557 29.5471C7.06099 29.8556 6.5451 32.505 5.71543 32.2411C5.23145 31.6456 3.9834 24.3534 3.097 25.0006C3.25123 25.5676 3.11118 26.0757 3.54197 26.3485C3.01545 26.4341 3.85575 27.5948 3.88766 27.7731C3.49765 27.848 4.50815 29.6737 4.14472 29.4063C4.15181 29.9215 4.26705 30.517 4.43369 31.15C4.21209 30.9806 3.96922 30.5937 3.82916 30.5366C2.33646 29.9287 1.20541 28.5308 -0.349339 27.7731C-1.6559 29.4473 9.89748 33.671 2.73357 34.3022C1.38624 35.1865 -0.404297 35.322 -1.90764 36.1725C-2.03705 38.0143 6.53269 32.9329 4.05963 35.8516C3.67493 37.0854 3.10409 38.4707 2.31519 39.6867C1.81171 44.3241 6.09304 31.7259 5.91575 36.5327C6.5061 37.6809 7.07694 39.0644 7.36946 40.489C9.46314 43.5771 6.60538 35.4076 6.30577 34.2505C7.44037 33.7638 11.8263 39.2837 12.6205 38.4137C12.6577 38.2906 12.0266 37.6078 11.8352 37.5347C11.7057 37.6006 11.6401 37.6541 11.5639 37.5329C11.9486 37.1603 10.5995 36.6896 10.4719 36.5612C10.7555 36.2777 8.87811 35.3559 9.33372 35.3702C8.98271 34.8763 8.44555 34.3789 7.83393 33.8779C8.91889 33.6675 9.39045 32.8973 9.29118 33.2984L9.28763 33.302Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.0413 11.3023C37.0466 11.2934 37.0466 11.2773 37.0572 11.2648C36.747 11.1079 36.7116 10.7228 36.4722 10.4928L36.4634 10.4839C36.2205 10.4055 36.2861 10.1612 35.9847 10.1594C35.9847 10.1594 36.0627 10.1202 36.0645 10.1202C35.5752 9.63166 34.3661 8.43175 34.3661 8.43175C34.3395 8.54051 34.5594 8.35152 34.781 8.38361C34.781 8.38361 34.7969 8.34261 34.8129 8.37471C35.3784 7.82021 36.0148 7.60804 36.7382 7.34417C37.0998 7.2461 37.1548 6.21734 36.5361 6.64346C36.529 6.63633 36.513 6.631 36.5059 6.61852C36.2896 6.8717 35.9297 6.77896 35.6567 6.9109L35.6461 6.91626L35.1923 7.13912C34.9458 7.24075 34.6533 7.321 34.3466 7.39945C34.3555 7.39053 34.3644 7.38161 34.3732 7.3727C34.3732 7.3727 34.4051 6.87882 34.3963 6.63456C34.3963 6.63456 34.7065 6.24232 34.6037 5.9731C34.7792 5.65752 35.4032 4.9675 34.8359 4.77138C34.6498 4.77138 34.5044 4.60914 34.4406 4.91045C34.4299 4.90867 34.4158 4.91223 34.4016 4.90688C34.3679 5.2189 34.0009 5.43999 33.8999 5.73595L33.8963 5.74845C33.9212 6.00162 33.7262 6.25122 33.7244 6.25122C33.6322 6.48301 33.5116 6.73617 33.384 7.00005C33.3308 6.85741 33.2723 6.73084 33.2138 6.63991C33.0011 6.40813 33.0915 3.24164 32.3044 3.94055C32.3416 4.53783 32.5295 5.16007 32.377 5.69138C32.3026 5.73239 32.416 5.94456 32.5082 6.1175C32.5011 6.33681 32.4568 6.45448 32.4444 6.76828C32.0544 6.48479 30.3525 5.04954 30.4571 6.01589C30.6397 6.11395 30.7726 6.22627 30.8684 6.45448C30.957 6.55254 31.7388 6.99472 31.7637 7.10526C31.7122 7.25859 32.6359 7.3816 32.2618 7.49571C32.3168 7.61695 32.3912 7.73286 32.4781 7.84518C32.0739 7.88797 31.5899 8.00741 31.3364 8.16253C31.2921 8.23919 29.6788 8.34261 29.0938 8.72237C28.7446 8.92028 28.4361 9.01835 28.7995 9.3161C28.9307 9.20913 29.4235 9.36245 29.4129 9.2216C29.5335 9.27152 30.349 8.95772 30.4394 9.01121C30.4837 9.08252 31.1254 8.70455 31.0492 8.88284C31.4942 9.00943 32.0367 8.90601 32.6004 8.76159C32.377 9.11818 32.1572 9.62631 32.1289 9.94189C31.9374 10.3466 31.4321 11.2417 31.2708 11.7908C31.0403 12.1902 31.1201 12.2223 31.4109 12.4273L31.4162 12.4327C31.4765 12.4737 31.4091 12.4327 31.6378 12.4416C31.6147 12.4202 31.581 12.3275 31.5367 12.3435C31.5669 12.2811 31.9143 12.192 31.769 12.1082C31.7637 12.0957 31.9906 11.921 32.0136 11.732C32.2157 11.058 32.6997 10.7175 33.0578 9.94903C33.0489 10.0293 33.6517 11.5394 33.6233 12.2918C33.579 12.6627 34.4725 13.2154 34.3431 12.3881C34.3537 12.3845 34.3626 12.3703 34.3785 12.3685C34.2349 12.0279 34.4246 11.6767 34.3502 11.3308L34.3466 11.3166C34.1853 11.1062 34.3715 10.9314 34.1162 10.7603C34.1162 10.7603 34.203 10.7692 34.2048 10.771C34.0913 10.2807 34.0204 9.68159 33.9141 9.14493C34.2952 9.4926 34.6303 9.86701 34.7685 10.2789L34.7863 10.2521C34.7863 10.2646 34.8129 10.2735 34.7898 10.302C35.1107 10.3698 35.2206 10.5053 35.4529 10.5962C35.4529 10.5962 35.701 11.0473 35.99 11.0634L36.4297 11.6892C36.6194 12.0119 37.6423 11.8265 37.0484 11.3094L37.0413 11.3023Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.47 21.4136C29.47 24.5332 27.8031 27.2568 25.3181 28.7396L24.3031 34.0328H17.7012L16.6862 28.7396C14.2012 27.2612 12.5344 24.5332 12.5344 21.4136C12.5344 16.71 16.3231 12.8952 21 12.8952C25.6769 12.8952 29.47 16.71 29.47 21.4136Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.8694 31.2652L25.0687 37.1832H16.9356L16.1306 31.2652H25.8694Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.8369 31.2652L24.3031 34.0284H17.7012L17.1675 31.2652H24.8369Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.8369 31.2652L24.3031 34.0284H17.7012L17.1675 31.2652H24.8369Z",
        fill: primaryColor
    }));

});

parcelRegister("a4vlK", function(module, exports) {

$parcel$export(module.exports, "DecisionDirectorAvatar", () => $b1e44362ee99359d$export$5b0c8178b6b02cb4);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $b1e44362ee99359d$export$5b0c8178b6b02cb4 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_4147_15812",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_4147_15812)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.8727 8.7469C31.1115 8.70494 33.0242 6.03171 32.013 6.33386C31.6322 6.39681 31.4429 6.61504 31.6107 6.91089C31.0836 6.5353 31.2535 7.55717 30.8921 7.62012C30.6468 7.23823 30.6791 8.5035 30.4682 8.06286C27.6089 10.1884 25.6575 18.1305 29.9605 10.2933C29.2032 10.755 29.655 10.0667 30.0014 9.86531C30.0164 10.6459 30.8125 9.17706 30.8835 8.83294C30.5349 9.18965 30.8211 8.32305 30.8706 8.7469H30.8727Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.4539 9.44771C22.7616 9.10779 21.8924 5.59104 21.8515 5.21544C21.6105 4.42858 20.8145 5.12521 21.1393 5.67916C21.1544 5.81345 21.5782 6.64018 21.1523 6.52478C20.651 7.28856 21.7009 8.4804 21.2297 9.07841C21.4664 9.13926 21.4535 9.50015 21.5976 9.5547C21.419 9.69529 21.546 9.99324 21.6041 9.97436C21.4771 11.1914 22.9939 11.0004 22.5572 9.85687C22.6196 9.86316 22.6648 9.54211 22.4561 9.44979L22.4539 9.44771Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.89582 13.5226C9.97328 14.171 9.60108 13.7702 9.56665 13.4534C10.1648 13.5184 9.38593 12.763 9.09763 12.656C9.16217 12.7505 9.03523 12.8994 8.89108 12.7127C9.38162 12.5364 7.53133 10.1968 7.64106 11.8985C7.67548 11.9363 7.99391 11.716 7.93797 11.8356C7.413 12.1189 8.03694 12.2259 8.15742 12.2993C7.91646 12.484 8.21982 12.4063 8.14236 12.5092C7.71636 12.6372 8.74693 12.7987 8.31017 12.9078C8.26284 13.8122 9.7818 14.341 9.67423 15.0879C10.4445 14.9432 11.0533 17.2429 11.5353 15.7951C11.1588 14.8928 10.7908 14.2004 9.89582 13.5226Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.7204 4.88812C10.8297 5.2847 12.3163 6.72834 12.3744 7.3914C12.3787 8.2454 15.5694 14.962 15.8039 12.3853C14.8207 10.3605 14.3775 8.53286 12.8671 6.22473C12.6498 5.83235 12.198 4.43909 11.7204 4.88812Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M32.3961 16.4875C32.4671 17.4003 31.2494 17.1547 31.2537 17.9479C31.4279 19.3391 37.1337 15.3523 36.1612 14.5508C35.2296 13.9717 33.076 16.5253 32.3961 16.4875Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.8656 15.2719L21.3193 19.0913V29.2763L30.8656 33.0957V15.2719Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.7649 19.7256V28.6244H18.773V34.3644H14.9537V28.6244H11.1343V19.7256H23.7649Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.765 19.7256H21.3193V28.62H23.765V19.7256Z",
        fill: primaryColor
    }));

});

parcelRegister("6Je5I", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagAvatar", () => $cc6035f067b1cb38$export$2d7efea536028358);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $cc6035f067b1cb38$export$2d7efea536028358 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_7126_44811)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18.4674 12.327C18.3867 10.7241 18.0617 8.58558 18.0098 7.815C18.427 8.74089 18.2636 6.33955 18.1732 5.9453C18.1348 6.3495 17.9618 6.03691 17.9983 5.76213C18.6174 6.14841 18.1963 -0.402498 17.6542 2.96654C17.5138 4.55548 17.2485 8.03603 17.21 10.5668C17.533 11.8033 18.1367 16.9982 18.4674 12.329V12.327Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.3998 15.0647C12.0115 14.3041 11.5943 13.645 10.7849 12.8386C10.8521 13.5056 10.508 13.0477 10.4772 12.7331C11.054 12.8585 10.2792 11.9923 10.0062 11.8729C10.085 11.9943 9.94468 12.1038 9.81394 11.9187C10.3004 11.8788 8.56619 9.75627 8.40085 10.71C8.62387 11.0445 8.38162 11.1959 8.78152 11.0505C8.34509 11.4368 9.04684 11.4308 9.07568 11.4965C8.80652 11.9226 9.6313 11.9884 9.28523 12.0999C9.41789 12.9122 12.4729 16.8448 12.3998 15.0667V15.0647Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.4909 22.1992C8.60074 21.4624 7.61638 20.9706 6.19943 20.7118C6.78967 21.2773 6.10329 21.0463 5.80337 20.8133C7.12995 20.3096 -0.123965 19.9432 2.62918 21.0921C2.75222 20.4589 2.66763 21.2812 3.03869 21.0483C3.32323 20.8412 3.59431 20.9089 3.58855 21.0722C3.58662 21.2534 4.34989 20.7735 4.14225 21.116C4.77863 21.2155 10.9559 23.7264 9.4909 22.1992Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.58349 28.6863C7.55683 29.0327 6.60901 29.5803 5.69193 30.6356C6.45136 30.4265 5.89187 30.9084 5.55926 31.0159C5.89379 29.5544 1.74295 35.4801 4.11157 33.8055C3.64054 33.3555 4.30767 33.8712 4.29421 33.4431C4.48455 32.5292 5.3824 32.5909 6.10529 31.5276C6.51481 30.8287 10.2254 28.8993 8.58349 28.6883V28.6863Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.6205 20.3191C37.54 20.2215 36.5883 20.2295 35.206 20.3589C36.0019 20.7432 34.9541 20.789 34.8599 20.4585C35.504 20.2793 33.8294 20.2056 33.6602 20.3788C33.8755 20.4027 33.7813 20.5859 33.5429 20.56C33.7217 20.0941 29.4863 20.11 31.73 21.0419C31.7992 21.0299 31.7511 20.6675 31.8568 20.777C31.8261 21.3724 32.4394 20.8328 32.5221 20.8547C32.5874 21.3166 33.4737 20.775 33.2661 21.0936C33.7121 21.6412 40.6834 21.2928 38.6186 20.3191H38.6205Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.6322 9.25067C28.5534 8.19337 29.5916 7.45664 29.7858 6.39536C29.3743 4.68495 26.1079 11.2637 27.1788 10.0292C27.4998 9.63696 23.7239 15.4969 25.0735 15.5009C25.1216 15.6084 25.5888 14.9434 25.5003 14.8956C25.4138 14.808 25.2831 14.7881 25.3734 14.7064C25.8945 14.9533 25.6945 13.9896 25.758 13.8921C26.7519 13.2191 27.396 10.4792 28.6341 9.24671L28.6322 9.25067Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.5431 28.7838L15.8442 14.8184L33.301 12.6947L28.9134 20.3145L34.9999 26.6602L17.5431 28.7838Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.226 15.1368L9.73462 15.5615L12.3891 37.3825L15.8805 36.9578L13.226 15.1368Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.4516 36.575C24.5175 36.3381 24.2405 37.4215 24.0948 35.5869C23.9577 34.7433 23.3407 34.9773 23.1294 35.2575C23.0008 35.4251 23.4007 36.2225 23.2436 36.2976C23.2436 36.2976 23.2608 36.9563 23.3036 37.3146C23.2579 36.9332 21.824 37.1412 21.1613 37.4243C21.1613 37.4243 20.6901 38.005 21.3584 38.3604C21.3984 38.3488 22.6838 38.1842 23.0494 38.3257C23.6492 38.7533 23.1865 38.8631 23.295 39.3254C23.4036 39.7847 23.3921 41.8158 24.6832 40.6312C24.7318 39.7067 24.7232 39.5276 24.5575 38.2564C24.7632 37.9068 25.0774 37.6555 25.5515 37.7364C25.8029 37.6613 25.8515 36.3698 25.4544 36.575H25.4516Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.2653 33.6133C30.0565 33.9889 31.0505 33.3475 31.5218 34.1391C30.9191 33.8907 30.9991 37.086 31.9931 36.3291C32.1131 35.8321 32.4015 35.8928 31.8931 35.7224C32.7472 35.7166 31.9531 35.1677 31.9817 35.0897C32.4472 35.0781 31.8388 34.8123 32.2816 34.9048C32.5386 34.8528 31.7874 34.1941 32.2959 34.3703C32.4587 33.6538 33.2527 33.6595 33.0756 33.2233C33.0842 33.5209 35.7235 33.5902 34.9922 32.4519C34.5295 32.475 34.5895 31.9492 34.5209 32.6339C34.381 31.7846 34.0696 32.6339 33.9954 32.6137C33.9268 32.137 33.7897 32.7957 33.8097 32.3306C33.7412 32.0792 33.2956 32.8824 33.3841 32.3566C31.8446 31.9492 33.1071 31.5101 32.2187 30.626C32.1302 30.2158 32.3473 28.8839 31.3961 29.0081C30.145 29.3722 31.6046 31.6459 30.862 32.0417C30.5306 32.3421 30.0593 32.7206 29.4338 32.4635C29.1253 32.4577 28.7283 33.7318 29.2624 33.6162L29.2653 33.6133Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_7126_44811"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "42",
        height: "42",
        fill: "white",
        transform: "translate(0 3)"
    }))));

});

parcelRegister("fksEs", function(module, exports) {

$parcel$export(module.exports, "GenericAvatar", () => $e682c5ed99f8be99$export$dd2d04596094525e);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $e682c5ed99f8be99$export$dd2d04596094525e = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.2653 16.6133C30.0565 16.9889 31.0505 16.3475 31.5218 17.1391C30.9191 16.8907 30.9991 20.086 31.9931 19.3291C32.1131 18.8321 32.4015 18.8928 31.8931 18.7224C32.7472 18.7166 31.9531 18.1677 31.9817 18.0897C32.4472 18.0781 31.8388 17.8123 32.2816 17.9048C32.5386 17.8528 31.7874 17.1941 32.2959 17.3703C32.4587 16.6538 33.2527 16.6595 33.0756 16.2233C33.0842 16.5209 35.7235 16.5902 34.9922 15.4519C34.5295 15.475 34.5895 14.9492 34.5209 15.6339C34.381 14.7846 34.0696 15.6339 33.9954 15.6137C33.9268 15.137 33.7897 15.7957 33.8097 15.3306C33.7412 15.0792 33.2956 15.8824 33.3841 15.3566C31.8446 14.9492 33.1071 14.5101 32.2187 13.626C32.1302 13.2158 32.3473 11.8839 31.3961 12.0081C30.145 12.3722 31.6046 14.6459 30.862 15.0417C30.5306 15.3421 30.0593 15.7206 29.4338 15.4635C29.1253 15.4577 28.7283 16.7318 29.2624 16.6162L29.2653 16.6133Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.7902 28.7278L27.201 27.1386C24.0002 29.572 21.081 32.2138 18.4782 35.0894C14.793 32.0629 11.4735 28.5422 8.47053 24.5922L21.0314 12.0314C24.0681 17.5482 28.2305 21.4951 33.1965 24.3214L28.7902 28.7278ZM19.6147 24.8358L19.6147 28.5444L19.6151 28.5444L21.5003 28.5444L21.5003 24.8358H24.9944L20.5575 20.3988L16.1206 24.8358L19.6147 24.8358ZM27.2009 27.1393L28.79 28.7284L20.698 36.8205C19.9435 36.2635 19.2038 35.6863 18.478 35.0901C21.0806 32.2146 23.9998 29.5729 27.2009 27.1393Z",
        fill: "#CCE0FF"
    }));

});

parcelRegister("fGiBX", function(module, exports) {

$parcel$export(module.exports, "HireWriterAvatar", () => $ea06274cb55976f0$export$4dca011d184814ed);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $ea06274cb55976f0$export$4dca011d184814ed = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36283",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36283)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.3398 21.2886C34.0588 21.4667 36.7798 21.6989 39.4643 22.0919C39.4643 22.0919 40.3092 22.1867 41.2736 22.3299C42.24 22.4674 43.3159 22.6899 43.8062 22.8254C44.1161 22.9029 44.3653 22.9841 44.5538 23.0867C44.649 23.1351 44.7219 23.2009 44.7827 23.2629C44.8394 23.3287 44.8739 23.3906 44.9002 23.4255C44.9286 23.4603 44.9529 23.4661 44.9752 23.4274C44.9975 23.3887 45.0137 23.2996 44.9833 23.1758C44.9509 23.0577 44.8739 22.9222 44.7625 22.8042C44.651 22.6841 44.5112 22.5796 44.3431 22.479C43.6704 22.0822 42.5581 21.7686 40.9048 21.5228C40.8663 21.5054 40.7367 21.4706 40.7225 21.4512C38.9679 21.2402 37.264 21.037 35.5439 20.8473C33.8258 20.6615 32.0955 20.4989 30.3126 20.4312C30.3551 20.4892 30.2356 20.5299 30.1282 20.495L30.1687 20.4273C29.644 20.435 29.1638 20.4273 28.71 20.4157C29.727 19.3666 30.7401 18.2943 31.7025 17.2317C34.3728 14.2838 36.6744 11.4289 37.6996 9.49336C37.9549 9.00754 38.1311 8.57977 38.198 8.20621C38.2304 8.0204 38.2365 7.84426 38.198 7.68941C38.1615 7.53457 38.0785 7.41264 38.0136 7.36619C37.9528 7.3178 37.9346 7.32167 37.9569 7.36813C37.9772 7.41265 38.042 7.51329 38.0542 7.65459C38.0846 7.93524 37.9529 8.28752 37.6976 8.74818C37.7037 8.67463 37.7077 8.59914 37.7077 8.52558C37.493 9.01528 37.2194 9.45077 36.9439 9.87078C36.6643 10.2889 36.3725 10.6876 36.0666 11.0786C35.4547 11.8625 34.7942 12.6231 34.0203 13.44C33.8278 13.6916 33.7913 13.709 33.8541 13.7574C33.8096 13.829 33.7366 13.9509 33.7873 13.9432C33.9595 14.0342 33.4469 14.5238 33.2483 14.76C33.1349 14.4367 31.9942 15.7471 30.7401 17.1891C29.6359 18.4685 28.4486 19.8544 27.9441 20.3944C26.6758 20.3421 25.5533 20.2763 24.1351 20.4137C24.1391 20.4137 24.3823 20.3247 24.3884 20.3228C23.659 20.317 22.9033 20.3112 22.1273 20.3112C21.9247 20.137 21.7261 19.9608 21.5235 19.7866C21.9004 19.4498 22.6156 18.8072 23.424 18.0853C24.6092 17.0149 25.995 15.7723 26.7264 14.9981C28.7809 13.287 30.8758 11.6128 33.066 10.0779C33.066 10.0779 33.7346 9.57464 34.5227 9.02301C35.3088 8.46557 36.2327 7.89847 36.6785 7.66234C36.954 7.50749 37.1911 7.39522 37.3997 7.34297C37.5031 7.31393 37.6044 7.31005 37.6915 7.31199C37.7806 7.32167 37.8495 7.34103 37.8941 7.34684C37.9407 7.35265 37.963 7.3391 37.9488 7.29845C37.9346 7.25587 37.8819 7.1823 37.7685 7.11456C37.6591 7.05262 37.5031 7.01005 37.3369 7.00231C37.1688 6.99263 36.9925 7.01393 36.8 7.05651C36.0301 7.23071 35.013 7.75911 33.6617 8.70366C33.6211 8.71721 33.5036 8.78109 33.4793 8.77722C32.0833 9.81274 30.7259 10.8212 29.3705 11.8489C28.0171 12.8767 26.6738 13.9316 25.3629 15.0871C25.4379 15.0987 25.3811 15.209 25.2798 15.2574L25.2575 15.18C23.6043 16.8136 22.3623 17.6207 20.9785 19.2389C20.9785 19.235 21.0879 19.0085 21.0899 19.0047C21.0231 19.0685 20.9542 19.1324 20.8853 19.1963C20.4943 18.8227 19.8804 18.242 19.1834 17.6111C17.9982 16.5349 16.5678 15.3232 15.6763 14.7155C13.6543 12.9561 11.5938 11.2354 9.41374 9.63853C9.41374 9.63853 8.71878 9.15464 7.87797 8.6514C7.45655 8.39978 6.99867 8.14428 6.57725 7.94298C6.15583 7.73975 5.76885 7.59458 5.51154 7.53458C5.19345 7.45716 4.91386 7.43974 4.73354 7.48813C4.64236 7.50749 4.58561 7.552 4.55725 7.58491C4.53293 7.62362 4.53497 7.65265 4.54713 7.67587C4.55726 7.69717 4.57752 7.71265 4.59575 7.72814C4.61399 7.74362 4.62614 7.76298 4.63627 7.7804C4.6545 7.79976 4.68085 7.80944 4.74771 7.83073C4.81457 7.85008 4.91789 7.88685 5.04756 7.94104C5.57637 8.15395 6.52052 8.67461 7.86785 9.534C7.89419 9.56497 7.99347 9.64628 7.99549 9.6695C9.44008 10.5618 10.755 11.6012 12.0415 12.6773C13.3281 13.7554 14.5842 14.88 15.9052 16.0007C15.9113 15.9291 16.0288 15.9716 16.0876 16.0626L16.0106 16.0916C17.7854 17.4504 18.6911 18.5517 20.2977 19.7518C20.3606 19.8002 20.4234 19.8466 20.4902 19.895C20.4862 19.895 20.2795 19.8118 20.2491 19.7982C20.0668 19.9705 19.8824 20.1447 19.696 20.3208C18.1582 20.3324 16.5617 20.3576 14.9348 20.4041C13.7029 19.1382 12.4569 17.8279 11.2818 16.5407C8.61952 13.6374 6.28752 10.8424 5.20966 9.10237C4.94222 8.67075 4.75581 8.30492 4.67275 8.05523C4.6302 7.93136 4.616 7.84039 4.60993 7.79394C4.60587 7.74942 4.59575 7.73782 4.58967 7.72814C4.57954 7.71652 4.57143 7.70103 4.55725 7.69716C4.54306 7.69523 4.51067 7.68942 4.48028 7.74749C4.40734 7.85975 4.42557 8.21589 4.60589 8.68816C4.55119 8.6359 4.50053 8.58172 4.44786 8.52752C4.64641 9.02109 4.90573 9.46625 5.16507 9.89595C5.42845 10.3237 5.70198 10.736 5.9836 11.1463C6.54685 11.9651 7.13645 12.7819 7.79492 13.6935C8.00765 13.9296 8.01979 13.9684 8.0826 13.918C8.14744 13.9761 8.25482 14.069 8.25887 14.0206C8.38651 13.8793 8.78161 14.46 8.98827 14.6903C8.63168 14.7329 9.76019 16.0684 11.1055 17.4427C12.2928 18.664 13.6442 19.9105 14.1709 20.4292C13.401 20.4544 12.6251 20.4854 11.8491 20.5202C9.62243 20.6247 7.37955 20.7737 5.19141 21.0002C4.09733 21.1144 3.01745 21.248 1.96187 21.4164C0.906293 21.5867 -0.124969 21.7802 -1.12382 22.0803H-1.07925L-1.09342 22.0938C-0.708471 22.0106 0.369384 21.8073 1.35203 21.6854C2.33467 21.5557 3.22613 21.4744 3.22613 21.4744C1.92135 21.8209 0.511198 22.0183 -0.913125 22.3551C-1.26971 22.4441 -1.62628 22.5409 -1.97881 22.6899C-2.02338 22.7074 -2.06594 22.7287 -2.11051 22.7499C-2.16116 22.7712 -2.21384 22.8061 -2.26652 22.8332C-2.36985 22.8932 -2.46711 22.9629 -2.55018 23.0422C-2.63324 23.1235 -2.70011 23.2164 -2.73658 23.3229C-2.77508 23.4293 -2.77102 23.5474 -2.73658 23.6539C-2.65959 23.8648 -2.47723 24.0332 -2.26449 24.1648C-2.14901 24.2403 -2.06796 24.279 -1.98287 24.3216C-1.89575 24.3642 -1.80864 24.401 -1.72152 24.4397C-1.37304 24.581 -1.02049 24.6874 -0.669982 24.7745L-0.71455 24.8578C-1.01846 24.7784 -1.31629 24.6952 -1.59791 24.5984C-1.73973 24.5481 -1.87549 24.4997 -2.00921 24.4416C-2.07607 24.4145 -2.1409 24.3836 -2.20776 24.3507C-2.29083 24.3081 -2.382 24.2539 -2.46102 24.2036C-2.78519 23.9926 -2.96552 23.7042 -2.95742 23.4313C-2.95134 23.1584 -2.80142 22.9706 -2.68593 22.8448C-2.84599 22.9958 -2.97766 23.1816 -2.9959 23.4061C-3.02021 23.6306 -2.93512 23.8532 -2.77507 24.0371C-2.73049 24.0816 -2.68794 24.1281 -2.63931 24.1706C-2.58663 24.2113 -2.536 24.2539 -2.4813 24.2926L-2.30703 24.4029L-2.16725 24.4784C-2.00111 24.5616 -1.83498 24.6333 -1.66681 24.6971C-0.992135 24.9487 -0.270856 25.1229 0.486892 25.2797C2.00036 25.5855 3.6516 25.8004 5.30082 25.9649C8.36625 26.2688 12.465 26.3597 12.2502 26.1991C12.7345 26.2184 13.2167 26.2301 13.6948 26.2417C13.6502 26.2881 13.5307 26.4101 13.5307 26.4101C13.1437 26.8088 12.7567 27.2114 12.3718 27.6179C10.8745 29.1953 9.39753 30.8154 8.01981 32.4548C7.33095 33.2755 6.6664 34.0981 6.04439 34.9304C5.42442 35.7646 4.83889 36.5969 4.35264 37.4853L4.38301 37.4543V37.4756C4.59372 37.1582 5.2056 36.2833 5.81139 35.5343C6.41111 34.7794 6.98043 34.1194 6.98043 34.1194C6.31386 35.2459 5.46292 36.3375 4.70517 37.5395C4.5208 37.8434 4.33845 38.1531 4.19865 38.4957C4.18042 38.5383 4.16624 38.5828 4.15003 38.6273C4.12977 38.6757 4.11759 38.7356 4.10138 38.7918C4.07099 38.904 4.05479 39.0182 4.05479 39.1324C4.05479 39.2447 4.0791 39.357 4.13178 39.4576C4.18243 39.5583 4.27362 39.6396 4.37695 39.6918C4.58766 39.7906 4.84092 39.7847 5.0881 39.7364C5.22384 39.7112 5.31095 39.6841 5.40415 39.657C5.49735 39.6299 5.58649 39.597 5.67564 39.5641C6.02615 39.4286 6.35437 39.266 6.66638 39.0918L6.69678 39.1808C6.42326 39.3299 6.14974 39.4712 5.88027 39.5951C5.74452 39.6551 5.6108 39.7131 5.47303 39.7634C5.40617 39.7886 5.33728 39.8118 5.26637 39.8331C5.17722 39.8602 5.07188 39.8835 4.97868 39.9009C4.59373 39.9706 4.25131 39.8893 4.05479 39.6899C3.85826 39.4925 3.82383 39.2583 3.81167 39.0918C3.80964 39.3066 3.85421 39.5273 4.00819 39.6976C4.15609 39.8718 4.381 39.9725 4.63223 39.9957C4.69707 39.9957 4.75987 40.0015 4.82673 39.9996C4.89359 39.9919 4.96045 39.988 5.02934 39.9783C5.09822 39.9647 5.16508 39.9512 5.23397 39.9377L5.38795 39.897C5.56625 39.8448 5.73642 39.7828 5.90458 39.7131C6.56913 39.4344 7.20735 39.0725 7.85771 38.6718C9.15439 37.8666 10.4815 36.9008 11.768 35.9059C14.3411 33.9103 16.7481 31.7774 18.2474 30.347C18.1157 30.3683 17.2627 31.3303 16.8575 31.3767C17.6578 30.678 18.4257 29.9483 19.1712 29.2805C19.2786 29.3889 18.8126 29.7373 18.7458 29.8341C18.9767 29.6618 19.8966 28.8779 21.2074 27.6934C22.8769 29.3928 24.903 31.2838 27.1823 33.2232C28.4749 34.3226 29.8486 35.4394 31.3013 36.5272C32.0266 37.0711 32.7742 37.6092 33.5462 38.126C34.3242 38.6408 35.1143 39.144 35.9997 39.5679C36.2226 39.6725 36.4536 39.7712 36.7068 39.8525C36.7372 39.8641 36.7696 39.8738 36.8041 39.8815L36.9155 39.9125C37.0148 39.9299 37.1141 39.9609 37.2133 39.9667C37.4119 39.9957 37.6064 39.9822 37.7807 39.926C37.9529 39.8699 38.1089 39.7557 38.2041 39.6047C38.3054 39.4576 38.3419 39.2795 38.3419 39.0957C38.3479 39.0047 38.3277 38.9079 38.3155 38.815L38.2831 38.6737C38.273 38.6273 38.2588 38.575 38.2487 38.546C38.2102 38.4183 38.1616 38.304 38.1129 38.1898C37.9144 37.7389 37.6753 37.3343 37.4261 36.9414C37.1769 36.5485 36.9155 36.171 36.646 35.7994C35.5702 34.3207 34.4153 32.9464 33.2808 31.6302C31.6822 29.7857 30.114 28.0669 28.6715 26.4914C30.1849 26.4372 31.7146 26.3617 33.1997 26.2591C37.2701 25.9784 41.0102 25.5159 43.17 24.8384C43.7089 24.6662 44.1506 24.4823 44.4748 24.2655C44.6348 24.1571 44.7706 24.0351 44.8577 23.8997C44.9468 23.7642 44.9772 23.6229 44.9671 23.5474C44.961 23.4719 44.9448 23.4622 44.9246 23.5106C44.9063 23.5551 44.8759 23.6713 44.7807 23.7777C44.5943 23.9965 44.2397 24.1571 43.719 24.31C43.7778 24.2616 43.8365 24.2113 43.8912 24.159C43.3786 24.3603 42.862 24.4842 42.3555 24.5945C41.849 24.701 41.3465 24.7861 40.842 24.8558C39.829 24.9971 38.7998 25.09 37.6469 25.1423C37.3248 25.1887 37.2863 25.1791 37.2964 25.2545C37.2113 25.2758 37.0715 25.3126 37.112 25.3397C37.1667 25.5197 36.4414 25.5197 36.1254 25.5526C36.2854 25.2468 34.5086 25.4036 32.5554 25.5758C30.8069 25.7365 28.9186 25.9165 28.1812 25.9552C27.7435 25.4772 27.316 25.0087 26.9088 24.5597L26.9432 24.6429C26.8885 24.5732 26.6839 24.3894 26.6657 24.3158C26.4185 24.1145 26.0659 23.8068 25.6891 23.4738C26.4023 22.777 27.1357 22.0473 27.8732 21.3002C29.18 21.3331 30.501 21.3583 31.3418 21.3157L31.3398 21.2886ZM43.2105 22.4732C43.251 22.3919 43.482 22.4306 43.5124 22.5351C43.4658 22.5874 43.1882 22.5564 43.1821 22.448C43.1821 22.4519 43.1902 22.4635 43.2105 22.4732ZM34.3525 21.1067C34.7436 21.1957 33.9514 21.2789 33.7792 21.1976C33.8683 21.126 34.1986 21.0989 34.3525 21.1067ZM10.1107 16.1807L10.0337 16.0955C10.0418 16.0839 10.0661 16.0878 10.0864 16.1013C10.1066 16.1091 10.1391 16.1323 10.1553 16.1555L10.1127 16.1807H10.1107ZM24.358 23.6655C23.896 24.1416 23.3936 24.6603 22.9195 25.1423C22.6723 25.3939 22.4312 25.6359 22.2103 25.8585C21.8477 25.872 21.481 25.8836 21.1284 25.8933C20.9157 25.8991 20.707 25.9049 20.5064 25.9107C20.1539 25.572 19.7831 25.2139 19.3982 24.8384C18.9382 24.3913 18.456 23.919 17.9597 23.4293C17.9799 23.408 18.0022 23.3848 18.0225 23.3635C18.61 22.7403 19.1145 22.2274 19.1145 22.2274C19.4184 21.9099 19.7284 21.5964 20.0343 21.2809C20.3768 21.2673 20.5956 21.2615 20.5956 21.2615C20.9967 21.2441 21.3979 21.2286 21.8011 21.215C22.6318 21.9951 23.4888 22.8158 24.36 23.6674L24.358 23.6655ZM15.9093 25.632C15.9984 25.5488 16.0896 25.4636 16.1767 25.3823L16.0937 25.4191C16.1646 25.363 16.3429 25.1597 16.4199 25.1404C16.6508 24.8539 17.0317 24.4281 17.4349 23.9887C17.9252 24.4436 18.4641 24.9333 18.9727 25.3881C19.1814 25.5759 19.384 25.7559 19.5745 25.9281C18.4723 25.9436 17.9273 25.9165 18.8329 25.8062C17.9192 25.7462 16.9406 25.6901 15.9093 25.632ZM16.0957 21.4783C16.1869 21.486 16.4644 21.4648 16.5333 21.5015C17.0155 21.4415 17.8361 21.3854 18.6161 21.3428C18.1562 21.7841 17.6902 22.2351 17.2201 22.6938C16.8311 22.3067 16.4381 21.9099 16.039 21.5054C16.0856 21.5054 16.1362 21.5054 16.1828 21.5054L16.0957 21.4744V21.4783ZM4.06087 21.306H4.04264L4.0325 21.217C4.73555 21.0505 4.84496 21.2751 4.06087 21.306ZM0.140443 25.0745C0.0553484 25.0552 0.0371048 25.0339 -0.0459638 25.0049C-0.0641983 24.8539 0.432182 25.03 0.582111 25.0436C0.472703 25.0513 0.264035 25.1036 0.142471 25.0745H0.140443ZM9.61635 25.2584C7.9023 25.1403 6.12138 25.001 4.3121 24.8016C3.40848 24.7029 2.49676 24.5868 1.58908 24.4436C0.685459 24.2965 -0.228301 24.13 -1.07519 23.8687C-1.28388 23.8029 -1.48853 23.7293 -1.6729 23.6461C-1.69721 23.6364 -1.71949 23.6248 -1.73975 23.6151L-1.79243 23.59C-1.80661 23.5822 -1.81876 23.5764 -1.83294 23.5667C-1.85928 23.5513 -1.88359 23.5319 -1.90385 23.5068C-1.95045 23.4564 -1.91602 23.3848 -1.86536 23.35C-1.85321 23.3403 -1.84104 23.3306 -1.82686 23.3229L-1.8066 23.3113C-1.8066 23.3113 -1.79649 23.3055 -1.7742 23.2938C-1.69113 23.2493 -1.59386 23.2067 -1.49864 23.1661C-1.10558 23.0074 -0.669973 22.8835 -0.230318 22.7771C0.209338 22.6687 0.659121 22.5777 1.10891 22.4964C2.9121 22.1731 4.72947 21.9777 6.49215 21.8267C9.56771 21.5731 12.4873 21.4783 15.0644 21.4957C15.4393 21.848 15.8485 22.2138 16.0086 22.4519C15.9721 22.4286 15.7371 22.2874 15.7067 22.2699C15.7594 22.3822 16.1301 22.7577 16.6488 23.2551C15.8911 24.0003 15.1232 24.7648 14.3553 25.5468C12.856 25.4636 11.2656 25.3726 9.61229 25.2584H9.61635ZM7.45858 33.4284L7.44844 33.4419L7.37348 33.3839C7.7483 32.7916 7.99144 32.8767 7.45858 33.4284ZM15.0989 26.3946C15.9133 26.4488 20.5753 26.5611 20.2775 26.5572C20.4841 26.7449 20.7718 27.0178 20.7718 27.0178L20.6948 27.0817C20.6948 27.0817 20.6786 27.0953 20.6685 27.103C18.8066 28.6669 16.667 30.5173 14.3087 32.4703C13.01 33.5445 11.6465 34.6497 10.2201 35.7317C9.50693 36.2717 8.77754 36.8059 8.02992 37.3169C7.2823 37.824 6.5124 38.3215 5.72223 38.7105C5.5257 38.8053 5.32717 38.8924 5.13469 38.9563C5.11038 38.966 5.08605 38.9718 5.06376 38.9796L5.00705 38.997C4.99287 39.0008 4.97664 39.0047 4.96246 39.0086C4.93207 39.0144 4.89966 39.0183 4.86927 39.0144C4.79836 39.0105 4.77 38.937 4.78013 38.877C4.78013 38.8615 4.78417 38.846 4.78619 38.8325L4.79228 38.8092C4.79228 38.8092 4.79431 38.7976 4.80242 38.7744C4.82876 38.6854 4.86522 38.5925 4.90372 38.4976C5.06378 38.1202 5.28057 37.7369 5.51357 37.3653C5.74454 36.9917 5.99578 36.624 6.25309 36.262C7.2884 34.8143 8.42907 33.4478 9.56367 32.1529C11.4499 30.0102 13.3402 28.0688 15.0989 26.3965V26.3946ZM34.152 33.8349L34.1621 33.8484L34.0851 33.9045C33.5725 33.4264 33.7143 33.2194 34.1499 33.8349H34.152ZM31.1331 30.1437C31.4532 30.4902 31.7956 30.8735 32.1178 31.2412L32.0327 31.2877C31.7004 30.918 31.3742 30.5541 31.0521 30.1941L31.1331 30.1437ZM34.8996 37.7698C33.6718 36.9685 32.3771 36.0046 31.1088 35.0194C28.5702 33.0471 26.1368 30.9741 24.5423 29.6579C24.5727 29.7837 25.6385 30.5135 25.7256 30.8909C24.9253 30.198 24.1108 29.5224 23.3733 28.8508C23.4787 28.7444 23.8697 29.1644 23.9751 29.2205C23.7907 29.0192 22.9782 28.2605 21.7889 27.1282C21.9855 26.9482 22.1901 26.7604 22.3988 26.5669C23.8981 26.5669 25.527 26.5494 27.2026 26.503C27.784 27.0991 28.3675 27.703 28.947 28.3147C30.4321 29.8825 31.897 31.489 33.2727 33.0955C33.9595 33.8987 34.624 34.702 35.246 35.5033C35.864 36.3046 36.4536 37.1059 36.9236 37.9053L36.9155 37.8686L36.9337 37.8782C36.8061 37.5608 36.2976 36.6762 35.7606 35.9001C35.2318 35.12 34.7091 34.433 34.7091 34.433C35.6533 35.3369 36.5083 36.444 37.1667 37.6595C37.3268 37.9634 37.4747 38.277 37.574 38.5925C37.5882 38.6312 37.5963 38.6699 37.6064 38.7105C37.6165 38.7434 37.6186 38.7686 37.6246 38.7995C37.6348 38.8557 37.6408 38.9137 37.6388 38.9679C37.6388 39.0763 37.5861 39.1964 37.4686 39.2254C37.3572 39.2544 37.2417 39.2292 37.1404 39.2002C37.0999 39.1886 37.0148 39.1615 36.9358 39.1324C36.8588 39.1053 36.7798 39.0724 36.7028 39.0395C36.3908 38.904 36.0848 38.7454 35.783 38.5808L35.8478 38.5111C36.1071 38.6544 36.3624 38.7802 36.6055 38.8828C36.7271 38.9312 36.8446 38.9776 36.956 39.0125C37.0107 39.0318 37.0675 39.0454 37.1161 39.057C37.1465 39.0647 37.1647 39.0647 37.187 39.0686C37.2721 39.0783 37.3511 39.0647 37.3815 39.0105C37.4099 38.9563 37.3896 38.9041 37.3775 38.875C37.3775 38.9099 37.3714 38.9467 37.345 38.9718C37.3187 38.9989 37.2741 39.0008 37.2377 38.995C37.2194 38.9911 37.2012 38.9873 37.1829 38.9815C37.1485 38.9699 37.1161 38.9602 37.0816 38.9486C36.954 38.904 36.8183 38.8499 36.6785 38.786M26.5745 25.8623C26.1125 25.8933 25.6526 25.9223 25.3994 25.8778C25.4419 25.8662 25.7094 25.7965 25.7438 25.7888C25.5635 25.7365 24.4876 25.7733 23.2112 25.8197C23.3085 25.7288 23.4057 25.6378 23.505 25.543C23.9588 25.1171 24.4289 24.6681 24.9151 24.2016C25.4662 24.7455 26.0193 25.2991 26.5765 25.8623H26.5745ZM25.9322 22.2525C25.9545 22.2157 26.0923 21.9873 26.1085 21.9564C25.995 22.0144 25.6101 22.3919 25.0975 22.9106C25.0144 22.8351 24.9313 22.7616 24.8503 22.6899C24.208 22.1131 23.6711 21.6273 23.6711 21.6273C23.4949 21.4725 23.3146 21.3196 23.1383 21.1647C23.3389 21.1589 23.5394 21.1512 23.738 21.1454C23.738 21.1454 25.0975 21.1879 26.7264 21.2383C26.7953 21.2383 26.8662 21.2421 26.9372 21.2441C26.5745 21.637 26.1875 22.0841 25.9322 22.2525Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31 14.1206H11V37.1206H31V14.1206Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.5175 32.4831C17.5175 30.4837 19.1362 28.865 21.1356 28.865C23.135 28.865 24.7537 30.4837 24.7537 32.4831V37.1337H17.5175V32.4831Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.2374 24.2144C24.2374 25.925 22.8506 27.3163 21.1356 27.3163C19.4206 27.3163 18.0337 25.9294 18.0337 24.2144C18.0337 22.4994 19.4206 21.1125 21.1356 21.1125C22.8506 21.1125 24.2374 22.4994 24.2374 24.2144Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.2037 11.5725V16.9581H14.7306V11.5725H18.3968C18.3968 10.1506 19.5475 9 20.9693 9C22.3912 9 23.5375 10.1506 23.5375 11.5725H27.2037Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.2037 14.4537H14.7306V17.9581H27.2037V14.4537Z",
        fill: primaryColor
    }));

});

parcelRegister("54k0x", function(module, exports) {

$parcel$export(module.exports, "MarketingMessageMaestroAvatar", () => $8e8aba828f528df3$export$981f8dc258625637);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $8e8aba828f528df3$export$981f8dc258625637 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_41146",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_41146)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.8146 33.2372C42.8863 26.2593 41.6736 20.7329 40.7508 17.0853C41.2687 15.0932 35.744 6.57273 37.391 11.9803C39.4893 14.2246 40.9099 22.1599 39.2797 26.6694C40.3775 27.8999 35.5039 36.4685 38.8144 33.2338L38.8146 33.2372Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.4493 29.7688C37.6984 27.0185 37.2267 23.1905 36.9474 21.6173C37.7975 22.8484 37.2465 19.476 36.8197 18.9481C36.8839 19.4831 36.5196 19.221 36.4571 18.7768C37.3824 18.5829 34.8601 12.8143 33.8218 14.4824C34.2377 15.1759 33.9231 15.5506 34.6706 15.5721C33.8085 15.9813 35.1115 16.6446 35.2234 16.884C35.0807 17.4173 34.8669 17.416 35.4162 18.0683C35.468 18.9811 35.2885 20.3008 35.6629 21.8181C35.8553 23.9518 35.255 25.1507 35.183 26.929C34.948 27.6898 33.3874 31.5119 35.443 29.7759L35.4493 29.7688Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.8448 26.7481C32.6747 25.6506 33.1238 24.2986 32.9003 22.4529C32.2919 23.2685 32.2675 22.5394 32.5537 22.0249C33.3266 22.9708 32.9746 19.8767 32.4045 20.7103C32.2439 20.5107 32.3221 20.2739 32.5001 20.4221C32.9653 19.2342 30.1673 15.8412 30.8921 18.6887C31.3443 18.5283 30.2507 19.1021 31.3712 19.419C31.092 19.8792 30.9183 19.7476 31.363 20.1129C31.3592 20.5238 30.8977 21.358 31.269 22.1618C31.6128 23.3172 30.6023 23.8022 31.2574 24.6471C30.834 25.1963 30.499 27.72 31.8479 26.7412L31.8448 26.7481Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.920702 17.5408C-1.78535 25.153 0.431775 30.3585 2.01544 33.7715C1.87621 35.8251 8.88604 43.1724 6.26425 38.1643C3.7859 36.3484 0.917413 28.8145 1.68244 24.0808C0.375448 23.0754 3.57425 13.7513 0.921512 17.5441L0.920702 17.5408Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.87117 20.3245C3.17154 23.4444 4.34544 27.1183 4.91179 28.6124C3.848 27.5605 5.01524 30.7721 5.53265 31.2116C5.3702 30.6978 5.7768 30.8877 5.92067 31.3126C5.04745 31.6749 8.59637 36.8753 9.30712 35.0434C8.76974 34.4391 9.00934 34.0125 8.27079 34.1301C9.04207 33.568 7.6386 33.158 7.48415 32.9436C7.52545 32.393 7.73577 32.3547 7.07501 31.8157C6.85471 30.9284 6.78621 29.5982 6.13668 28.1767C5.55174 26.1158 5.91907 24.8263 5.65989 23.0655C5.74963 22.2744 6.57387 18.229 4.87613 20.3163L4.87117 20.3245Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.9736 22.6239C8.36179 23.8563 8.17141 25.2681 8.73353 27.0403C9.18004 26.1259 9.33932 26.8379 9.15349 27.3966C8.21851 26.6105 9.13863 29.5855 9.54412 28.6606C9.73897 28.827 9.70608 29.0741 9.50366 28.9616C9.26701 30.2152 12.646 33.03 11.4054 30.3665C10.9908 30.608 11.959 29.8412 10.7991 29.7378C10.9881 29.2337 11.1832 29.3308 10.6783 29.0544C10.6058 28.6499 10.9045 27.7446 10.3905 27.0237C9.83831 25.9521 10.7413 25.288 9.94069 24.5794C10.2548 23.9612 10.1157 21.4191 8.97193 22.6312L8.9736 22.6239Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.7573 33.1935C26.7668 32.8779 26.7428 32.5452 26.6902 32.1992C26.6376 31.8532 26.556 31.5204 26.4524 31.2175C25.8372 29.4126 24.3747 28.4667 22.522 28.4475C22.207 28.4423 21.8787 28.4656 21.5413 28.5169C21.2039 28.5682 20.8575 28.6475 20.546 28.7524C18.784 29.33 17.6724 30.6629 17.6158 32.5611C17.607 32.8811 17.6273 33.2187 17.6806 33.5691C17.7339 33.9194 17.8135 34.2392 17.9121 34.5384C18.5253 36.3303 19.9835 37.2769 21.8418 37.3041C22.1698 37.3073 22.5118 37.2863 22.8621 37.2331C23.2125 37.1798 23.5156 37.1071 23.8191 37.0079C25.5824 36.4389 26.7014 35.096 26.7486 33.1948L26.7573 33.1935Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.83 23.2208L31.0927 31.5253L13.2725 34.2348L12.0098 25.9302C11.1733 20.4285 12.7616 17.1955 15.8738 15.6027C15.8639 15.5378 15.8541 15.4729 15.8436 15.4037C15.8008 15.1226 15.7866 14.8548 15.7917 14.5974C15.835 13.0773 16.7257 12.0082 18.1421 11.545C18.3907 11.4629 18.655 11.3962 18.9404 11.3528C19.2086 11.312 19.4714 11.2942 19.7245 11.3C21.209 11.3132 22.3822 12.073 22.8766 13.5201C22.958 13.7644 23.0197 14.025 23.0625 14.3061C23.0723 14.371 23.0822 14.4359 23.0834 14.5021C26.7044 15.0623 29.1948 17.6751 29.8343 23.2201L29.83 23.2208Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.6938 32.1942L17.6928 33.5627C17.6396 33.2124 17.6162 32.884 17.6294 32.5634C17.6816 30.6659 18.7976 29.3323 20.5552 28.7553C20.8674 28.6548 21.2002 28.5732 21.5505 28.5199C21.9009 28.4666 22.2119 28.4459 22.5312 28.4505C24.3839 28.4697 25.8421 29.4162 26.4573 31.2212C26.5652 31.5234 26.6405 31.8438 26.6938 32.1942Z",
        fill: primaryColor
    }));

});

parcelRegister("bTTug", function(module, exports) {

$parcel$export(module.exports, "MyUserManualAvatar", () => $7b3bc412acf3f8c5$export$b7a39f103e11c638);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $7b3bc412acf3f8c5$export$b7a39f103e11c638 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38527",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38527)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57 26.9465C52.3092 27.9804 46.9066 27.0919 42.7987 24.3569C49.4591 12.2437 30.5884 14.1409 40.5928 24.3095C35.7026 27.8982 27.4469 29.0997 22.5597 24.9608C33.6931 11.6809 15.4207 11.7663 20.4643 24.6984C19.8722 25.4984 13.7793 28.9132 10.6562 28.4863C11.3189 28.6539 12.4018 28.2998 13.0645 28.5685C11.5919 28.8152 10.061 28.831 8.66207 28.5495C8.72957 28.3156 9.52415 28.5338 9.65607 28.499C8.45959 28.382 4.93457 27.2595 3.73195 25.7355C5.38862 24.2684 9.67755 21.0559 7.70489 18.5169C6.29365 17.3597 4.62778 17.6126 3.19813 18.6244C3.23188 18.5706 3.52026 18.245 3.56628 18.2039C1.14877 19.3516 0.593479 23.2882 2.18265 25.4193C-1.47122 27.9583 -5.98411 30.7724 -10 30.3139C-9.99386 30.6617 -9.16553 30.7945 -8.34947 30.8704L-8.65932 31C-4.75388 30.7629 -1.01717 29.2009 1.75008 26.6461C1.75928 26.8928 2.21027 26.741 2.89748 26.3109C3.14904 26.7283 5.56962 28.2935 3.87921 27.4303C8.21416 31.8474 18.3751 29.3274 21.4736 26.0327C25.9835 30.2665 33.3066 29.5803 38.5435 27.7053H38.4023C39.6019 27.2722 40.6665 26.4785 41.9427 25.3118C45.1364 27.6041 54.7788 30.6364 57 26.9402V26.9465ZM3.01099 24.7838C1.03833 22.0424 4.17373 17.1257 7.24163 19.3516C7.3214 21.5997 4.46825 23.3799 3.01099 24.7838ZM21.2558 23.9205C21.2558 23.9205 21.2681 23.9048 21.2742 23.8984C19.1328 21.5049 21.1607 14.7827 24.6489 16.4206C24.0722 15.94 22.7468 16.6988 22.4462 17.0403C27.318 14.3812 22.7928 22.6684 21.2558 23.9205ZM42.6729 21.2804C42.4888 22.0361 42.0685 22.8013 41.5316 23.4052C40.6511 22.678 39.786 21.7262 39.3595 20.6575C39.2982 20.7429 39.1693 20.6385 39.1847 20.4962L39.3013 20.5026C38.1723 18.3051 40.8107 15.9463 42.4213 18.0363C42.4213 18.0236 42.1759 17.8909 42.1636 17.8972C42.7496 18.8805 42.9459 20.1516 42.6729 21.2804Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.9869 15.9675V33.7388C30.52 34.4607 25.5937 36.0882 21 38.7219C16.4106 36.0882 11.48 34.4607 7.01312 33.7388V15.9675C12.6919 16.5582 17.4694 18.4744 21 20.8719C24.535 18.4788 29.3081 16.5582 34.9869 15.9675Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.0444 10.0525H22.9513L24.1806 13.3337L27.6369 12.7606L29.5925 16.1469L27.3656 18.8506L29.5925 21.5544L27.6369 24.9406L24.1806 24.3675L22.9513 27.6487H19.0444L17.815 24.3675L14.3588 24.9406L12.4031 21.5544L14.63 18.8506L12.4031 16.1469L14.3588 12.7606L17.815 13.3337L19.0444 10.0525ZM21 22.145C22.82 22.145 24.2988 20.6706 24.2988 18.8462C24.2988 17.0219 22.8244 15.5475 21 15.5475C19.1756 15.5475 17.7013 17.0219 17.7013 18.8462C17.7013 20.6706 19.1756 22.145 21 22.145Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.37 18.8462L28.6869 17.245C27.1119 17.7262 25.6419 18.3125 24.29 18.9731C24.2288 20.7362 22.7806 22.1406 21 22.1406C19.2194 22.1406 17.7756 20.7362 17.7144 18.9775C16.3625 18.3125 14.8969 17.7262 13.3175 17.245L14.6344 18.8462L12.4075 21.55L14.3631 24.9319L17.8194 24.3587L19.0488 27.64H22.9556L24.185 24.3587L27.6413 24.9362L29.5925 21.55L27.37 18.8462Z",
        fill: primaryColor
    }));

});

parcelRegister("8zvm7", function(module, exports) {

$parcel$export(module.exports, "OkrOracleAvatar", () => $d4339908d67ae7d0$export$b39cc14a70af21b3);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $d4339908d67ae7d0$export$b39cc14a70af21b3 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_35871",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_35871)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.0672 6.71876C25.3431 2.95696 20.5959 3.71388 17.4568 4.31657C15.7916 3.78529 8.29655 8.02982 12.9638 6.90157C14.969 5.24204 21.7699 4.42513 25.5174 6.01325C26.6142 5.14778 33.6494 9.66079 31.0644 6.71876H31.0672Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.9625 9.38656C25.7374 7.36142 22.4669 7.57567 21.1187 7.73562C22.2041 7.07866 19.3163 7.38142 18.8479 7.71561C19.3049 7.68704 19.065 7.98126 18.6851 8.01268C18.5651 7.22433 13.5494 9.07236 14.9148 10.0264C15.5232 9.70932 15.8259 9.99212 15.8802 9.36372C16.1858 10.1092 16.8113 9.0438 17.0198 8.96097C17.4654 9.10664 17.454 9.28659 18.0339 8.85528C18.8108 8.85528 19.9219 9.06952 21.2272 8.82673C23.0467 8.76674 24.035 9.32945 25.5403 9.47512C26.1744 9.70934 29.3421 11.2061 27.9682 9.39228L27.9625 9.38656Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.2261 12.2772C24.3349 11.526 23.2095 11.0833 21.6328 11.1832C22.2955 11.7345 21.6757 11.7202 21.253 11.4546C22.0927 10.849 19.4506 10.9976 20.1305 11.5174C19.9534 11.6431 19.7562 11.566 19.8905 11.4232C18.9051 10.9747 15.8916 13.1684 18.3424 12.6943C18.2281 12.3058 18.6623 13.2541 18.9851 12.3258C19.3621 12.5828 19.2421 12.7228 19.5734 12.3658C19.9219 12.3886 20.6074 12.8171 21.3072 12.5429C22.3041 12.3086 22.6669 13.1827 23.4152 12.6714C23.8608 13.0541 25.9859 13.4569 25.2204 12.2743L25.2261 12.2772Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M33.2237 14.725H8.77625V30.7332H33.2237V14.725Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.5669 32.925V35.6463H14.4331V32.925H18.8081V28.0425H23.1919V32.925H27.5669Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.1919 28.0425H18.8081V30.7375H23.1919V28.0425Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21 26.5288C23.0973 26.5288 24.7975 24.8286 24.7975 22.7313C24.7975 20.634 23.0973 18.9338 21 18.9338C18.9027 18.9338 17.2025 20.634 17.2025 22.7313C17.2025 24.8286 18.9027 26.5288 21 26.5288Z",
        fill: primaryColor
    }));

});

parcelRegister("8zaiw", function(module, exports) {

$parcel$export(module.exports, "OpsAgentAvatar", () => $ffd70be6cbe5d6d1$export$957c6b1be4b93dae);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $ffd70be6cbe5d6d1$export$957c6b1be4b93dae = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36391",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36391)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.025 10.3877C25.9578 10.8278 26.7509 11.4073 27.3127 12.0251L27.3208 11.9732C29.4821 12.9519 31.2187 14.8436 32.251 17.0333C31.7886 16.9895 30.8021 16.2979 30.4096 16.4647C27.517 15.2974 31.6112 17.9955 32.8155 17.9026L32.8075 17.8944C32.8075 17.8944 33.0682 17.9163 33.0521 17.9436C34.1435 16.6341 34.1489 10.6063 32.88 15.9671C32.5306 15.2372 31.8263 14.0207 31.5413 13.6954C30.9203 13.258 30.837 12.6812 30.1004 12.4188C30.1004 12.4188 30.2456 12.3833 30.2482 12.3805C28.517 10.6583 25.7643 8.83491 23.283 8.42759C23.3314 8.55607 24.4094 9.00988 24.5061 9.08915C23.7669 9.21764 20.6673 8.11595 22.8287 8.35924C22.0545 7.71683 16.3984 8.03121 17.8931 8.55882C17.635 8.62716 16.5678 9.05908 17.1055 8.63809C15.2479 8.27177 8.4896 14.1246 10.4789 14.6577C10.7773 14.0289 11.6429 13.638 11.8284 13.1214C11.7343 12.9163 11.6752 12.7988 11.8768 12.6785C12.5569 13.1542 13.4064 11.1476 13.7478 11.041C13.8715 11.5112 16.6699 9.15476 16.2398 9.92019C18.9899 9.33791 22.361 9.0208 25.0304 10.3795L25.025 10.3877Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.891 25.7265C37.9582 24.9829 35.9286 21.5029 35.9636 23.0256C35.9582 23.2497 36.4663 24.4799 36.6571 24.7943C36.8749 24.8025 37.0039 24.7997 37.0093 25.0294C36.2996 25.434 37.4018 26.7871 37.3346 27.394C36.8749 30.6881 33.7834 37.1041 28.8746 36.7843C28.6381 36.7624 27.9069 37.0795 27.6838 37.0412C25.6434 37.2791 20.6218 35.9477 24.6649 34.8406C26.0036 33.471 21.5815 35.3436 21.1433 35.8548C21.5788 38.1292 25.0574 41.0762 22.517 36.8799C23.888 37.6672 25.009 38.3397 26.5547 38.173C28.294 38.9822 32.2591 37.9433 33.856 36.2949C33.7511 36.2785 32.743 36.7979 32.6382 36.8225C33.0844 36.109 35.4985 34.5672 34.1974 35.9888C37.4259 33.0801 38.3507 30.248 37.8883 25.721L37.891 25.7265Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.4496 34.3539C16.2695 34.2911 15.0356 34.3376 14.7507 34.4114C14.6781 34.6137 14.6485 34.7476 14.4496 34.6738C14.0759 33.7771 12.3474 34.6738 11.7533 33.9849C9.4817 33.0308 4.0219 29.3267 5.65635 25.3273C5.56764 23.3809 6.5784 21.3962 7.9279 19.9856C8.34189 19.3268 8.05963 21.5794 8.43329 21.6668C8.75857 24.8434 9.21289 19.8161 8.5704 18.8429C8.5704 18.8429 8.46824 18.5996 8.5005 18.5996C6.51389 18.2661 2.38206 20.8085 6.78809 19.6822C5.85258 20.7401 5.10256 21.5028 4.90901 22.897C3.77457 24.1572 3.61327 28.1457 4.9332 29.8707C4.93857 29.6875 4.66708 28.646 4.68321 28.6542C5.2558 29.1873 6.25584 31.6202 5.15903 30.2343C5.54345 33.0418 15.9093 37.4813 16.4496 34.3512V34.3539Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.9559 13.5099H24.9163C28.3336 13.5099 31.1058 16.282 31.1058 19.6993C31.1058 23.1166 28.3336 25.8887 24.9163 25.8887H17.489C15.8966 25.8887 14.6006 27.1789 14.6006 28.7771C14.6006 30.3753 15.8908 31.6655 17.489 31.6655H29.4494V34.9665H17.489C14.0718 34.9665 11.2996 32.1944 11.2996 28.7771C11.2996 25.3599 14.0718 22.5877 17.489 22.5877H24.9163C26.5087 22.5877 27.8047 21.2975 27.8047 19.6993C27.8047 18.1011 26.5146 16.8109 24.9163 16.8109H12.9559V13.5099Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.956 20.0713C15.6906 20.0713 17.9075 17.8544 17.9075 15.1197C17.9075 12.3851 15.6906 10.1682 12.956 10.1682C10.2213 10.1682 8.00443 12.3851 8.00443 15.1197C8.00443 17.8544 10.2213 20.0713 12.956 20.0713Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34 28.7539H24.9222V37.8317H34V28.7539Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.6344 13.5099C17.8088 14.0155 17.9017 14.5502 17.9017 15.1139C17.9017 15.7125 17.7971 16.2821 17.5995 16.8109H12.956V13.5099H17.6344Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.9017 15.1139C17.9017 15.7125 17.7971 16.2821 17.5995 16.8109H12.956V13.5099H17.6344C17.8088 14.0155 17.9017 14.5502 17.9017 15.1139Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.5836 37.1227V34.9608H24.9223V31.6597H28.5836V29.4978L32.3903 33.3103L28.5836 37.1227Z",
        fill: primaryColor
    }));

});

parcelRegister("3oTAZ", function(module, exports) {

$parcel$export(module.exports, "PitchPerfectorAvatar", () => $82686e5f6ebe08b5$export$89900ca53820ce0b);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $82686e5f6ebe08b5$export$89900ca53820ce0b = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38623",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38623)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.66037 32.0813C9.6521 32.0728 9.63839 32.0653 9.62931 32.0514C9.42188 32.3069 9.06094 32.2027 8.80197 32.3575C8.82774 32.4079 8.79189 32.3648 8.79189 32.3648C8.66918 32.5797 8.37737 32.6279 8.37621 32.6295C7.8259 32.9375 7.01741 33.2111 6.44789 33.6049L6.45732 33.6117L6.45897 33.6227C6.5459 33.6615 6.33192 33.7347 6.34904 33.6814C5.95847 33.7235 5.26998 34.0235 5.0066 34.3066C5.04377 34.3676 4.97309 34.4087 4.97286 34.3794C4.77124 34.2936 1.94854 35.4363 2.86634 35.7021L2.88103 35.7809C3.06517 35.7323 3.21698 35.6918 3.45381 35.7424C3.47274 35.7196 3.48301 35.732 3.45005 35.6618C3.45229 35.6488 4.38093 35.3287 4.38258 35.3397C4.49765 35.4817 4.92461 35.1157 4.92461 35.1157C5.97063 35.2679 7.14661 33.9377 8.22811 33.9916L8.2072 33.9643C8.21662 33.9711 8.23242 33.9461 8.25571 33.9801C8.29707 33.8374 8.4891 33.6558 8.4891 33.6558C8.4891 33.6558 9.14669 33.3455 9.22082 33.0587L9.88582 32.8438C9.88582 32.8438 10.1227 32.6632 10.1424 32.4975C10.156 32.393 10.145 32.2828 10.1103 32.1919C10.0433 32.0068 9.88868 31.8993 9.66467 32.082L9.66037 32.0813Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.01187 24.6324C5.0075 24.6219 4.99766 24.6123 4.99245 24.5964C4.92929 24.6964 4.8336 24.6828 4.74253 24.6629C4.65188 24.6456 4.55868 24.6022 4.47306 24.6275C4.48172 24.6849 4.48128 24.7284 4.47286 24.7004L4.46644 24.63C4.36243 24.7929 4.272 24.5641 4.17185 24.8173L4.18121 24.7219C3.79832 24.7964 3.26318 24.6676 2.79831 24.736L2.79996 24.7469L2.79732 24.7572C2.83109 24.8329 3.02012 24.9557 3.02012 24.9557C2.83011 25.2896 2.69752 24.9109 2.53522 24.9097L2.54773 24.8166C2.61764 24.8261 2.68366 24.7914 2.71458 24.7554C2.48315 24.6018 1.96875 24.527 1.7041 24.6534C1.7035 24.7235 1.79593 24.5766 1.79272 24.8054C1.73066 24.8017 1.66379 24.8309 1.60405 24.824C1.61649 24.6749 1.64696 24.7287 1.65689 24.7018C1.61485 24.6177 1.05706 24.4871 0.54749 24.5278C0.420798 24.5404 0.300397 24.5574 0.19527 24.5832C0.0893982 24.6133 0.00153942 24.6516 -0.0632643 24.6945C-0.191302 24.7815 -0.207962 24.8935 -0.0636331 25.035L-0.0672793 25.1126C0.0627909 25.1318 0.172114 25.1431 0.310164 25.28C0.327605 25.2659 0.330074 25.2823 0.32671 25.2044C0.330515 25.1926 0.338138 25.1689 0.33476 25.1373C0.321927 24.9503 0.367765 25.0226 0.386444 25.0167C0.389988 25.3088 0.489151 25.3177 0.5971 25.255C0.70546 25.1951 0.829285 25.071 0.858619 25.0801C0.864399 25.3593 0.970279 25.0883 1.00206 25.2064C0.999411 25.2166 0.982355 25.2796 0.979707 25.2899C0.997915 25.4662 1.53324 24.994 1.36628 25.3325C1.89714 25.9424 3.03462 25.3945 3.71335 25.91L3.7084 25.8772C3.71278 25.8876 3.73137 25.872 3.73442 25.9107C3.80957 25.7974 3.99109 25.7128 3.99109 25.7128C4.05474 25.6715 4.11872 25.6231 4.18154 25.5763C4.18154 25.5763 4.26524 25.6031 4.36664 25.599C4.46647 25.5937 4.58276 25.5493 4.63287 25.4275C4.79956 25.4392 4.96758 25.4227 5.1384 25.4155C5.1384 25.4155 5.32661 25.292 5.3398 25.1385C5.34917 25.0431 5.33738 24.9372 5.31204 24.8433C5.25591 24.6565 5.151 24.517 5.0146 24.6319L5.01187 24.6324Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.78216 17.4541C5.78324 17.4427 5.26329 17.1181 4.96465 17.047C4.94909 17.1014 4.95176 17.0449 4.95176 17.0449C4.712 17.1139 4.46519 16.9418 4.46404 16.9434C3.84941 16.7787 3.06767 16.405 2.37774 16.2878L2.37667 16.2992L2.37088 16.3072C2.40829 16.3976 2.20187 16.2987 2.25121 16.2737C1.93751 16.0286 1.22764 15.7606 0.836083 15.7776C0.821433 15.8473 0.741695 15.8283 0.75947 15.8071C0.672761 15.6029 -2.17964 14.4366 -1.70076 15.2763L-1.74507 15.3439C-1.57734 15.4366 -1.4382 15.5159 -1.30232 15.7218C-1.27191 15.7196 -1.27372 15.7353 -1.24701 15.6622C-1.23577 15.6534 -0.33734 16.0779 -0.344285 16.0874C-0.359962 16.2707 0.529727 16.0538 0.206027 16.3075C0.859777 17.1576 3.40002 17.7928 3.40002 17.7928C3.40324 17.8049 3.8196 17.767 3.8196 17.767L4.11663 17.7347C4.11663 17.7347 4.51403 18.0066 4.7687 17.8511L5.40172 18.1654C5.40172 18.1654 5.69929 18.2017 5.83147 18.0958C5.91364 18.029 5.98274 17.9406 6.0226 17.8528C6.10422 17.6712 6.06644 17.4855 5.77439 17.4581L5.78216 17.4541Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.0711814 25.4932C0.0755581 25.5037 0.0853788 25.5133 0.0905801 25.5292C0.153749 25.4292 0.249438 25.4428 0.340501 25.4628C0.431153 25.48 0.524374 25.5234 0.609998 25.4981C0.601338 25.4407 0.601751 25.3972 0.610172 25.4252L0.616593 25.4956C0.720607 25.3327 0.811031 25.5615 0.911188 25.3083L0.90182 25.4037C1.28472 25.3292 1.81985 25.458 2.28473 25.3896L2.28309 25.3787L2.28574 25.3684C2.25196 25.2928 2.06291 25.1699 2.06291 25.1699C2.25293 24.836 2.38553 25.2147 2.54784 25.2159L2.53533 25.309C2.46542 25.2995 2.39937 25.3343 2.36846 25.3702C2.59988 25.5238 3.1143 25.5986 3.37896 25.4722C3.37956 25.4021 3.28712 25.549 3.29034 25.3202C3.3524 25.3239 3.41926 25.2947 3.47901 25.3016C3.46657 25.4508 3.43609 25.397 3.42617 25.4238C3.4682 25.5079 4.02597 25.6385 4.53554 25.5978C4.66224 25.5853 4.78266 25.5682 4.88779 25.5424C4.99366 25.5123 5.08151 25.474 5.14632 25.4311C5.27436 25.3441 5.291 25.2321 5.14667 25.0907L5.15033 25.013C5.02026 24.9939 4.91094 24.9825 4.77289 24.8456C4.75545 24.8597 4.75296 24.8433 4.75632 24.9212C4.75252 24.933 4.74492 24.9567 4.7483 24.9884C4.76113 25.1753 4.71529 25.1031 4.69661 25.109C4.69307 24.8168 4.5939 24.808 4.48596 24.8706C4.3776 24.9305 4.25375 25.0546 4.22442 25.0455C4.21864 24.7663 4.11278 25.0373 4.081 24.9193C4.08364 24.909 4.10068 24.846 4.10333 24.8357C4.08512 24.6595 3.54979 25.1317 3.71675 24.7931C3.71675 24.7931 0.962768 24.5014 0.901517 24.5493C0.901517 24.5493 0.817815 24.5225 0.716413 24.5267C0.616582 24.5319 0.500279 24.5763 0.45016 24.6981C0.283478 24.6864 0.115473 24.7029 -0.0553473 24.7101C-0.0553473 24.7101 -0.243559 24.8337 -0.256747 24.9871C-0.266116 25.0825 -0.254329 25.1884 -0.228988 25.2823C-0.172851 25.4691 -0.0679416 25.6087 0.0684515 25.4937L0.0711814 25.4932Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M32.1917 32.0813C32.1999 32.0728 32.2137 32.0653 32.2227 32.0514C32.4302 32.3069 32.7911 32.2027 33.0501 32.3575C33.0243 32.4079 33.0602 32.3648 33.0602 32.3648C33.1829 32.5797 33.4747 32.6279 33.4758 32.6295C34.0262 32.9375 34.8346 33.2111 35.4042 33.6049L35.3947 33.6117L35.3931 33.6227C35.3062 33.6615 35.5201 33.7347 35.503 33.6814C35.8936 33.7235 36.5821 34.0235 36.8454 34.3066C36.8083 34.3676 36.879 34.4087 36.8792 34.3794C37.0808 34.2936 39.9035 35.4363 38.9857 35.7021L38.971 35.7809C38.7869 35.7323 38.6351 35.6918 38.3982 35.7424C38.3793 35.7196 38.369 35.732 38.402 35.6618C38.3998 35.6488 37.4711 35.3287 37.4695 35.3397C37.3544 35.4817 36.9274 35.1157 36.9274 35.1157C35.8814 35.2679 34.7054 33.9377 33.6239 33.9916L33.6448 33.9643C33.6354 33.9711 33.6196 33.9461 33.5963 33.9801C33.555 33.8374 33.3629 33.6558 33.3629 33.6558C33.3629 33.6558 32.7054 33.3455 32.6312 33.0587L31.9662 32.8438C31.9662 32.8438 31.7293 32.6632 31.7096 32.4975C31.696 32.393 31.707 32.2828 31.7417 32.1919C31.8088 32.0068 31.9634 31.8993 32.1874 32.082L32.1917 32.0813Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.8402 24.6324C36.8446 24.6219 36.8544 24.6123 36.8596 24.5964C36.9228 24.6964 37.0185 24.6828 37.1095 24.6629C37.2002 24.6456 37.2934 24.6022 37.379 24.6275C37.3703 24.6849 37.3708 24.7284 37.3792 24.7004L37.3856 24.63C37.4896 24.7929 37.58 24.5641 37.6802 24.8173L37.6708 24.7219C38.0537 24.7964 38.5889 24.6676 39.0537 24.736L39.0521 24.7469L39.0547 24.7572C39.021 24.8329 38.8319 24.9557 38.8319 24.9557C39.0219 25.2896 39.1545 24.9109 39.3168 24.9097L39.3043 24.8166C39.2344 24.8261 39.1684 24.7914 39.1375 24.7554C39.3689 24.6018 39.8833 24.527 40.148 24.6534C40.1486 24.7235 40.0561 24.5766 40.0593 24.8054C40.1214 24.8017 40.1883 24.8309 40.248 24.824C40.2356 24.6749 40.2051 24.7287 40.1952 24.7018C40.2372 24.6177 40.795 24.4871 41.3046 24.5278C41.4313 24.5404 41.5517 24.5574 41.6568 24.5832C41.7627 24.6133 41.8505 24.6516 41.9153 24.6945C42.0434 24.7815 42.06 24.8935 41.9157 25.035L41.9193 25.1126C41.7893 25.1318 41.6799 25.1431 41.5419 25.28C41.5244 25.2659 41.522 25.2823 41.5253 25.2044C41.5215 25.1926 41.5139 25.1689 41.5173 25.1373C41.5301 24.9503 41.4843 25.0226 41.4656 25.0167C41.4621 25.3088 41.3629 25.3177 41.255 25.255C41.1466 25.1951 41.0228 25.071 40.9934 25.0801C40.9877 25.3593 40.8818 25.0883 40.85 25.2064C40.8526 25.2166 40.8697 25.2796 40.8723 25.2899C40.8541 25.4662 40.3188 24.994 40.4858 25.3325C39.9549 25.9424 38.8174 25.3945 38.1387 25.91L38.1437 25.8772C38.1393 25.8876 38.1207 25.872 38.1176 25.9107C38.0425 25.7974 37.861 25.7128 37.861 25.7128C37.7973 25.6715 37.7333 25.6231 37.6705 25.5763C37.6705 25.5763 37.5868 25.6031 37.4854 25.599C37.3856 25.5937 37.2693 25.5493 37.2192 25.4275C37.0525 25.4392 36.8845 25.4227 36.7136 25.4155C36.7136 25.4155 36.5254 25.292 36.5122 25.1385C36.5029 25.0431 36.5147 24.9372 36.54 24.8433C36.5961 24.6565 36.7011 24.517 36.8374 24.6319L36.8402 24.6324Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.0699 17.4541C36.0688 17.4427 36.5888 17.1181 36.8874 17.047C36.903 17.1014 36.9003 17.0449 36.9003 17.0449C37.14 17.1139 37.3869 16.9418 37.388 16.9434C38.0026 16.7787 38.7844 16.405 39.4743 16.2878L39.4754 16.2992L39.4812 16.3072C39.4438 16.3976 39.6502 16.2987 39.6008 16.2737C39.9145 16.0286 40.6244 15.7606 41.016 15.7776C41.0306 15.8473 41.1104 15.8283 41.0926 15.8071C41.1793 15.6029 44.0317 14.4366 43.5528 15.2763L43.5971 15.3439C43.4294 15.4366 43.2902 15.5159 43.1544 15.7218C43.124 15.7196 43.1258 15.7353 43.0991 15.6622C43.0878 15.6534 42.1894 16.0779 42.1963 16.0874C42.212 16.2707 41.3223 16.0538 41.646 16.3075C40.9923 17.1576 38.452 17.7928 38.452 17.7928C38.4488 17.8049 38.0324 17.767 38.0324 17.767L37.7354 17.7347C37.7354 17.7347 37.338 18.0066 37.0834 17.8511L36.4503 18.1654C36.4503 18.1654 36.1528 18.2017 36.0206 18.0958C35.9384 18.029 35.8693 17.9406 35.8295 17.8528C35.7478 17.6712 35.7856 17.4855 36.0777 17.4581L36.0699 17.4541Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M41.7809 25.4932C41.7765 25.5037 41.7667 25.5133 41.7615 25.5292C41.6983 25.4292 41.6026 25.4428 41.5116 25.4628C41.4209 25.48 41.3277 25.5234 41.2421 25.4981C41.2507 25.4407 41.2503 25.3972 41.2419 25.4252L41.2355 25.4956C41.1315 25.3327 41.041 25.5615 40.9409 25.3083L40.9502 25.4037C40.5673 25.3292 40.0322 25.458 39.5673 25.3896L39.569 25.3787L39.5663 25.3684C39.6001 25.2928 39.7892 25.1699 39.7892 25.1699C39.5991 24.836 39.4665 25.2147 39.3042 25.2159L39.3167 25.309C39.3866 25.2995 39.4527 25.3343 39.4836 25.3702C39.2522 25.5238 38.7378 25.5986 38.4731 25.4722C38.4725 25.4021 38.5649 25.549 38.5617 25.3202C38.4997 25.3239 38.4328 25.2947 38.3731 25.3016C38.3855 25.4508 38.416 25.397 38.4259 25.4238C38.3839 25.5079 37.8261 25.6385 37.3165 25.5978C37.1898 25.5853 37.0694 25.5682 36.9643 25.5424C36.8584 25.5123 36.7706 25.474 36.7057 25.4311C36.5777 25.3441 36.5611 25.2321 36.7054 25.0907L36.7017 25.013C36.8318 24.9939 36.9411 24.9825 37.0792 24.8456C37.0966 24.8597 37.0991 24.8433 37.0957 24.9212C37.0995 24.933 37.1071 24.9567 37.1038 24.9884C37.0909 25.1753 37.1368 25.1031 37.1555 25.109C37.159 24.8168 37.2582 24.808 37.3661 24.8706C37.4745 24.9305 37.5983 25.0546 37.6276 25.0455C37.6334 24.7663 37.7393 25.0373 37.7711 24.9193C37.7684 24.909 37.7514 24.846 37.7487 24.8357C37.7669 24.6595 38.3023 25.1317 38.1353 24.7931C38.1353 24.7931 40.8893 24.5014 40.9505 24.5493C40.9505 24.5493 41.0343 24.5225 41.1357 24.5267C41.2355 24.5319 41.3518 24.5763 41.4019 24.6981C41.5686 24.6864 41.7366 24.7029 41.9074 24.7101C41.9074 24.7101 42.0956 24.8337 42.1088 24.9871C42.1182 25.0825 42.1064 25.1884 42.0811 25.2823C42.0249 25.4691 41.92 25.6087 41.7836 25.4937L41.7809 25.4932Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M33.2675 11.7762H8.72812V26.8525H33.2675V11.7762Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.2419 36.9981L22.75 23.1381H19.25L10.7581 36.9981L13.7419 38.8268L19.25 29.8362V37.9124H22.75V29.8362L28.2581 38.8268L31.2419 36.9981Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.025 26.8568H16.975L19.25 23.1425H22.75L25.025 26.8568Z",
        fill: primaryColor
    }));

});

parcelRegister("3ptGp", function(module, exports) {

$parcel$export(module.exports, "ProductRequirementAvatar", () => $cb8d32210f2d7769$export$96348a0fd479c23f);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $cb8d32210f2d7769$export$96348a0fd479c23f = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_602_29348",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_602_29348)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37 35.9716C35.7885 34.4863 32.8225 32.1398 31.2873 30.7577C31.3918 30.2472 27.5902 29.0198 29.0053 28.9476C27.4596 26.6424 24.1646 24.5486 21.1412 22.3774C22.3892 20.263 23.8827 17.6742 24.196 16.0652C25.021 15.467 34.3682 -0.721128 30.739 2.39891L30.6137 2.20294C29.0158 4.0337 27.538 7.0042 26.5301 9.51055C25.8252 9.25269 23.867 14.9771 23.6947 13.3835C21.9976 15.1111 20.4676 17.8289 18.9585 20.7324C16.2483 18.2002 15.6426 17.3596 12.9376 16.3488C12.9376 16.3488 11.4024 14.6316 10.3058 14.4975C8.82801 13.2649 8.21714 11.79 6.0814 11.2536C4.50962 11.3568 4.79155 12.2335 6.02913 13.399C7.38681 14.0901 8.03439 15.4979 9.23019 16.4159C9.45473 16.1426 9.44943 16.3488 9.27711 16.452C10.2954 16.8078 10.3737 17.6794 11.5016 17.767C11.5016 17.767 11.2614 17.8908 11.2562 17.8908C13.1622 19.3606 15.4807 21.3718 17.7626 23.0479C16.1073 26.2865 14.4311 29.4994 12.5565 31.619H12.6556C12.6086 31.6499 12.5774 31.7995 12.4677 31.7789C12.2275 33.3982 11.7314 34.2388 11.4286 35.4816C11.4286 35.4816 9.77328 37.8075 9.76806 39.0916L7.51741 42.7222C6.47304 44.2074 6.89075 48.3022 9.17792 44.2796C9.71055 42.5107 11.1309 41.2885 11.9455 39.6279C11.6322 39.4784 11.8359 39.401 11.9769 39.5609C12.2275 38.3026 13.1413 37.9157 13.1048 36.6213C14.9846 34.4863 17.6425 28.5712 19.4702 25.1417C19.2926 25.2139 19.794 24.4506 19.7679 24.4454C19.7679 24.4454 19.7731 24.4352 19.7783 24.43C19.794 24.4403 19.8097 24.4506 19.8254 24.4609C19.8254 24.4403 19.8305 24.4197 19.8514 24.4094C19.8514 24.3991 20.5668 24.8013 20.3579 24.7703C21.6372 26.1628 24.598 28.4422 26.2534 29.2003C26.3317 29.025 26.666 29.2467 26.5824 29.2776C26.1229 29.1796 37.8459 39.2876 36.8015 36.0799L37 35.9767V35.9716Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.41632 37H29.3148V11H19.2549L9.41632 20.6911V37Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.259 11V20.6624H9.44501L19.259 11Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35 21.313L23.133 33.7411L16.9966 27.1391L19.6412 24.4436L23.1684 28.2389L32.3908 18.5804L35 21.313Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.3147 21.8019L23.1684 28.2389L19.6412 24.4436L16.9966 27.1391L23.133 33.7411L29.3147 27.2671V21.8019Z",
        fill: "#101214"
    }));

});

parcelRegister("7zNkv", function(module, exports) {

$parcel$export(module.exports, "ReleaseNotesAvatar", () => $1c4302bcb883b38a$export$c581761a1d98823f);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $1c4302bcb883b38a$export$c581761a1d98823f = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36603",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36603)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57.9155 20.7534C54.2909 19.0242 56.2884 14.5907 48.2281 18.687C48.3336 18.7485 48.1249 18.9193 48.1343 18.7439C46.737 19.719 45.75 20.0676 44.2167 20.5962C44.2167 20.5962 44.3691 20.4594 44.3714 20.4572C42.4536 21.0085 41.8839 19.7099 41.2931 18.1972C37.0754 14.1647 32.2551 22.0884 27.8405 20.284C28.3164 20.9402 29.8052 20.7989 30.5788 20.6463C27.2427 22.2069 27.6131 19.3431 26.0142 17.7506C26.7222 17.6549 27.1606 19.1836 27.3997 19.6165C25.5476 13.5655 18.8072 20.038 15.2413 20.6189C15.4288 20.6918 16.2775 20.3478 16.5002 20.5232C16.0313 20.8171 13.4759 20.9493 14.7349 20.7101C13.8627 20.644 13.1899 20.5004 12.9812 19.4228C10.4609 12.8911 3.33366 21.9836 -0.881711 20.3524C-1.71869 19.1426 -2.06567 16.7892 -4.20853 17.4088C-4.1757 17.6048 -3.44423 17.6025 -3.2004 17.7757C-3.26605 17.7893 -3.32935 17.8007 -3.39031 17.8167C-1.48425 18.2199 -2.55332 21.1384 -0.412816 21.3639C0.126414 21.3662 0.199091 20.9515 0.815689 21.0746C3.30084 21.8423 5.93133 18.3885 8.44227 18.1561C8.41414 18.1766 8.243 18.2951 8.2219 18.3179C9.48323 17.9625 12.1723 17.5934 12.2872 19.6598C12.4115 20.0699 12.3458 20.0402 12.1302 19.6484C14.6786 25.4146 21.0814 17.4385 25.1772 18.3657C29.355 26.2553 33.8259 17.5342 39.6356 18.5822C39.6285 18.5639 39.6168 18.548 39.6051 18.5321C40.8289 18.9353 40.6742 20.9083 41.9847 21.3206C46.6385 23.2184 50.7015 15.7435 54.8536 18.753C55.3154 19.5345 55.85 21.2477 57.1066 21.1657C57.6693 21.1498 58.2202 21.0154 57.9108 20.7534H57.9155Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57.0011 25.8543C53.3765 24.1251 55.3741 19.6916 47.3137 23.7879C47.4192 23.8494 47.2106 24.0203 47.2199 23.8449C45.8226 24.82 44.8356 25.1686 43.3023 25.6971C43.3023 25.6971 43.4547 25.5604 43.4571 25.5581C41.5393 26.1095 40.9696 24.8109 40.3788 23.2981C36.1611 19.2656 31.3408 27.1893 26.9262 25.385C27.4021 26.0411 28.8908 25.8999 29.6645 25.7472C26.3283 27.3078 26.6987 24.4441 25.0998 22.8516C25.8078 22.7559 26.2463 24.2846 26.4854 24.7175C24.6333 18.6664 17.8929 25.139 14.3269 25.7199C14.5145 25.7928 15.3632 25.4488 15.5859 25.6242C15.117 25.9181 12.5615 26.0502 13.8205 25.811C12.9484 25.745 12.2755 25.6015 12.0669 24.5238C9.54654 17.9921 2.41932 27.0846 -1.79605 25.4533C-2.63303 24.2436 -2.98001 21.8902 -5.12286 22.5098C-5.09004 22.7058 -4.35857 22.7035 -4.11474 22.8766C-4.18039 22.8903 -4.24369 22.9017 -4.30464 22.9177C-2.39858 23.3209 -3.46766 26.2393 -1.32715 26.4649C-0.787923 26.4671 -0.715246 26.0525 -0.0986485 26.1756C2.3865 26.9411 5.01701 23.4895 7.52795 23.2571C7.49981 23.2776 7.32865 23.3961 7.30755 23.4189C8.56654 23.0635 11.258 22.6944 11.3729 24.7607C11.4971 25.1708 11.4315 25.1412 11.2158 24.7494C13.7643 30.5156 20.167 22.5395 24.2628 23.4667C28.4407 31.3563 32.9116 22.6351 38.7212 23.6831C38.7142 23.6649 38.7025 23.649 38.6907 23.633C39.9146 24.0363 39.7598 26.0092 41.0704 26.4216C45.7242 28.3194 49.7872 20.8444 53.9392 23.854C54.4011 24.6354 54.9356 26.3487 56.1923 26.2667C56.7549 26.2507 57.3059 26.1163 56.9964 25.8543H57.0011Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.9941 30.9052C24.1995 30.1853 26.3518 25.5034 20.1553 27.9617C20.1553 27.9617 20.2209 27.8227 20.2209 27.8204C17.5951 28.57 14.0456 32.279 11.3471 30.2468C11.2346 30.5703 11.9684 31.0738 12.3224 31.092C10.7563 31.4041 11.0306 29.7045 10.5218 28.7158C10.8805 28.7317 10.9251 29.5929 11.1384 29.7911C10.7586 25.3303 3.56813 28.4675 5.06391 28.4561C4.7521 28.5973 3.46732 29.381 4.06516 28.8274C0.45701 30.3379 -2.22742 32.8235 -4.15927 28.0004C-4.68678 27.4332 -7.00079 27.5379 -5.50267 27.9594L-5.60581 28.0392C-3.85917 28.2852 -4.47812 29.3127 -3.59894 30.2741C-4.19912 32.1104 -0.609741 31.5249 0.344461 31.3198C-0.295581 32.181 3.60798 29.5519 2.93745 30.3037C13.6494 24.6377 6.86212 35.7761 17.7452 30.5748L17.6936 30.5589C19.8482 28.8138 24.3824 26.515 25.0225 30.7776C25.2194 31.6958 28.0984 31.7596 26.9895 30.9052H26.9941Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.4518 34.4737V13.4956H12.715V34.4737H28.4518ZM16.6525 19.4106H24.5187V17.4419H16.6525V19.4106ZM16.6525 24.3106H20.5856V22.3419H16.6525V24.3106ZM20.5856 29.2719H16.6525V27.3031H20.5856V29.2719Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.3644 24.0044L32.2831 17.91V21.3707H23V27.2113H32.2831V30.0857L38.3644 24.0044Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.8125 21.375V27.2156H28.4518V21.375H22.8125Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.8125 21.375V27.2156H28.4518V21.375H22.8125Z",
        fill: primaryColor
    }));

});

parcelRegister("lLzmU", function(module, exports) {

$parcel$export(module.exports, "ResearchScoutAvatar", () => $727ce7a9982a2700$export$5b23e1bc88738494);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $727ce7a9982a2700$export$5b23e1bc88738494 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36507",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36507)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.4463 11.0851C24.2842 11.0342 24.8953 6.66708 25.6794 5.05429C25.214 4.53564 24.9686 3.51338 25.2376 2.60969C23.3643 0.0930822 23.604 5.10354 23.7107 6.67045C24.36 5.84105 23.402 8.14889 23.6078 8.61284C23.6433 8.40279 22.9772 12.6138 24.0463 11.7228C24.1108 11.8796 24.6752 11.0305 24.4486 11.0876L24.4463 11.0851Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.7749 9.62623C34.8599 8.67744 35.4555 8.03786 36.282 7.51077C36.7283 4.27819 32.9755 8.45022 32.0793 9.47383C32.0793 9.47383 30.4663 11.2367 30.5232 10.9755C30.0737 11.0089 27.0189 13.2024 28.5477 13.6027C29.1004 13.2848 29.7974 12.2938 30.2622 12.4522C31.3683 12.5512 33.3234 10.0611 34.7751 9.62147L34.7749 9.62623Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M40.0248 20.0843C41.0507 18.2865 36.9152 18.5769 35.4287 18.1889C35.4287 18.1889 33.9085 17.7033 33.4188 17.8368C33.6396 17.9081 28.1592 16.5002 30.714 18.428C30.7975 18.4262 32.694 18.9166 32.694 18.9166C34.9809 20.2763 37.7615 20.3387 40.0272 20.0821L40.0248 20.0843Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.0381 28.0381C21.3544 31.7218 15.3562 31.7218 11.6681 28.0381C7.98437 24.3543 7.98437 18.3562 11.6681 14.6681C15.3519 10.9843 21.35 10.9843 25.0381 14.6681C28.7262 18.3518 28.7219 24.35 25.0381 28.0381ZM14.0744 17.0743C11.7162 19.4325 11.7162 23.2737 14.0744 25.6318C16.4325 27.99 20.2737 27.99 22.6319 25.6318C24.99 23.2737 24.99 19.4325 22.6319 17.0743C20.2737 14.7162 16.4325 14.7162 14.0744 17.0743Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.9119 24.3962L21.4007 27.9075L29.5832 36.09L33.0944 32.5788L24.9119 24.3962Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21.3981 27.9068L23.0519 29.5606C23.765 29.1537 24.4344 28.6462 25.0425 28.0381C25.6506 27.4299 26.1581 26.7606 26.565 26.0474L24.9112 24.3937L21.3981 27.9068Z",
        fill: primaryColor
    }));

});

parcelRegister("89yuV", function(module, exports) {

$parcel$export(module.exports, "SocialMediaScribeAvatar", () => $1721a74f1671a422$export$538286cb30d86972);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $1721a74f1671a422$export$538286cb30d86972 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36095",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36095)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M48.6709 34.1188C42.9117 36.4894 35.3817 38.733 29.4937 35.0081C32.969 32.6026 35.7299 28.9433 37.9132 25.4171L37.7643 25.6035C41.4508 20.1473 42.8835 8.15902 33.8403 7.81275C38.3076 -5.34542 33.8665 -13.1067 22.493 -0.886975C14.3654 8.61183 7.40888 22.2781 7.84353 35.1781C-8.66328 40.8598 -0.618129 15.5433 1.67387 8.36391C1.35794 8.68149 0.943409 10.0768 0.367895 11.593L0.472513 11.005C-1.30635 16.8485 -3.3307 22.8272 -2.9544 28.8429C-2.92623 29.0785 -2.8699 29.4699 -2.84374 29.3654C-2.59622 29.6235 -2.4634 31.5741 -2.22796 32.0125C-1.82148 36.9341 3.9538 37.7209 7.94014 35.9158C9.92023 47.5905 23.2094 39.5997 28.7935 35.506C33.6069 38.7699 39.9758 38.1593 45.1615 36.1227C46.1676 35.801 50.168 33.7398 48.6669 34.1168L48.6709 34.1188ZM8.74506 32.029C8.81549 30.6582 8.99457 29.3059 9.23604 27.9864L9.20585 28.0909V28.0417C8.79937 29.7731 8.42108 32.7748 8.61627 34.8749C8.55389 34.9015 8.48948 34.9282 8.42509 34.9528C7.90994 28.8142 10.1577 22.6859 12.3873 17.0821L12.4537 17.1702C11.4918 19.467 10.5621 22.2433 10.0913 24.2021C12.0452 17.4201 15.9148 9.28182 20.5572 3.1453C23.7326 -1.37872 35.0819 -12.783 34.5828 -0.23747C34.6915 -0.923859 34.4561 -3.76981 34.1643 -4.7451C35.098 -2.14092 34.7941 0.920172 34.3394 3.57967C34.2025 3.43215 34.5305 1.88726 34.5004 1.69671C34.4923 2.03069 33.8886 5.46264 32.9609 7.82709C24.6723 8.0115 20.8993 17.4488 22.2656 24.5893C18.4221 28.6585 13.9408 32.5105 8.78328 34.8012C8.69876 33.8812 8.69475 32.9489 8.74103 32.029H8.74506ZM23.155 18.3647C23.155 18.3647 23.2074 18.4753 23.2074 18.4794C24.2376 12.9945 27.3567 9.48262 32.639 8.69584C30.4697 14.1747 27.0971 19.2048 23.0162 23.7779C22.8411 22.1491 22.8774 20.4853 23.143 18.8441C23.0665 18.9548 23.0625 18.6372 23.155 18.3647ZM22.324 38.3704C17.6032 41.1753 9.66868 43.3738 8.87382 35.5367C13.8723 33.1518 17.6333 30.1521 21.2937 26.6095C21.2192 26.6976 20.7483 27.257 20.688 27.3287C20.8892 27.175 21.5533 26.5522 22.4487 25.6056C23.1752 29.1851 25.0124 32.6047 27.89 34.8483C26.093 36.1248 24.2417 37.3234 22.324 38.3704ZM28.5621 34.3627C25.5839 32.1027 23.7688 28.5499 23.155 24.8413C26.5719 21.2352 30.3832 15.2852 32.2687 11.2221C32.1922 11.5356 32.0292 11.8778 31.82 12.3818C32.4196 11.2324 32.9911 10.0112 33.5023 8.71427C36.7058 8.44176 39.3379 11.1853 39.5693 14.359C40.3883 21.6143 34.1884 30.3017 28.5621 34.3627Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.4419 16.5931H10.5306V34.5H28.4375V16.5931H28.4419ZM14.3719 22.3506H24.605V20.43H14.3719V22.3506ZM14.3719 26.5069H24.605V24.5863H14.3719V26.5069ZM20.7681 30.6631H14.3719V28.7425H20.7681V30.6631Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.9156 22.9018L21 24L22.0981 20.0843L31.8631 10.3193L34.6806 13.1368L24.9156 22.9018Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5894 16.5931L22.0981 20.0844L22.0019 20.43H24.605V22.3506H21.4638L21 24L24.9156 22.9019L28.4419 19.3756V16.5931H25.5894Z",
        fill: primaryColor
    }));

});

parcelRegister("pHJ36", function(module, exports) {

$parcel$export(module.exports, "TeamConnectionAvatar", () => $88b5807114c63803$export$f08846c34de290e3);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $88b5807114c63803$export$f08846c34de290e3 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36191",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36191)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.025 10.3877C25.9578 10.8278 26.7509 11.4073 27.3127 12.0251L27.3208 11.9732C29.4821 12.9519 31.2187 14.8436 32.251 17.0333C31.7886 16.9895 30.8021 16.2979 30.4096 16.4647C27.517 15.2974 31.6112 17.9955 32.8155 17.9026L32.8075 17.8944C32.8075 17.8944 33.0682 17.9163 33.0521 17.9436C34.1435 16.6341 34.1489 10.6063 32.88 15.9671C32.5306 15.2372 31.8263 14.0207 31.5413 13.6954C30.9203 13.258 30.837 12.6812 30.1004 12.4188C30.1004 12.4188 30.2456 12.3833 30.2482 12.3805C28.517 10.6583 25.7643 8.83491 23.283 8.42759C23.3314 8.55607 24.4094 9.00988 24.5061 9.08915C23.7669 9.21764 20.6673 8.11595 22.8287 8.35924C22.0545 7.71683 16.3984 8.03121 17.8931 8.55882C17.635 8.62716 16.5678 9.05908 17.1055 8.63809C15.2479 8.27177 8.4896 14.1246 10.4789 14.6577C10.7773 14.0289 11.6429 13.638 11.8284 13.1214C11.7343 12.9163 11.6752 12.7988 11.8768 12.6785C12.5569 13.1542 13.4064 11.1476 13.7478 11.041C13.8715 11.5112 16.6699 9.15476 16.2398 9.92019C18.9899 9.33791 22.361 9.0208 25.0304 10.3795L25.025 10.3877Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.891 25.7265C37.9582 24.9829 35.9286 21.5029 35.9636 23.0256C35.9582 23.2497 36.4663 24.4799 36.6571 24.7943C36.8749 24.8025 37.0039 24.7997 37.0093 25.0294C36.2996 25.434 37.4018 26.7871 37.3346 27.394C36.8749 30.6881 33.7834 37.1041 28.8746 36.7843C28.6381 36.7624 27.9069 37.0795 27.6838 37.0412C25.6434 37.2791 20.6218 35.9477 24.6649 34.8406C26.0036 33.471 21.5815 35.3436 21.1433 35.8548C21.5788 38.1292 25.0574 41.0762 22.517 36.8799C23.888 37.6672 25.009 38.3397 26.5547 38.173C28.294 38.9822 32.2591 37.9433 33.856 36.2949C33.7511 36.2785 32.743 36.7979 32.6382 36.8225C33.0844 36.109 35.4985 34.5672 34.1974 35.9888C37.4259 33.0801 38.3507 30.248 37.8883 25.721L37.891 25.7265Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.4496 34.3539C16.2695 34.2911 15.0356 34.3376 14.7507 34.4114C14.6781 34.6137 14.6485 34.7476 14.4496 34.6738C14.0759 33.7771 12.3474 34.6738 11.7533 33.9849C9.4817 33.0308 4.0219 29.3267 5.65635 25.3273C5.56764 23.3809 6.5784 21.3962 7.9279 19.9856C8.34189 19.3268 8.05963 21.5794 8.43329 21.6668C8.75857 24.8434 9.21289 19.8161 8.5704 18.8429C8.5704 18.8429 8.46824 18.5996 8.5005 18.5996C6.51389 18.2661 2.38206 20.8085 6.78809 19.6822C5.85258 20.7401 5.10256 21.5028 4.90901 22.897C3.77457 24.1572 3.61327 28.1457 4.9332 29.8707C4.93857 29.6875 4.66708 28.646 4.68321 28.6542C5.2558 29.1873 6.25584 31.6202 5.15903 30.2343C5.54345 33.0418 15.9093 37.4813 16.4496 34.3512V34.3539Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.9575 15.6919C10.276 15.6919 6.4791 19.4888 6.4791 24.1703C6.4791 27.6996 8.63385 30.7253 11.7004 32V29.9541C11.7004 28.1577 13.1566 26.697 14.9575 26.697C16.7584 26.697 18.21 28.1532 18.21 29.9541V32C21.2766 30.7298 23.4359 27.6996 23.4359 24.1703C23.4359 19.4888 19.639 15.6919 14.9575 15.6919ZM14.9575 25.7852C13.4151 25.7852 12.1677 24.5332 12.1677 22.9954C12.1677 21.4576 13.4151 20.2055 14.9575 20.2055C16.4998 20.2055 17.7428 21.453 17.7428 22.9954C17.7428 24.5377 16.4953 25.7852 14.9575 25.7852Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.0469 15.6919C22.3654 15.6919 18.5685 19.4888 18.5685 24.1703C18.5685 27.6996 20.7232 30.7253 23.7898 32V29.9541C23.7898 28.1577 25.2459 26.697 27.0469 26.697C28.8478 26.697 30.2994 28.1532 30.2994 29.9541V32C33.366 30.7298 35.5253 27.6996 35.5253 24.1703C35.5253 19.4888 31.7283 15.6919 27.0469 15.6919ZM27.0469 25.7852C25.5045 25.7852 24.257 24.5332 24.257 22.9954C24.257 21.4576 25.5045 20.2055 27.0469 20.2055C28.5892 20.2055 29.8322 21.453 29.8322 22.9954C29.8322 24.5377 28.5847 25.7852 27.0469 25.7852Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20.9954 18.2322C19.4893 19.7609 18.5639 21.8567 18.5639 24.1702C18.5639 26.4838 19.4939 28.5886 20.9954 30.1174C22.5014 28.5886 23.4314 26.4883 23.4314 24.1702C23.4314 21.8522 22.506 19.7609 20.9954 18.2322Z",
        fill: primaryColor
    }));

});



parcelRegister("920hm", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCreator", () => $f487095b9eea36be$export$f35b2eeaa7e3db15);
$parcel$export(module.exports, "AgentStarCount", () => $f487095b9eea36be$export$65f8fe094f79ae2);
$parcel$export(module.exports, "AgentProfileInfo", () => $f487095b9eea36be$export$e02348ba0b01a210);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hI5oG = parcelRequire("hI5oG");

var $daM3L = parcelRequire("daM3L");

var $45uQ5 = parcelRequire("45uQ5");
var $aFHo6 = parcelRequire("aFHo6");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $hFxJG = parcelRequire("hFxJG");

var $8cU5f = parcelRequire("8cU5f");

var $kfZqf = parcelRequire("kfZqf");

var $cfzU9 = parcelRequire("cfzU9");

var $aj3Jh = parcelRequire("aj3Jh");
const $f487095b9eea36be$var$clickableItemStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $f487095b9eea36be$var$countStyles = (0, $1ZAYh.xcss)({
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.025'
});
const $f487095b9eea36be$var$nameStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'space-between',
    alignItems: 'flex-start'
});
const $f487095b9eea36be$var$descriptionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0',
    marginBottom: 'space.100'
});
const $f487095b9eea36be$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100,
                borderRadius: 3
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45uQ5.AtlassianIcon), {
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $aj3Jh.messages).agentDeactivated))
        });
        if (creator.type === 'THIRD_PARTY') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$clickableItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFHo6.RovoIcon), {
        appearance: "brand",
        size: "small"
    }), creatorRender) : null;
};
const $f487095b9eea36be$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((starCount === null || starCount === undefined) && !isLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$countStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        label: "",
        size: "small"
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        testId: "agent-profile-info-star-count-skeleton",
        isShimmering: true,
        height: 16,
        width: 75,
        borderRadius: 3
    }) : formatMessage((0, $aj3Jh.messages).starredCount, {
        count: starCount
    }));
};
const $f487095b9eea36be$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $f487095b9eea36be$var$tooltipWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    marginInline: 'space.100',
    position: 'relative',
    bottom: 'space.025'
});
const $f487095b9eea36be$var$headingWrapperStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $f487095b9eea36be$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        xcss: $f487095b9eea36be$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f487095b9eea36be$var$nameStyles,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "span",
        size: "xlarge"
    }, agentName), isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$tooltipWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $aj3Jh.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kfZqf.HiddenIcon), {
        label: formatMessage((0, $aj3Jh.messages).hiddenIcon)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfzU9.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$descriptionStyles,
        as: "p"
    }, agentDescription), starCountRender);
};

});
parcelRegister("45uQ5", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", () => $12a88b946c693080$export$8a485e2e7ed91e8f);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $12a88b946c693080$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $12a88b946c693080$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $lpzFL.defaultLogoParams).size, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $12a88b946c693080$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("aFHo6", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", () => $e6e5f467bfb8f1b0$export$e23ae35269442b4f);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $e6e5f467bfb8f1b0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $e6e5f467bfb8f1b0$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        svg: $e6e5f467bfb8f1b0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hFxJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6854df9b98f4b182$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $6854df9b98f4b182$var$shimmer = (0, $lcnyw.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6854df9b98f4b182$var$shimmerKeyframes = (0, $byn9U.keyframes)($6854df9b98f4b182$var$shimmer.keyframes);
const $6854df9b98f4b182$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...$6854df9b98f4b182$var$shimmer.css
});
const $6854df9b98f4b182$var$activeShimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationName: `${$6854df9b98f4b182$var$shimmerKeyframes}`
});
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $6854df9b98f4b182$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6854df9b98f4b182$var$skeletonStyles,
            isShimmering && $6854df9b98f4b182$var$activeShimmerStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                width: width,
                height: height,
                borderRadius: borderRadius
            }
        ],
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        }
    });
};
var $6854df9b98f4b182$export$2e2bcd8739ae039 = $6854df9b98f4b182$var$Skeleton;

});

parcelRegister("kfZqf", function(module, exports) {

$parcel$export(module.exports, "HiddenIcon", () => $a21c86407f311f09$export$bce21421c351deb1);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a21c86407f311f09$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.75961 3.82038L0.469614 1.53039L1.53027 0.469727L15.5303 14.4697L14.4696 15.5304L11.9569 13.0177C10.7749 13.6441 9.42396 14.0001 7.99985 14.0001C4.43327 14.0001 1.31894 11.7676 0.167087 8.61989C0.0206752 8.21978 0.0206129 7.78052 0.167056 7.38031C0.683493 5.96897 1.59401 4.74336 2.75961 3.82038ZM3.82896 4.88973C2.80461 5.65938 2.01287 6.70107 1.57571 7.89577C1.5511 7.96303 1.55109 8.03706 1.57574 8.10442C2.50926 10.6555 5.05721 12.5001 7.99985 12.5001C9.00694 12.5001 9.96863 12.284 10.8358 11.8965L9.52381 10.5846C9.07723 10.8483 8.55598 11.0001 7.99994 11.0001C6.34309 11.0001 4.99994 9.65691 4.99994 8.00006C4.99994 7.44402 5.15166 6.92277 5.41542 6.47619L3.82896 4.88973ZM6.55063 7.6114C6.51755 7.7353 6.49994 7.86555 6.49994 8.00006C6.49994 8.82848 7.17152 9.50006 7.99994 9.50006C8.13445 9.50006 8.2647 9.48246 8.3886 9.44937L6.55063 7.6114ZM7.99985 3.50006C7.50971 3.50006 7.03064 3.55121 6.56817 3.64826L6.26011 2.18024C6.82282 2.06215 7.40511 2.00006 7.99985 2.00006C11.5664 2.00006 14.6809 4.23249 15.8328 7.38022C15.9792 7.78032 15.9793 8.21955 15.8328 8.61977C15.5258 9.45892 15.0793 10.2324 14.5232 10.9153L13.3601 9.96815C13.8143 9.41034 14.1762 8.78194 14.4242 8.10432C14.4488 8.03708 14.4488 7.96307 14.4242 7.8957C13.4906 5.34464 10.9425 3.50006 7.99985 3.50006Z",
        fill: "currentColor"
    }));
const $a21c86407f311f09$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $a21c86407f311f09$var$CustomGlyph,
        ...props
    });

});

parcelRegister("cfzU9", function(module, exports) {

$parcel$export(module.exports, "StarIconButton", () => $0d5e336c9f732951$export$703abb8bd2abdfa5);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4vqt4 = parcelRequire("4vqt4");
const $0d5e336c9f732951$var$pressableStarIconStyles = (0, $1ZAYh.xcss)({
    background: 'transparent',
    padding: 'space.0',
    height: '32px',
    width: '32px'
});
const $0d5e336c9f732951$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $0d5e336c9f732951$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $0d5e336c9f732951$var$pressableStarIconStyles,
            !visible && $0d5e336c9f732951$var$hiddenStyles
        ],
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
        size: "medium",
        label: formatMessage((0, $4vqt4.default).removeFromFavouritesLabel),
        primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        size: "medium",
        label: formatMessage((0, $4vqt4.default).clickToFavouriteLabel),
        primaryColor: "var(--ds-background-accent-gray-bolder-hovered, #44546F)"
    }));
};

});
parcelRegister("4vqt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $237a04530def53a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $237a04530def53a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeFromFavouritesLabel: {
        id: 'rovo-chat.browse-agents.remove-from-favourites-label',
        defaultMessage: 'Remove from favourites',
        description: 'Remove from favourites label'
    },
    clickToFavouriteLabel: {
        id: 'rovo-chat.browse-agents.click-to-favourite-label',
        defaultMessage: 'Not favourited, click to favourite',
        description: 'Click to favourite agent label'
    }
});

});


parcelRegister("aj3Jh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9eb9dca2dfa43df$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b9eb9dca2dfa43df$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    agentCreatedBy: {
        id: 'ai-mate.agent-profile-info.created-by',
        defaultMessage: 'Rovo agent by {creatorNameWithLink}',
        description: 'Message to show who created this Rovo agent'
    },
    agentDeactivated: {
        id: 'ai-mate.agent-profile-info.deactivated',
        defaultMessage: '(deactivated)',
        description: 'Message to show that this agent is deactivated'
    },
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{count} starred',
        description: 'Message to show how many times this agent has been starred by users'
    },
    hiddenIcon: {
        id: 'ai-mate.agent-profile-info.hidden-icon',
        defaultMessage: 'Hidden',
        description: 'Icon to show that this agent is hidden'
    },
    hiddenTooltip: {
        id: 'ai-mate.agent-profile-info.hidden-tooltip',
        defaultMessage: "Agent won't show in search results",
        description: 'Tooltip to explain what strikethough eye icon means'
    },
    starAgentTooltip: {
        id: 'ai-mate.agent-profile-info.star-agent-tooltip',
        defaultMessage: 'Star Agent',
        description: 'Tooltip to explain what star icon does'
    }
});

});


parcelRegister("4x5z4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ecabf9b19940d0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $b3ecabf9b19940d0$var$LoadingState = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics((0, $3vXh8.profileCardRendered)(profileType, 'spinner'));
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $b3ecabf9b19940d0$export$2e2bcd8739ae039 = $b3ecabf9b19940d0$var$LoadingState;

});
parcelRegister("kqibQ", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $9338621abe3237e0$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $9338621abe3237e0$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $9338621abe3237e0$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $9338621abe3237e0$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $9338621abe3237e0$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $9338621abe3237e0$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $9338621abe3237e0$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $9338621abe3237e0$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $9338621abe3237e0$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $9338621abe3237e0$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $9338621abe3237e0$export$2062e7265a95a823);
$parcel$export(module.exports, "FullNameLabel", () => $9338621abe3237e0$export$1270e9c1fc39142b);
$parcel$export(module.exports, "LozengeWrapper", () => $9338621abe3237e0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $9338621abe3237e0$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $9338621abe3237e0$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $9338621abe3237e0$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $9338621abe3237e0$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $9338621abe3237e0$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $9338621abe3237e0$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $9338621abe3237e0$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $9338621abe3237e0$export$b0ec2c767a0e0eab);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $9338621abe3237e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9338621abe3237e0$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
const $9338621abe3237e0$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo20"
})("background-color:", (0, $5PC5M.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, $lcnyw.gridSize)() * 45, "px;");
const $9338621abe3237e0$export$a7a74ab5cffd1455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo19"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $9338621abe3237e0$export$d395c8d16f1e359d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
});
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $9338621abe3237e0$var$kudosButtonAnimationTransformation = (0, $byn9U.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $9338621abe3237e0$export$b08abf2f97b92ea5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo17"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, $lcnyw.gridSize)() * 4 / (0, $lcnyw.fontSize)(), "em;animation-name:", $9338621abe3237e0$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $9338621abe3237e0$export$4a8a956251d4bf6f = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9338621abe3237e0$export$b08abf2f97b92ea5, {
        className: "kudos-blob-animation",
        ...props
    });
const $9338621abe3237e0$export$58517bb1b373a54c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo16"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $lcnyw.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $9338621abe3237e0$export$6196a3f52a6944fe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo15"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $9338621abe3237e0$export$73d695ae27330056 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo14"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$ff778e5b796745a6 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo13"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $9338621abe3237e0$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo12"
})("display:flex;flex-direction:column;min-height:", (0, $lcnyw.gridSize)() * 17, "px;");
const $9338621abe3237e0$export$35cf684daac137ac = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo11"
})("display:flex;flex-direction:column;margin-left:", (0, $lcnyw.gridSize)() * 14.5, "px;width:", (0, $lcnyw.gridSize)() * 24.5, "px;");
const $9338621abe3237e0$export$2062e7265a95a823 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo10"
})("font-size:", (0, $lcnyw.fontSizeSmall)(), "px;color:", (0, $5PC5M.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $9338621abe3237e0$export$1270e9c1fc39142b = /*#__PURE__*/ (0, $joBf7.default)("h2", {
    target: "e1ebb2vo9"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $5PC5M.headerTextColorInactive) : (0, $5PC5M.headerTextColor), ";margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$9338621abe3237e0$var$getFullNameMargin(props), ";}");
const $9338621abe3237e0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $9338621abe3237e0$export$6ebf103500ba5a45 = /*#__PURE__*/ (0, $joBf7.default)($9338621abe3237e0$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $9338621abe3237e0$export$d6c0e5f211c8d617 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $5PC5M.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$4865ffa72a4d5f9 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $5PC5M.appLabelBgColor), ";color:", (0, $5PC5M.appLabelTextColor), ";border-radius:", (0, $lcnyw.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
const $9338621abe3237e0$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo4"
})("align-items:center;display:flex;height:", (0, $lcnyw.gridSize)() * 12, "px;justify-content:center;position:relative;");
const $9338621abe3237e0$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $5PC5M.headerBgColorDisabledUser) : (0, $5PC5M.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, $lcnyw.gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5}, 0 0 1px ${0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $lcnyw.borderRadius)()}px`, ";overflow:hidden;");
const $9338621abe3237e0$export$138a08882ebf7289 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1ebb2vo2"
})("display:flex;align-items:center;line-height:24px;font-size:", (0, $lcnyw.gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
const $9338621abe3237e0$export$79d7d9b2f6a70c70 = /*#__PURE__*/ (0, $joBf7.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $5PC5M.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $9338621abe3237e0$export$b0ec2c767a0e0eab = /*#__PURE__*/ (0, $joBf7.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $5PC5M.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("5PC5M", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $94991c92a8b245c9$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $94991c92a8b245c9$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $94991c92a8b245c9$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $94991c92a8b245c9$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $94991c92a8b245c9$export$5c2df128da90e8de);
$parcel$export(module.exports, "headerTextColorInactive", () => $94991c92a8b245c9$export$a882617dcf7f98a6);
$parcel$export(module.exports, "appLabelBgColor", () => $94991c92a8b245c9$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $94991c92a8b245c9$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $94991c92a8b245c9$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $94991c92a8b245c9$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $94991c92a8b245c9$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $94991c92a8b245c9$export$be3c814f7ed506ed);
$parcel$export(module.exports, "errorTextColor", () => $94991c92a8b245c9$export$ddf766d3bfcf965c);

const $94991c92a8b245c9$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`;
const $94991c92a8b245c9$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`;
const $94991c92a8b245c9$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $94991c92a8b245c9$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $94991c92a8b245c9$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $94991c92a8b245c9$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
const $94991c92a8b245c9$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$c2e91cbeada39b8b)})`;
const $94991c92a8b245c9$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
const $94991c92a8b245c9$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
const $94991c92a8b245c9$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;

});



parcelRegister("iINHb", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => (parcelRequire("9Pgj1")).ErrorBoundary);
$parcel$export(module.exports, "ErrorIllustration", () => (parcelRequire("8J4a2")).ErrorIllustration);
$parcel$export(module.exports, "ErrorMessage", () => (parcelRequire("4ga2m")).default);

var $9Pgj1 = parcelRequire("9Pgj1");

var $8J4a2 = parcelRequire("8J4a2");

var $4ga2m = parcelRequire("4ga2m");

});
parcelRegister("9Pgj1", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $4fd3e125f285a7c7$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $4fd3e125f285a7c7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $4fd3e125f285a7c7$export$2e2bcd8739ae039 = $4fd3e125f285a7c7$export$e926676385687eaf;

});

parcelRegister("8J4a2", function(module, exports) {

$parcel$export(module.exports, "ErrorIllustration", () => $87687304f7d83e3d$export$e0319f52fc2380b1);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $87687304f7d83e3d$export$e0319f52fc2380b1 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "var(--ds-surface-overlay, white)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
};

});

parcelRegister("4ga2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d3bd21855e22f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5k4ch = parcelRequire("5k4ch");

var $fnJ1y = parcelRequire("fnJ1y");

var $3vXh8 = parcelRequire("3vXh8");
const $486d3bd21855e22f$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "The user is no longer available for the site");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorTitle), null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorText), null, "Try again and we\u2019ll give it another shot"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        label: "icon error",
        size: "xlarge"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: reload
    }, "Try again"));
};
var $486d3bd21855e22f$export$2e2bcd8739ae039 = $486d3bd21855e22f$var$ErrorMessage;

});
parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::143bcc99e3b5fbdcb049ce3958503a90>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: clear text field, error status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});


parcelRegister("fnJ1y", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0ffb74661b2a3e3e$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0ffb74661b2a3e3e$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorText", () => $0ffb74661b2a3e3e$export$7f714e6c560938e5);
$parcel$export(module.exports, "TeamErrorTitle", () => $0ffb74661b2a3e3e$export$d139ade0bdee219d);
$parcel$export(module.exports, "TeamErrorText", () => $0ffb74661b2a3e3e$export$90d92ccfb27352c6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
const $0ffb74661b2a3e3e$export$bb27b7e39840238f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1g2atxt4"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorIconColor)
});
const $0ffb74661b2a3e3e$export$b065fd053267ec81 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTitleColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $lcnyw.gridSize)() * 3}px`,
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0ffb74661b2a3e3e$export$7f714e6c560938e5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1g2atxt2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.errorTextColor)
});
const $0ffb74661b2a3e3e$export$d139ade0bdee219d = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt1"
})((0, $4lTFP.h400));
const $0ffb74661b2a3e3e$export$90d92ccfb27352c6 = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e1g2atxt0"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});



parcelRegister("dDnjt", function(module, exports) {

$parcel$export(module.exports, "AgentActions", () => $4ca46e58b113fec1$export$a091e6fbe251d12f);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");

var $6Rnl4 = parcelRequire("6Rnl4");
const $4ca46e58b113fec1$var$chatToAgentButtonContainer = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $4ca46e58b113fec1$var$buttonStyles = (0, $1ZAYh.xcss)({
    borderRadius: '3px',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $4ca46e58b113fec1$var$chatToAgentButtonWrapper = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '20px',
    padding: 'space.075',
    fontWeight: '500'
});
const $4ca46e58b113fec1$var$chatPillButtonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $4ca46e58b113fec1$var$chatPillTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left',
    whiteSpace: 'pre-wrap'
});
const $4ca46e58b113fec1$var$chatPillIconWrapper = (0, $1ZAYh.xcss)({
    minWidth: '20px',
    height: '20px'
});
const $4ca46e58b113fec1$var$actopnsWrapperStyles = (0, $1ZAYh.xcss)({
    borderTop: '1px',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200',
    marginBlockStart: 'space.200',
    color: 'color.text'
});
const $4ca46e58b113fec1$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionDuplicate),
            onClick: onDuplicateAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionCopyLink),
            onClick: onCopyAgent
        }
    ];
};
const $4ca46e58b113fec1$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionEdit),
            onClick: onEditAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $4ca46e58b113fec1$var$messages.actionDelete),
            onClick: onDeleteAgent
        }
    ];
};
const $4ca46e58b113fec1$export$a091e6fbe251d12f = ({ isAgentCreatedByCurrentUser: isAgentCreatedByCurrentUser, onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $eUqFw.useState)(false);
    const agentActions = $4ca46e58b113fec1$var$buildAgentActions({
        onDuplicateAgent: onDuplicateAgent,
        onCopyAgent: onCopyAgent
    });
    const agentSetting = $4ca46e58b113fec1$var$buildAgentSettings({
        onEditAgent: onEditAgent,
        onDeleteAgent: ()=>{
            setIsDeleteModalOpen(true);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        xcss: $4ca46e58b113fec1$var$actopnsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $4ca46e58b113fec1$var$chatToAgentButtonContainer,
            $4ca46e58b113fec1$var$buttonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        shouldFitContainer: true,
        onClick: onChatClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatToAgentButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $4ca46e58b113fec1$var$chatPillButtonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatPillIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca46e58b113fec1$var$chatPillTextStyles
    }, formatMessage($4ca46e58b113fec1$var$messages.actionChatToAgent)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $4ca46e58b113fec1$var$buttonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
                label: "more",
                ref: triggerRef
            })),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: onClick
        }, text);
    })), isAgentCreatedByCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: true
    }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: onClick
        }, text);
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Rnl4.AgentDeleteConfirmationModal), {
        isOpen: isDeleteModalOpen,
        onClose: ()=>{
            setIsDeleteModalOpen(false);
        },
        onSubmit: onDeleteAgent,
        agentId: 'some Id',
        agentName: "agentName"
    }));
};
const $4ca46e58b113fec1$var$messages = (0, $90IgZ.defineMessages)({
    actionChatToAgent: {
        id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
        defaultMessage: 'Chat to Agent',
        description: 'Text for the "chat to agent" action to chat to the agent'
    },
    actionDelete: {
        id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
        defaultMessage: 'Delete Agent',
        description: 'Text for the "Delete" action to delete an agent'
    },
    actionEdit: {
        id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
        defaultMessage: 'Edit Agent',
        description: 'Text for the "Edit" action to edit an agent'
    },
    actionCopyLink: {
        id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
        defaultMessage: 'Copy link',
        description: 'Text for the Copy link of an agent'
    },
    actionDuplicate: {
        id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
        defaultMessage: 'Duplicate Agent',
        description: 'Text for the Duplicate Agent action to create a duplicate'
    }
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("ki32l", function(module, exports) {

$parcel$export(module.exports, "useId", () => $3c6f36e551c6b75b$export$f680877a34711e37);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $XHGTv = parcelRequire("XHGTv");
// @ts-ignore - useId is not accessible in React 16
const $3c6f36e551c6b75b$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useId ?? undefined;
function $3c6f36e551c6b75b$export$f680877a34711e37() {
    if ($3c6f36e551c6b75b$var$react18UseId && (0, $XHGTv.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $3c6f36e551c6b75b$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jFtVs.useUID)();
}
function $3c6f36e551c6b75b$export$6ee17796e3d70de2() {
    if ($3c6f36e551c6b75b$var$react18UseId && (0, $XHGTv.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const uid = $3c6f36e551c6b75b$var$react18UseId();
        return (id)=>`${uid}-${id.toString()}`;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jFtVs.useUIDSeed)();
}

});

parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("34Io4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::814443588b4f2d6fcc3849858668de22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d42d3583f8fd73$var$_react = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23d42d3583f8fd73$var$_showMoreHorizontal = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $23d42d3583f8fd73$var$_more = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("jG1wZ")));
function $23d42d3583f8fd73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d42d3583f8fd73$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $23d42d3583f8fd73$var$_react.default.createElement($23d42d3583f8fd73$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $23d42d3583f8fd73$var$_more.default
    }, props));
$23d42d3583f8fd73$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $23d42d3583f8fd73$var$_default = module.exports.default = $23d42d3583f8fd73$var$ShowMoreHorizontalIcon;

});

parcelRegister("kDlNh", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $a3e4a399a3fc0cd1$export$38f9b635c1c454e7);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a3e4a399a3fc0cd1$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fill: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "9",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));
const $a3e4a399a3fc0cd1$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $a3e4a399a3fc0cd1$var$CustomGlyph,
        label: "",
        size: "small"
    });

});

parcelRegister("6Rnl4", function(module, exports) {

$parcel$export(module.exports, "AgentDeleteConfirmationModal", () => $c2674505d54c0f56$export$39d869cf16a68f79);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $1Yimi = parcelRequire("1Yimi");
const $c2674505d54c0f56$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, isOpen: isOpen, onSubmit: onSubmit, agentId: agentId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleDeleteAgent = (0, $eUqFw.useCallback)(async ()=>{
        if (agentId) {
            await onSubmit();
            onClose();
        }
    }, [
        agentId,
        onClose,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage($c2674505d54c0f56$var$messages.title, {
        agentName: agentName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage($c2674505d54c0f56$var$messages.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage($c2674505d54c0f56$var$messages.cancelText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "danger",
        onClick: (_e, event)=>{
            handleDeleteAgent();
        }
    }, formatMessage($c2674505d54c0f56$var$messages.confirmText))))));
};
const $c2674505d54c0f56$var$messages = (0, $90IgZ.defineMessages)({
    cancelText: {
        id: 'ai-mate.agent-modal.agent-delete-confirm.cancel-text',
        defaultMessage: 'Cancel'
    },
    confirmText: {
        id: 'ai-mate.agent-modal.agent-delete-confirm.confirm-text',
        defaultMessage: 'Delete'
    },
    title: {
        id: 'ai-mate.agent-list.delete-agent-confirm-title',
        defaultMessage: 'Delete "{agentName}"?',
        description: 'Title text for the delete agent confirmation modal'
    },
    body: {
        id: 'ai-mate.agent-list.delete-agent-confirm-body',
        defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
        description: 'Body text for the delete agent confirmation modal'
    },
    error: {
        id: 'ai-mate.agent-list.delete-agent-error',
        defaultMessage: 'Could not delete agent',
        description: 'Error message displayed when an agent cannot be deleted'
    },
    errorAgentNotFound: {
        id: 'ai-mate.agent-list.delete-agent-error.agent-not-found',
        defaultMessage: 'That agent could not be found.',
        description: 'Error message displayed when an agent cannot be found'
    },
    errorAgentInUse: {
        id: 'ai-mate.agent-list.delete-agent-error.agent-in-use',
        defaultMessage: 'Agent is currently in use. Try again later.',
        description: 'Error message displayed when an agent is in use'
    },
    errorIncorrectOwner: {
        id: 'ai-mate.agent-list.delete-agent-error.incorrect-owner',
        defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
        description: 'Error message displayed when the agent owner is incorrect'
    },
    agentDeletedSuccess: {
        id: 'ai-mate.agent-list.delete-agent-success',
        defaultMessage: 'Agent has been deleted!',
        description: 'Success message displayed when an agent is deleted'
    }
});

});


parcelRegister("kCTG1", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $66858e19046e4863$export$2c6604b50c274e6f);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $66858e19046e4863$var$styles = (0, $1ZAYh.xcss)({
    width: '360px'
});
const $66858e19046e4863$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $66858e19046e4863$var$styles
    }, children);
};

});

parcelRegister("1Z0pV", function(module, exports) {

$parcel$export(module.exports, "ConversationStarters", () => $7d1e0be3836402a9$export$ea338c37011da44c);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $fc0pM = parcelRequire("fc0pM");
const $7d1e0be3836402a9$export$ea338c37011da44c = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
    const handleConversationStarterClick = (conversationStarter)=>{
        onConversationStarterClick(conversationStarter);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fc0pM.AgentConversationStarters), {
        isAgentDefault: isAgentDefault,
        onConversationStarterClick: handleConversationStarterClick,
        userDefinedConversationStarters: userDefinedConversationStarters
    }));
};

});
parcelRegister("fc0pM", function(module, exports) {

$parcel$export(module.exports, "getConversationStarters", () => $09834075c65ca3b7$export$c2d882153e0984c5);
$parcel$export(module.exports, "AgentConversationStarters", () => $09834075c65ca3b7$export$171adfc74aa509c3);
$parcel$export(module.exports, "ConversationStarters", () => $09834075c65ca3b7$export$ea338c37011da44c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $iAqay = parcelRequire("iAqay");

var $9Amv1 = parcelRequire("9Amv1");

var $i1PAb = parcelRequire("i1PAb");

var $8qJMo = parcelRequire("8qJMo");
const $09834075c65ca3b7$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const customAgentConversationStarters = [
        (0, $8qJMo.messages).agentEmptyStateSuggestion1,
        (0, $8qJMo.messages).agentEmptyStateSuggestion2,
        (0, $8qJMo.messages).agentEmptyStateSuggestion3
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        (0, $8qJMo.messages).emptyStateSuggestion1,
        (0, $8qJMo.messages).emptyStateSuggestion2,
        (0, $8qJMo.messages).emptyStateSuggestion3
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return default suggestions + user defined suggestions with a max of 3 suggestions
        return [
            ...customAgentConversationStarters.slice(0, 3 - userDefinedConversationStarters.length),
            ...userDefinedConversationStarters
        ];
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $09834075c65ca3b7$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $eUqFw.useMemo)(()=>$09834075c65ca3b7$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $eUqFw.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter === 'string' ? starter : formatMessage(starter)), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09834075c65ca3b7$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $09834075c65ca3b7$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, starters.map((starter, index)=>{
        const isLastStarter = index === starters.length - 1;
        const chatPill = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i1PAb.ChatPill), {
            testId: "conversation-starter",
            key: starter,
            onClick: ()=>onConversationStarterClick(starter)
        }, starter);
        return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050",
            grow: "fill",
            alignInline: "end",
            key: starter
        }, chatPill, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAqay))),
            onClick: onReloadButtonClick,
            appearance: "subtle",
            label: ""
        })) : chatPill;
    }));
};

});
parcelRegister("iAqay", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8d429e90ba478b1ecddd093004aa6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d87fe36e3f00d89c$var$_react = $d87fe36e3f00d89c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d87fe36e3f00d89c$var$_UNSAFE_baseNew = $d87fe36e3f00d89c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d87fe36e3f00d89c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d87fe36e3f00d89c$var$RetryIcon = (props)=>/*#__PURE__*/ $d87fe36e3f00d89c$var$_react.default.createElement($d87fe36e3f00d89c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v3"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.375 8.375 12.75 11l-2.625-2.625"/>`
    }, props));
$d87fe36e3f00d89c$var$RetryIcon.displayName = 'RetryIcon';
var $d87fe36e3f00d89c$var$_default = module.exports.default = $d87fe36e3f00d89c$var$RetryIcon;

});

parcelRegister("i1PAb", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $54ff5c9d6063b7a8$export$e33faa86e0996d96);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");
const $54ff5c9d6063b7a8$var$buttonStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    padding: 'space.100',
    borderRadius: 'border.radius.200',
    borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
    lineHeight: '16px',
    fontWeight: '500',
    fontSize: '14px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 1,
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $54ff5c9d6063b7a8$var$buttonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $54ff5c9d6063b7a8$var$queryTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left'
});
const $54ff5c9d6063b7a8$var$whiteSpacePreWrapStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'pre-wrap'
});
const $54ff5c9d6063b7a8$export$e33faa86e0996d96 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ref: ref,
        ...props,
        xcss: $54ff5c9d6063b7a8$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $54ff5c9d6063b7a8$var$buttonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $54ff5c9d6063b7a8$var$queryTextStyles,
            whiteSpacePreWrap && $54ff5c9d6063b7a8$var$whiteSpacePreWrapStyles
        ]
    }, children))));

});

parcelRegister("8qJMo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e80cab5507804e86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e80cab5507804e86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    emptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.suggestion1',
        defaultMessage: 'Are any of my tickets overdue?',
        description: 'The first suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.suggestion2',
        defaultMessage: 'What should I work on next?',
        description: 'The second suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.suggestion3',
        defaultMessage: 'Write an update about my week',
        description: 'The third suggestion displayed in the empty state of the chat history'
    },
    agentEmptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
        defaultMessage: 'Tell me about yourself',
        description: 'The first suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
        defaultMessage: 'What can you help me with?',
        description: 'The second suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
        defaultMessage: "Summarize what I'm looking at",
        description: 'The third suggestion displayed in the empty state when an agent is selected'
    }
});

});



parcelRegister("2TnXV", function(module, exports) {

$parcel$export(module.exports, "useAgentUrlActions", () => $934b89b97dc0779a$export$56665b80ee272742);

var $eUqFw = parcelRequire("eUqFw");

var $bW292 = parcelRequire("bW292");

var $2b1Yl = parcelRequire("2b1Yl");
const $934b89b97dc0779a$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $934b89b97dc0779a$var$ROVO_PARAM_PREFIX = 'rovoChat';
const $934b89b97dc0779a$var$createRovoParams = (params)=>{
    const rovoParams = {};
    Object.entries(params).forEach(([key, value])=>{
        rovoParams[`${$934b89b97dc0779a$var$ROVO_PARAM_PREFIX}.${key}`] = encodeURIComponent(value);
        rovoParams[`${$934b89b97dc0779a$var$ROVO_PARAM_PREFIX}${$934b89b97dc0779a$export$fda91e425d265029(key)}`] = encodeURIComponent(value);
    });
    return rovoParams;
};
const $934b89b97dc0779a$export$56665b80ee272742 = ({ cloudId: cloudId })=>{
    const onEditAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const url = `${(0, $bW292.getATLContextUrl)('home')}/agents/${agentId}/edit`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(url, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    }, [
        cloudId
    ]);
    const onCopyAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId,
                agentId: agentId,
                pathway: 'chat'
            })
        });
        navigator.clipboard.writeText(urlWithParams);
    }, [
        cloudId
    ]);
    const onDuplicateAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat/agents/new`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId,
                agentId: agentId,
                pathway: 'agents-create'
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    }, [
        cloudId
    ]);
    const onConversationStarter = ({ agentId: agentId, prompt: prompt })=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId,
                agentId: agentId,
                prompt: prompt
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    };
    const onOpenChat = ()=>{
        const baseUrl = `${(0, $bW292.getATLContextUrl)('home')}/chat`;
        const urlWithParams = (0, $2b1Yl.encodeParamsToUrl)(baseUrl, {
            cloudId: cloudId,
            ...$934b89b97dc0779a$var$createRovoParams({
                cloudId: cloudId
            })
        });
        window.open(urlWithParams, '_blank', 'noopener, noreferrer');
    };
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent,
        onOpenChat: onOpenChat,
        onConversationStarter: onConversationStarter
    };
};

});
parcelRegister("2b1Yl", function(module, exports) {

$parcel$export(module.exports, "encodeParamsToUrl", () => $fdbe762c1a952693$export$3220405ab77f2c5d);
const $fdbe762c1a952693$export$3220405ab77f2c5d = (baseUrl, params)=>{
    const url = new URL(baseUrl);
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params))searchParams.append(key, String(value));
    url.search = searchParams.toString();
    return url.toString();
};

});


parcelRegister("1c2zu", function(module, exports) {

$parcel$export(module.exports, "useDeleteAgent", () => $b6bb5f8fe78b020c$export$89877d4f8d8790ca);

var $eUqFw = parcelRequire("eUqFw");

var $6oOPK = parcelRequire("6oOPK");
const $b6bb5f8fe78b020c$export$89877d4f8d8790ca = ({ cloudId: cloudId, product: product })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const deleteAgent = async (agentId)=>{
        if (!agentId || !cloudId) return;
        setIsLoading(true);
        try {
            const headers = (0, $6oOPK.createHeaders)(product, cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            }));
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            setError(error);
        }
    };
    return {
        isLoading: isLoading,
        error: error,
        deleteAgent: deleteAgent
    };
};

});

parcelRegister("iRjU7", function(module, exports) {

$parcel$export(module.exports, "useSetFavouriteAgent", () => $fe0270b8520c2af7$export$1e511e95a8fac655);

var $eUqFw = parcelRequire("eUqFw");

var $6oOPK = parcelRequire("6oOPK");
const $fe0270b8520c2af7$export$1e511e95a8fac655 = ({ agentId: agentId, cloudId: cloudId, isStarred: isStarred, product: product })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isFavourite, setIsFavourite] = (0, $eUqFw.useState)(isStarred);
    const setFavourite = async ()=>{
        if (!agentId || !cloudId) return;
        setIsLoading(true);
        try {
            const headers = (0, $6oOPK.createHeaders)(product, cloudId);
            if (isFavourite) await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                setIsFavourite(true);
            });
            else await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                setIsFavourite(false);
            });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    return {
        isLoading: isLoading,
        isStarred: isFavourite,
        setFavourite: // hasError: Boolean(error) || cannotLoadUser,
        setFavourite
    };
};

});


parcelRegister("94Fw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80709e37e35f48e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $aCbpp = parcelRequire("aCbpp");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");


var $cEOpo = parcelRequire("cEOpo");
parcelRequire("iINHb");
var $9Pgj1 = parcelRequire("9Pgj1");

var $j7pJq = parcelRequire("j7pJq");

var $dO06T = parcelRequire("dO06T");
class $b80709e37e35f48e$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link'
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl()
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $5Jx7I.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).giveKudosButton),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Pgj1.ErrorBoundary), {
            onError: this.onErrorBoundary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: !!this.state.visible,
            onClose: this.onClose,
            placement: this.props.position,
            content: this.renderProfileCard,
            trigger: (triggerProps)=>this.renderTrigger(triggerProps),
            zIndex: (0, $lcnyw.layers).modal(),
            shouldFlip: true,
            autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
            shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
        }));
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $cEOpo.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $cEOpo.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $7NIUg.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $3vXh8.cardTriggered)('team', 'click'));
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $3vXh8.cardTriggered)('team', 'hover'));
            }
            this.showProfilecard((0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $515c9dbc88c31cf4$export$89a9f35a94d7f196));
        };
        this.onClose = ()=>{
            this.hideProfilecard();
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $515c9dbc88c31cf4$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $3vXh8.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", this.cardListeners, this.state.visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dO06T.default), {
                    analytics: this.fireAnalyticsWithDuration
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7pJq.TeamProfileCardLazy), {
                ...newProps,
                isLoading: isLoading,
                hasError: hasError,
                errorType: error
            })));
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
                isOpen: this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, $btCBO.KudosType).TEAM,
                    recipientId: this.props.teamId
                },
                analyticsSource: "team-profile-card",
                teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                cloudId: this.props.cloudId || '',
                addFlag: this.props.addFlag,
                onClose: this.closeKudosDrawer
            }));
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "data-testid": "team-profilecard-trigger-wrapper",
                ...triggerProps,
                ...this.triggerListeners
            }, children));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                "data-testid": "team-profilecard-trigger-wrapper",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: 'initial',
                    textDecoration: 'none'
                },
                href: viewProfileLink,
                ...triggerProps,
                ref: triggerProps.ref,
                ...this.triggerListeners
            }, children));
        };
    }
}
var $b80709e37e35f48e$export$2e2bcd8739ae039 = (0, $2jDha.default)()($b80709e37e35f48e$export$f811dc569217c959);

});
parcelRegister("dx7Op", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $1be4d1ec21b65937$export$93fe397a02fe8b76);

var $eUqFw = parcelRequire("eUqFw");

const $1be4d1ec21b65937$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("koXTq")));

});
parcelRegister("koXTq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('dSAyy')
        ]);
        const value = parcelRequire('5A0d0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("dSAyy")
    ]).then(()=>parcelRequire('5A0d0'));
}

});


parcelRegister("btCBO", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $5cf31a8d69eb9e81$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $5cf31a8d69eb9e81$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $5cf31a8d69eb9e81$export$7a1fc1a1b0477464);
var $5cf31a8d69eb9e81$export$4fa2020056771264;
(function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
})($5cf31a8d69eb9e81$export$4fa2020056771264 || ($5cf31a8d69eb9e81$export$4fa2020056771264 = {}));
var $5cf31a8d69eb9e81$export$d21f9befaa2961a;
(function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
})($5cf31a8d69eb9e81$export$d21f9befaa2961a || ($5cf31a8d69eb9e81$export$d21f9befaa2961a = {}));
const $5cf31a8d69eb9e81$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($5cf31a8d69eb9e81$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("5Jx7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c805980c1a8d0797$export$2e2bcd8739ae039);
const $c805980c1a8d0797$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $c805980c1a8d0797$export$2e2bcd8739ae039 = $c805980c1a8d0797$var$filterActions;

});

parcelRegister("aCbpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $99816a416a8a70ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $99816a416a8a70ef$var$messages = (0, $90IgZ.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    }
});
var $99816a416a8a70ef$export$2e2bcd8739ae039 = $99816a416a8a70ef$var$messages;

});

parcelRegister("7NIUg", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $211cf3e2277295bb$export$eddcd8a5b7e09991);
const $211cf3e2277295bb$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $515c9dbc88c31cf4$export$5b956b542f1bc1b3 = 800;
const $515c9dbc88c31cf4$export$89a9f35a94d7f196 = 200;

parcelRegister("j7pJq", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $5ae4a5a4fd9fbf1e$export$82a49d896f41ca78);

var $eUqFw = parcelRequire("eUqFw");

const $5ae4a5a4fd9fbf1e$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("g8DVf"))));

});
parcelRegister("g8DVf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b92b2ec2eaaa8f9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4XQdE = parcelRequire("4XQdE");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $51sCz = parcelRequire("51sCz");

var $34Io4 = parcelRequire("34Io4");

var $bo4OB = parcelRequire("bo4OB");
var $8PFhw = parcelRequire("8PFhw");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $fnJ1y = parcelRequire("fnJ1y");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");
parcelRequire("iINHb");
var $8J4a2 = parcelRequire("8J4a2");

var $22Tpa = parcelRequire("22Tpa");

var $dO06T = parcelRequire("dO06T");
const $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT = 50;
const $b92b2ec2eaaa8f9d$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
function $b92b2ec2eaaa8f9d$var$onMemberClick(callback, userId, analytics, index, hasHref) {
    return (event)=>{
        analytics((duration)=>(0, $3vXh8.teamAvatarClicked)({
                duration: duration,
                hasHref: hasHref,
                hasOnClick: !!callback,
                index: index
            }));
        if (callback) callback(userId, event);
    };
}
const $b92b2ec2eaaa8f9d$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou })=>{
    const count = members ? members.length : 0;
    const message = includingYou ? count >= $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT ? (0, $aCbpp.default).membersMoreThan50IncludingYou : (0, $aCbpp.default).memberCountIncludingYou : count >= $b92b2ec2eaaa8f9d$var$LARGE_MEMBER_COUNT ? (0, $aCbpp.default).membersMoreThan50 : (0, $aCbpp.default).memberCount;
    // Use a ref to track whether this is currently open, so we can fire events
    // iff the more section is being opened (not closed).
    const isMoreMembersOpen = (0, $eUqFw.useRef)(false);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>{
        const { current: isOpen } = isMoreMembersOpen;
        if (!isOpen) analytics((duration)=>(0, $3vXh8.moreMembersClicked)({
                duration: duration,
                memberCount: count
            }));
        isMoreMembersOpen.current = !isOpen;
    }, [
        analytics,
        count
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.MemberCount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...message,
        values: {
            count: count
        }
    })), members && members.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.AvatarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: members.map((member, index)=>{
            const href = generateUserLink?.(member.id);
            const onClick = $b92b2ec2eaaa8f9d$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
            return {
                key: member.id,
                name: member.fullName,
                src: member.avatarUrl,
                href: href,
                onClick: onClick
            };
        }),
        maxCount: 9,
        showMoreButtonProps: {
            onClick: onMoreClick
        },
        testId: "profilecard-avatar-group"
    })));
};
function $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index) {
    return (event, ...args)=>{
        analytics((duration)=>(0, $3vXh8.actionClicked)('team', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || ''
            }));
        if (action.callback && (0, $7NIUg.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    };
}
const $b92b2ec2eaaa8f9d$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
    const isGiveKudosActionButton = action.id === $b92b2ec2eaaa8f9d$var$GIVE_KUDOS_ACTION_ID;
    const actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        key: action.id || index,
        onClick: $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index),
        href: action.link,
        shouldFitContainer: true
    }, action.label, isGiveKudosActionButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.KudosBlobAnimation), null))));
    if (isGiveKudosActionButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimatedKudosButton), null, actionButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.WrappedButton), null, actionButton);
};
const $b92b2ec2eaaa8f9d$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
    const [isOpen, setOpen] = (0, $eUqFw.useState)(false);
    const count = actions.length;
    const onMoreClick = (0, $eUqFw.useCallback)((shouldBeOpen)=>{
        if (shouldBeOpen) // Only fire this event when OPENING the dropdown
        analytics((duration)=>(0, $3vXh8.moreActionsClicked)('team', {
                duration: duration,
                numActions: count + 2
            }));
        setOpen(shouldBeOpen);
    }, [
        analytics,
        count
    ]);
    if (!count) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.MoreButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
                    onClick: $b92b2ec2eaaa8f9d$var$onActionClick(action, analytics, index + 2),
                    key: action.id || index,
                    href: action.link
                }, action.label))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                testId: "more-actions-button",
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>onMoreClick(!isOpen),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                    spacing: "spacious",
                    label: "actions",
                    color: "currentColor"
                })
            }),
        zIndex: (0, $lcnyw.layers).modal(),
        shouldRenderToParent: (0, $XHGTv.fg)('enable_appropriate_reading_order_in_profile_card')
    }));
};
const $b92b2ec2eaaa8f9d$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
    if (!actions) return null;
    const extraActions = actions.slice(2);
    const initialActions = actions.slice(0, 2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.ActionButtons), null, initialActions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ActionButton, {
            action: action,
            analytics: analytics,
            index: index,
            key: index
        })), extraActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ExtraActions, {
        actions: extraActions,
        analytics: analytics
    }));
};
const $b92b2ec2eaaa8f9d$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick })=>{
    const allActions = [
        {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamViewProfile),
            link: viewProfileLink,
            callback: viewProfileOnClick,
            id: 'view-profile'
        },
        ...actions || []
    ];
    const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'content', {
                duration: duration,
                numActions: allActions.length,
                memberCount: team.members?.length,
                includingYou: includingYou,
                descriptionLength: team.description.length,
                titleLength: team.displayName.length
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardHeader), {
        image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: team.displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.TeamName), null, team.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$TeamMembers, {
        analytics: analytics,
        members: team.members,
        generateUserLink: generateUserLink,
        includingYou: includingYou,
        onUserClick: onUserClick
    }), team.description.trim() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.DescriptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.Description), null, team.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ButtonSection, {
        actions: allActions,
        analytics: analytics
    })));
};
const $b92b2ec2eaaa8f9d$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
    const hasRetry = !!clientFetchProfile;
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'error', {
                duration: duration,
                hasRetry: hasRetry
            }));
    }, [
        analytics,
        hasRetry
    ]);
    const retry = (0, $eUqFw.useCallback)(()=>{
        analytics((duration)=>(0, $3vXh8.errorRetryClicked)({
                duration: duration
            }));
        if (clientFetchProfile) clientFetchProfile();
    }, [
        analytics,
        clientFetchProfile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.ErrorWrapper), {
        "data-testid": "team-profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8J4a2.ErrorIllustration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.TeamErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fnJ1y.TeamErrorText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorText)), clientFetchProfile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.ActionButtons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.WrappedButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "client-fetch-profile-button",
        shouldFitContainer: true,
        onClick: retry,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).teamErrorButton)))));
};
const $b92b2ec2eaaa8f9d$var$TeamProfileCard = (props)=>{
    const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
    if (hasError) {
        if (errorType?.reason === 'TEAMS_FORBIDDEN') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22Tpa.default), {
            analytics: analytics
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
            "data-testid": "team-profilecard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$ErrorMessage, {
            analytics: analytics,
            clientFetchProfile: clientFetchProfile,
            isLoading: isLoading
        }));
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dO06T.default), {
        analytics: analytics
    });
    if (team) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b92b2ec2eaaa8f9d$var$TeamProfilecardContent, {
        ...props,
        team: team
    });
    return null;
};
var $b92b2ec2eaaa8f9d$export$2e2bcd8739ae039 = $b92b2ec2eaaa8f9d$var$TeamProfileCard;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("dRbkr", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $44bed1e2692b7853$export$6aa22a823032b784);
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $44bed1e2692b7853$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "CardHeader", () => $44bed1e2692b7853$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $44bed1e2692b7853$export$64ef9b8c11710c47);
$parcel$export(module.exports, "TeamName", () => $44bed1e2692b7853$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $44bed1e2692b7853$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $44bed1e2692b7853$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $44bed1e2692b7853$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $44bed1e2692b7853$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $44bed1e2692b7853$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $44bed1e2692b7853$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $44bed1e2692b7853$export$7f94856880993f27);
$parcel$export(module.exports, "LoadingWrapper", () => $44bed1e2692b7853$export$43a792a870d28db2);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $44bed1e2692b7853$export$71bcd744fda975e5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $44bed1e2692b7853$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44bed1e2692b7853$export$a443be8291b92497 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f414"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $44bed1e2692b7853$export$6aa22a823032b784 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f413"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $5PC5M.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lcnyw.gridSize)() * 40}px`,
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $44bed1e2692b7853$export$66ecf3d3b7b1c016 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f412"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lcnyw.gridSize)() * 40}px`,
    position: 'relative'
});
const $44bed1e2692b7853$export$5665775b26e26c5d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f411"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $5PC5M.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:", (0, $lcnyw.gridSize)() * 16, "px;");
const $44bed1e2692b7853$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f410"
})({
    display: 'flex',
    flexDirection: 'column',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lcnyw.gridSize)() * 13}px`
});
const $44bed1e2692b7853$export$8fe6f0aed18a58c7 = /*#__PURE__*/ (0, $joBf7.default)("h6", {
    target: "e1kkd6f49"
})((0, $4lTFP.h600), "text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
const $44bed1e2692b7853$export$1cbd03a20253b620 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f48"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-050, 4px)"
});
const $44bed1e2692b7853$export$82a6f3ee677bdbfe = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f47"
})({
    name: "li9rw7",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
});
const $44bed1e2692b7853$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f46"
})({
    name: "vi4bqq",
    styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
});
const $44bed1e2692b7853$export$393edc798c47379d = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1kkd6f45"
})({
    name: "yog5y2",
    styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
});
const $44bed1e2692b7853$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f44"
})({
    width: 'calc(100% + 8px)',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
const $44bed1e2692b7853$export$44e087c32db6077d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f43"
})({
    name: "1svotkm",
    styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
});
const $44bed1e2692b7853$export$7f94856880993f27 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f42"
})({
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
});
const $44bed1e2692b7853$export$43a792a870d28db2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f41"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});
const $44bed1e2692b7853$export$71bcd744fda975e5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1kkd6f40"
})({
    name: "ifz8jz",
    styles: "margin-bottom:var(--ds-space-300, 24px)"
}); // export const LoadingTeamName = styled.div`
 //   width: 175px;
 //   height: ${gridSize () *3)px;
 //   border-radius: ${borderRadius}px;
 //   background-color: #f4f5f7;
 // `;
 // export const LoadingMemberCount = styled.div`
 //   width: 81px;
 //   height: ${gridSize () *2)px;
 //   border-radius: 3px;
 //   background-color: #f4f5f7;
 //   margin: 4px 0;
 // `;

});

parcelRegister("22Tpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $479bbf795543ee24$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $220ac = parcelRequire("220ac");

var $aCbpp = parcelRequire("aCbpp");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");

var $1eRuZ = parcelRequire("1eRuZ");
var $479bbf795543ee24$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    const intl = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'error', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.TeamForbiddenErrorStateWrapper), {
        "data-testid": "team-profilecard-forbidden-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: intl.formatMessage((0, $aCbpp.default).teamForbiddenErrorStateTitle),
        description: intl.formatMessage((0, $aCbpp.default).teamForbiddenErrorStateDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.AccessLockSVGWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eRuZ.default), null))
    }));
};

});
parcelRegister("1eRuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f333fc6edfa90ad9$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");
const $f333fc6edfa90ad9$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'multiply'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
        fill: "#FFE380"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
        fill: "#FFFAE5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white"
    }))));
};
var $f333fc6edfa90ad9$export$2e2bcd8739ae039 = $f333fc6edfa90ad9$var$AccessLockSVG;

});


parcelRegister("dO06T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aac33fd408e01e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $dRbkr = parcelRequire("dRbkr");

var $3vXh8 = parcelRequire("3vXh8");
var $5aac33fd408e01e7$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $eUqFw.useEffect)(()=>{
        analytics((duration)=>(0, $3vXh8.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardHeader), {
        isLoading: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRbkr.LoadingWrapper), {
        "data-testid": "team-profilecard-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))));
};

});




parcelRegister("ehM5E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProfilecardInternal", () => $aaa133bbdb29f425$export$64e0275ede8ab792);
$parcel$export(module.exports, "default", () => $aaa133bbdb29f425$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $2jDha = parcelRequire("2jDha");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $51sCz = parcelRequire("51sCz");

var $4Bees = parcelRequire("4Bees");


var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");

var $7NIUg = parcelRequire("7NIUg");

var $cEOpo = parcelRequire("cEOpo");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $g8EW1 = parcelRequire("g8EW1");

var $gXyvb = parcelRequire("gXyvb");
const $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $aaa133bbdb29f425$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
    const kudosUrl = (0, $eUqFw.useMemo)(()=>{
        const recipientId = userId ? `&recipientId=${userId}` : '';
        const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
        return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
    }, [
        cloudId,
        teamCentralBaseUrl,
        userId
    ]);
    const kudosButtonCallback = (0, $eUqFw.useCallback)(()=>{
        if (openKudosDrawer) openKudosDrawer();
        else window.open(kudosUrl);
    }, [
        kudosUrl,
        openKudosDrawer
    ]);
    const kudosAction = (0, $eUqFw.useMemo)(()=>{
        return {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).giveKudosButton),
            id: $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID,
            callback: kudosButtonCallback,
            link: kudosUrl
        };
    }, [
        kudosButtonCallback,
        kudosUrl
    ]);
    return {
        kudosAction: kudosAction,
        kudosButtonCallback: kudosButtonCallback,
        kudosUrl: kudosUrl
    };
};
const $aaa133bbdb29f425$var$Wrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testid": "profilecard",
        role: "dialog",
        "aria-labelledby": "profilecard-name-label"
    }, props.children);
const $aaa133bbdb29f425$export$64e0275ede8ab792 = (props)=>{
    const [openTime] = (0, $eUqFw.useState)((0, $cEOpo.getPageTime)());
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsWithDuration = (0, $eUqFw.useCallback)((generator)=>{
        const elapsed = (0, $cEOpo.getPageTime)() - openTime;
        const event = generator(elapsed);
        fireAnalytics(event);
    }, [
        fireAnalytics,
        openTime
    ]);
    const { kudosAction: kudosAction } = $aaa133bbdb29f425$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
    const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
    const realActions = (0, $eUqFw.useMemo)(()=>{
        if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
        return actions.concat([
            kudosAction
        ]);
    }, [
        actions,
        isCurrentUser,
        isKudosEnabled,
        kudosAction,
        status
    ]);
    const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
    const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
    (0, $eUqFw.useEffect)(()=>{
        if (canRender) fireAnalyticsWithDuration((duration)=>(0, $3vXh8.profileCardRendered)('user', 'content', {
                duration: duration,
                numActions: realActions.length
            }));
    }, [
        canRender,
        fireAnalyticsWithDuration,
        realActions
    ]);
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: props.clientFetchProfile,
        errorType: props.errorType || null,
        fireAnalytics: fireAnalytics
    }));
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$LoadingView, {
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }));
    if (!canRender) return null;
    const isDisabledUser = status === 'inactive' || status === 'closed';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardContainer), {
        isDisabledUser: isDisabledUser,
        withoutElevation: props.withoutElevation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ProfileImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xlarge",
        src: status !== 'closed' ? props.avatarUrl : undefined,
        borderColor: `var(--ds-shadow-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXyvb.ProfileCardDetails), {
        ...props,
        status: status,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }), realActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ActionsFlexSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aaa133bbdb29f425$var$Actions, {
        actions: realActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
    })))));
};
const $aaa133bbdb29f425$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
    const onActionClick = (0, $eUqFw.useCallback)((action, args, event, index)=>{
        fireAnalyticsWithDuration((duration)=>(0, $3vXh8.actionClicked)('user', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || 'no-id-specified'
            }));
        if (action.callback && (0, $7NIUg.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    }, [
        fireAnalyticsWithDuration
    ]);
    if (!actions || actions.length === 0) return null;
    const regularActions = actions.slice(0, (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD));
    const overflowActions = actions.length > (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $g8EW1.ACTION_OVERFLOW_THRESHOLD)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.ActionButtonGroup), {
        "data-testid": "profilecard-actions"
    }, regularActions.map((action, index)=>{
        const isKudos = action.id === $aaa133bbdb29f425$var$GIVE_KUDOS_ACTION_ID;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
            isInset: true,
            key: `profile-card-action-focus-ring_${action.id || index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "default",
            key: action.id || index,
            onClick: (event, ...args)=>onActionClick(action, args, event, index),
            href: action.link,
            autoFocus: index === 0 && isTriggeredUsingKeyboard
        }, action.label, isKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.KudosBlobAnimation), null))));
        if (isKudos) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AnimatedKudosButton), {
            key: `profile-card-action-kudos_${action.id || index}`
        }, button);
        return button;
    }), overflowActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8EW1.OverflowProfileCardButtons), {
        actions: overflowActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $g8EW1.ACTION_OVERFLOW_THRESHOLD))
    }));
};
const $aaa133bbdb29f425$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalyticsWithDuration((duration)=>(0, $3vXh8.profileCardRendered)('user', 'spinner', {
                duration: duration
            }));
    }, [
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), {
        "data-testid": "profilecard-spinner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $aaa133bbdb29f425$export$2e2bcd8739ae039 = (0, $2jDha.default)()($aaa133bbdb29f425$export$64e0275ede8ab792);

});
parcelRegister("g8EW1", function(module, exports) {

$parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", () => $4d541855ce71e000$export$3e2419a7546ad45e);
$parcel$export(module.exports, "OverflowProfileCardButtons", () => $4d541855ce71e000$export$9d9b53d23c0df7a1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bbaTG = parcelRequire("bbaTG");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $4d541855ce71e000$export$3e2419a7546ad45e = 2;
const $4d541855ce71e000$export$9d9b53d23c0df7a1 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const [, setOpen] = (0, $eUqFw.useState)(false);
    const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
    const numActions = actions.length + $4d541855ce71e000$export$3e2419a7546ad45e;
    const onOpenChange = (0, $eUqFw.useCallback)(({ isOpen: nextOpen })=>{
        setOpen((prevOpen)=>{
            if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $3vXh8.moreActionsClicked)('user', {
                    duration: duration,
                    numActions: numActions
                }));
            return nextOpen;
        });
    }, [
        numActions,
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.OverflowActionButtonsWrapper), {
        "data-testid": "profilecard-actions-overflow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        onOpenChange: onOpenChange,
        placement: 'bottom-end',
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                type: "button",
                ...providedProps,
                ref: triggerRef,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: intl.formatMessage((0, $aCbpp.default).profileCardMoreIconLabel)
                })
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: action.id,
            onClick: (event, ...args)=>{
                onItemClick(action, args, event, index);
            },
            href: action.link
        }, action.label)))));
};

});

parcelRegister("gXyvb", function(module, exports) {

$parcel$export(module.exports, "ProfileCardDetails", () => $6edf297decc2faf3$export$c0e6870b898eb99d);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hkN79 = parcelRequire("hkN79");

var $aCbpp = parcelRequire("aCbpp");

var $kqibQ = parcelRequire("kqibQ");
parcelRequire("f8FAx");
var $2XE3d = parcelRequire("2XE3d");

var $4VIvN = parcelRequire("4VIvN");
const $6edf297decc2faf3$var$detailedListWrapperStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0',
    padding: 'space.0'
});
const $6edf297decc2faf3$var$renderName = (nickname, fullName, meta)=>{
    if (!fullName && !nickname) return null;
    const isNicknameRedundant = !nickname || nickname === fullName;
    const shownNickname = ` (${nickname}) `;
    const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.FullNameLabel), {
        noMeta: !meta,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, displayName);
};
const $6edf297decc2faf3$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
    // consumer does not want to use built-in message
    if (disabledAccountMessage) return disabledAccountMessage;
    const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
    const relativeDateKey = (0, $hkN79.default)(date);
    const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
    const secondSentence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default)[msgKey]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": "profilecard-disabled-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).generalDescMsgForDisabledUser), " ", secondSentence);
};
const $6edf297decc2faf3$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
    if (lozenges.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CustomLozengeContainer), null, lozenges.map(({ text: text, ...otherProps }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            ...otherProps,
            key: index
        }, text)));
};
const $6edf297decc2faf3$var$BotProfileCardDetails = (props)=>{
    const { fullName: fullName, nickname: nickname } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, $6edf297decc2faf3$var$renderName(nickname, fullName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.AppTitleLabel), null, "App"));
};
const $6edf297decc2faf3$var$DisabledProfileCardDetails = (props)=>{
    const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
    const name = status === 'inactive' ? fullName || nickname : nickname || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).disabledAccountDefaultName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.FullNameLabel), {
        noMeta: true,
        isDisabledAccount: true,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, name), hasDisabledAccountLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default",
        isBold: true
    }, status === 'inactive' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).inactiveAccountMsg) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).closedAccountMsg))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DisabledInfo), null, $6edf297decc2faf3$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "companyName"
    }, companyName));
};
const $6edf297decc2faf3$export$c0e6870b898eb99d = (props)=>{
    const { meta: meta, status: status } = props;
    if (props.isBot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$BotProfileCardDetails, props);
    if (status === 'inactive' || status === 'closed') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$DisabledProfileCardDetails, {
        ...props,
        status: status
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsGroup), null, $6edf297decc2faf3$var$renderName(props.nickname, props.fullName, meta), meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.JobTitleLabel), null, meta), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6edf297decc2faf3$var$CustomLozenges, {
        lozenges: props.customLozenges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "dl",
        xcss: $6edf297decc2faf3$var$detailedListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "email"
    }, props.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "time"
    }, props.timestring), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "companyName"
    }, props.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XE3d.default), {
        icon: "location"
    }, props.location)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VIvN.default), {
        reportingLines: props.reportingLines,
        reportingLinesProfileUrl: props.reportingLinesProfileUrl,
        onReportingLinesClick: props.onReportingLinesClick,
        fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
    }));
};

});
parcelRegister("hkN79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be3e2500aef7a3b$export$2e2bcd8739ae039);

var $1raUW = parcelRequire("1raUW");

var $7CyDX = parcelRequire("7CyDX");

var $hX17M = parcelRequire("hX17M");

var $7ueqz = parcelRequire("7ueqz");
function $7be3e2500aef7a3b$export$c03bb0116ee09d4b(date, today = new Date()) {
    return !!date.getTime && (0, $7ueqz.default)(date) && date.getTime() <= today.getTime();
}
function $7be3e2500aef7a3b$export$2e2bcd8739ae039(date, today = new Date()) {
    if (!date || !$7be3e2500aef7a3b$export$c03bb0116ee09d4b(date, today)) return null;
    if ((0, $hX17M.default)(date)) return 'ThisWeek';
    if ((0, $7CyDX.default)(date)) return 'ThisMonth';
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
    const diffInMonths = (0, $1raUW.default)(today, date);
    if (diffInMonths < 6) return 'AFewMonths';
    if (diffInMonths <= 12) return 'SeveralMonths';
    return 'MoreThanAYear';
}

});

parcelRegister("f8FAx", function(module, exports) {

$parcel$export(module.exports, "IconLabel", () => (parcelRequire("2XE3d")).default);

var $2XE3d = parcelRequire("2XE3d");

});
parcelRegister("2XE3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4197d6aec28d50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2o6Nb = parcelRequire("2o6Nb");

var $9UAhx = parcelRequire("9UAhx");

var $1sqLF = parcelRequire("1sqLF");

var $4wgnn = parcelRequire("4wgnn");

var $kqibQ = parcelRequire("kqibQ");
const $3b4197d6aec28d50$var$icons = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1sqLF))),
    time: (0, (/*@__PURE__*/$parcel$interopDefault($2o6Nb))),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($9UAhx))),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($4wgnn)))
};
class $3b4197d6aec28d50$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            icon: ''
        };
    }
    render() {
        if (!this.props.children) return null;
        // @ts-ignore
        const IconElement = this.props.icon && $3b4197d6aec28d50$var$icons[this.props.icon];
        const displayIcon = IconElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconElement, {
            label: `${this.props.icon}`,
            LEGACY_size: "small",
            color: "currentColor"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabelIcon), null, displayIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.DetailsLabelText), null, this.props.children));
    }
}

});
parcelRegister("2o6Nb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4510a429e6f5527457e7ec27e6bf4ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bd3177144d2e857$var$_react = $1bd3177144d2e857$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1bd3177144d2e857$var$_clock = $1bd3177144d2e857$var$_interopRequireDefault((parcelRequire("eSHsi")));

var $1bd3177144d2e857$var$_recent = $1bd3177144d2e857$var$_interopRequireDefault((parcelRequire("k6W9R")));
function $1bd3177144d2e857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "RecentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bd3177144d2e857$var$ClockIcon = (props)=>/*#__PURE__*/ $1bd3177144d2e857$var$_react.default.createElement($1bd3177144d2e857$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $1bd3177144d2e857$var$_recent.default
    }, props));
$1bd3177144d2e857$var$ClockIcon.Name = 'ClockIconMigration';
var $1bd3177144d2e857$var$_default = module.exports.default = $1bd3177144d2e857$var$ClockIcon;

});

parcelRegister("9UAhx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f7b62c842b6a50df02b47b62543acb1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73757cd51f353c0b$var$_react = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73757cd51f353c0b$var$_email = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("8qa3H")));

var $73757cd51f353c0b$var$_email2 = $73757cd51f353c0b$var$_interopRequireDefault((parcelRequire("8IVhP")));
function $73757cd51f353c0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73757cd51f353c0b$var$EmailIcon = (props)=>/*#__PURE__*/ $73757cd51f353c0b$var$_react.default.createElement($73757cd51f353c0b$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $73757cd51f353c0b$var$_email2.default
    }, props));
$73757cd51f353c0b$var$EmailIcon.Name = 'EmailIconMigration';
var $73757cd51f353c0b$var$_default = module.exports.default = $73757cd51f353c0b$var$EmailIcon;

});
parcelRegister("8qa3H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e8f81245a7bf271f86ba63b93c89562>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62188de139005924$var$_react = $62188de139005924$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $62188de139005924$var$_UNSAFE_baseNew = $62188de139005924$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $62188de139005924$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62188de139005924$var$EmailIcon = (props)=>/*#__PURE__*/ $62188de139005924$var$_react.default.createElement($62188de139005924$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
    }, props));
$62188de139005924$var$EmailIcon.displayName = 'EmailIcon';
var $62188de139005924$var$_default = module.exports.default = $62188de139005924$var$EmailIcon;

});

parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $659edeb603307d4b$var$_email = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("8qa3H")));
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $659edeb603307d4b$var$_email.default
    }));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = module.exports.default = $659edeb603307d4b$var$EmailIcon;

});


parcelRegister("1sqLF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e0be08318890a4932c8789281ebf917>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10fd2b7df2e2da22$var$_react = $10fd2b7df2e2da22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $10fd2b7df2e2da22$var$_location = $10fd2b7df2e2da22$var$_interopRequireDefault((parcelRequire("gIKck")));

var $10fd2b7df2e2da22$var$_location2 = $10fd2b7df2e2da22$var$_interopRequireDefault((parcelRequire("izGRi")));
function $10fd2b7df2e2da22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LocationIcon.
 * This component is LocationIcon, with `UNSAFE_fallbackIcon` set to "LocationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10fd2b7df2e2da22$var$LocationIcon = (props)=>/*#__PURE__*/ $10fd2b7df2e2da22$var$_react.default.createElement($10fd2b7df2e2da22$var$_location.default, Object.assign({
        LEGACY_fallbackIcon: $10fd2b7df2e2da22$var$_location2.default
    }, props));
$10fd2b7df2e2da22$var$LocationIcon.Name = 'LocationIconMigration';
var $10fd2b7df2e2da22$var$_default = module.exports.default = $10fd2b7df2e2da22$var$LocationIcon;

});
parcelRegister("gIKck", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d20b96af41398a2001599c35ba809457>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2c4975ab9840edb$var$_react = $c2c4975ab9840edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c2c4975ab9840edb$var$_UNSAFE_baseNew = $c2c4975ab9840edb$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c2c4975ab9840edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2c4975ab9840edb$var$LocationIcon = (props)=>/*#__PURE__*/ $c2c4975ab9840edb$var$_react.default.createElement($c2c4975ab9840edb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$c2c4975ab9840edb$var$LocationIcon.displayName = 'LocationIcon';
var $c2c4975ab9840edb$var$_default = module.exports.default = $c2c4975ab9840edb$var$LocationIcon;

});

parcelRegister("izGRi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d85cbdb8c81e089a$var$_react = $d85cbdb8c81e089a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d85cbdb8c81e089a$var$_location = $d85cbdb8c81e089a$var$_interopRequireDefault((parcelRequire("gIKck")));
function $d85cbdb8c81e089a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d85cbdb8c81e089a$var$LocationIcon = (props)=>/*#__PURE__*/ $d85cbdb8c81e089a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $d85cbdb8c81e089a$var$_location.default
    }));
$d85cbdb8c81e089a$var$LocationIcon.displayName = 'LocationIcon';
var $d85cbdb8c81e089a$var$_default = module.exports.default = $d85cbdb8c81e089a$var$LocationIcon;

});


parcelRegister("4wgnn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::015c0b82ae2c53f98d4712db5c1243d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34a6da89084607d2$var$_react = $34a6da89084607d2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $34a6da89084607d2$var$_officeBuilding = $34a6da89084607d2$var$_interopRequireDefault((parcelRequire("jaf6K")));

var $34a6da89084607d2$var$_officeBuilding2 = $34a6da89084607d2$var$_interopRequireDefault((parcelRequire("bK40S")));
function $34a6da89084607d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34a6da89084607d2$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $34a6da89084607d2$var$_react.default.createElement($34a6da89084607d2$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $34a6da89084607d2$var$_officeBuilding2.default
    }, props));
$34a6da89084607d2$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $34a6da89084607d2$var$_default = module.exports.default = $34a6da89084607d2$var$OfficeBuildingIcon;

});
parcelRegister("jaf6K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a3eb33b5845c1910a3bdb4c571191ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df3aab978cc1c9fb$var$_react = $df3aab978cc1c9fb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $df3aab978cc1c9fb$var$_UNSAFE_baseNew = $df3aab978cc1c9fb$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $df3aab978cc1c9fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df3aab978cc1c9fb$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $df3aab978cc1c9fb$var$_react.default.createElement($df3aab978cc1c9fb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 3.75h2m2 0h2m0 3H9m-2 0H5m1.25 8.5H4c-.69 0-1.25-.56-1.25-1.25V2c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v12c0 .69-.56 1.25-1.25 1.25H9.75m-3.5 0v-5.5h3.5v5.5m-3.5 0h3.5"/>`
    }, props));
$df3aab978cc1c9fb$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $df3aab978cc1c9fb$var$_default = module.exports.default = $df3aab978cc1c9fb$var$OfficeBuildingIcon;

});

parcelRegister("bK40S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c71a7d3deb32d8$var$_react = $88c71a7d3deb32d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $88c71a7d3deb32d8$var$_officeBuilding = $88c71a7d3deb32d8$var$_interopRequireDefault((parcelRequire("jaf6K")));
function $88c71a7d3deb32d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c71a7d3deb32d8$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $88c71a7d3deb32d8$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $88c71a7d3deb32d8$var$_officeBuilding.default
    }));
$88c71a7d3deb32d8$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $88c71a7d3deb32d8$var$_default = module.exports.default = $88c71a7d3deb32d8$var$OfficeBuildingIcon;

});




parcelRegister("4VIvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea078b29528825bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $iJlfe = parcelRequire("iJlfe");

var $4XQdE = parcelRequire("4XQdE");

var $7u4fN = parcelRequire("7u4fN");

var $aCbpp = parcelRequire("aCbpp");

var $82aoD = parcelRequire("82aoD");

var $3vXh8 = parcelRequire("3vXh8");
function $ea078b29528825bd$var$getProfileHref(userId, profileUrl) {
    return profileUrl ? profileUrl + userId : undefined;
}
const $ea078b29528825bd$var$ReportingLinesDetails = (props)=>{
    const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
    const { managers: managers = [], reports: reports = [] } = reportingLines;
    const manager = managers.length >= 1 ? managers[0] : undefined;
    const hasReports = reports.length > 0;
    const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
            fireAnalyticsWithDuration((duration)=>(0, $3vXh8.reportingLinesClicked)({
                    duration: duration,
                    userType: userType
                }));
            onReportingLinesClick(user);
        } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesHeading), {
        style: {
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).managerSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.OffsetWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        href: $ea078b29528825bd$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
        onClick: getReportingLinesOnClick(manager, 'manager'),
        isDisabled: !onReportingLinesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ManagerSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xsmall",
        src: manager.pii?.picture
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ManagerName), null, manager.pii?.name))))), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82aoD.ReportingLinesHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $aCbpp.default).directReportsSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        size: "small",
        data: reports.map((member)=>{
            return {
                key: member.accountIdentifier,
                name: member.pii?.name || '',
                src: member.pii?.picture,
                href: $ea078b29528825bd$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                onClick: getReportingLinesOnClick(member, 'direct-report')
            };
        }),
        maxCount: 5,
        testId: "profilecard-reports-avatar-group"
    })));
};
var $ea078b29528825bd$export$2e2bcd8739ae039 = $ea078b29528825bd$var$ReportingLinesDetails;

});
parcelRegister("82aoD", function(module, exports) {

$parcel$export(module.exports, "ReportingLinesSection", () => $04441ecf0f4a2833$export$ae48ddd79a45b949);
$parcel$export(module.exports, "ReportingLinesHeading", () => $04441ecf0f4a2833$export$abdd342d30bb5b5f);
$parcel$export(module.exports, "ManagerSection", () => $04441ecf0f4a2833$export$2992b481dad9fb03);
$parcel$export(module.exports, "ManagerName", () => $04441ecf0f4a2833$export$98f8ec89e658b052);
$parcel$export(module.exports, "OffsetWrapper", () => $04441ecf0f4a2833$export$56eae56612ce5f3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");

var $5PC5M = parcelRequire("5PC5M");

var $joBf7 = parcelRequire("joBf7");
function $04441ecf0f4a2833$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04441ecf0f4a2833$export$ae48ddd79a45b949 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a4"
})({
    name: "1m5erzj",
    styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$abdd342d30bb5b5f = /*#__PURE__*/ (0, $joBf7.default)("h3", {
    target: "e11fux8a3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5PC5M.appLabelTextColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.gridSize)() * 1.5}px`,
    fontWeight: 600,
    marginBottom: "var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$2992b481dad9fb03 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a2"
})({
    display: 'flex',
    alignItems: 'center',
    margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $04441ecf0f4a2833$export$98f8ec89e658b052 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e11fux8a1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.gridSize)() * 1.5}px`,
    marginLeft: "var(--ds-space-100, 8px)"
});
const $04441ecf0f4a2833$export$56eae56612ce5f3 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11fux8a0"
})({
    name: "ysolxb",
    styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
});

});




parcelRegister("6aOtB", function(module, exports) {

$parcel$export(module.exports, "default", () => $184c4f94fc0b4764$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $5Jx7I = parcelRequire("5Jx7I");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
parcelRequire("iINHb");
var $4ga2m = parcelRequire("4ga2m");

var $ehM5E = parcelRequire("ehM5E");

var $ijWKk = parcelRequire("ijWKk");
class $184c4f94fc0b4764$var$ProfileCardResourced extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            actions: []
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.clientFetchProfile();
    }
    componentDidUpdate(prevProps) {
        const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
        if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: profileData,
            reportingLinesData: reportingLinesData,
            isKudosEnabled: shouldShowGiveKudos
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    render() {
        const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled } = this.state;
        const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
        const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
        if (isFetchingOrNotStartToFetchYet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
            fireAnalytics: this.fireAnalytics
        }));
        else if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
            errorType: error,
            reload: this.clientFetchProfile,
            fireAnalytics: this.fireAnalytics
        }));
        const newProps = {
            hasError: hasError,
            errorType: error,
            clientFetchProfile: this.clientFetchProfile,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            cloudId: cloudId,
            userId: userId,
            addFlag: addFlag,
            ...data,
            isKudosEnabled: isKudosEnabled,
            teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl(),
            openKudosDrawer: this.openKudosDrawer
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isKudosEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
            isOpen: this.state.kudosDrawerOpen,
            recipient: {
                type: (0, $btCBO.KudosType).INDIVIDUAL,
                recipientId: this.props.userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: newProps.teamCentralBaseUrl,
            cloudId: this.props.cloudId,
            addFlag: this.props.addFlag,
            onClose: this.closeKudosDrawer
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ehM5E.default), {
            ...newProps,
            actions: this.filterActions()
        })));
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            isKudosEnabled: false,
            kudosDrawerOpen: false
        };
        this.fireAnalytics = (payload)=>{
            // Don't fire analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $3vXh8.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.clientFetchProfile = ()=>{
            const { cloudId: cloudId, userId: userId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                    this.props.resourceClient.getReportingLines(userId),
                    this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.filterActions = ()=>(0, $5Jx7I.default)(this.props.actions, this.state.data);
        this.openKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
    }
}
const $184c4f94fc0b4764$export$a6d9ff68ecba3be5 = $184c4f94fc0b4764$var$ProfileCardResourced;
var $184c4f94fc0b4764$export$2e2bcd8739ae039 = (0, $2jDha.default)()($184c4f94fc0b4764$var$ProfileCardResourced);

});
parcelRegister("ijWKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $005cfbb6d85cc048$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");
const $005cfbb6d85cc048$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eUqFw.useEffect)(()=>{
        fireAnalytics((0, $3vXh8.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
};
var $005cfbb6d85cc048$export$2e2bcd8739ae039 = $005cfbb6d85cc048$var$UserLoadingState;

});


parcelRegister("1I4cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a11e1a2b837fef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $dx7Op = parcelRequire("dx7Op");
var $btCBO = parcelRequire("btCBO");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $5Jx7I = parcelRequire("5Jx7I");

var $l2W2J = parcelRequire("l2W2J");

var $kqibQ = parcelRequire("kqibQ");

var $3vXh8 = parcelRequire("3vXh8");


var $hSM1E = parcelRequire("hSM1E");

var $ijWKk = parcelRequire("ijWKk");
function $d9a11e1a2b837fef$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isMounted = (0, $eUqFw.useRef)(false);
    const showDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' ? 0 : (0, $515c9dbc88c31cf4$export$89a9f35a94d7f196);
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(undefined);
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eUqFw.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eUqFw.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eUqFw.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eUqFw.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const triggerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eUqFw.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eUqFw.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eUqFw.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos()
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $3vXh8.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eUqFw.useCallback)(()=>{
        return (0, $5Jx7I.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: (0, $XHGTv.fg)('migrate_cloud_user_to_agg_user_query') ? userId === viewingUserId : data?.isCurrentUser,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!visible,
        onClose: (event)=>{
            hideProfilecard();
            handleKeyboardClose(event);
        },
        placement: position,
        offset: offset ?? [
            0,
            8
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", wrapperProps, showLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9a11e1a2b837fef$var$LoadingView, {
                fireAnalytics: fireAnalytics
            }) : visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSM1E.ProfileCardLazy), {
                ...profilecardProps,
                actions: filterActions(),
                hasError: hasError,
                errorType: error,
                withoutElevation: true
            }))),
        trigger: (triggerProps)=>{
            const { ref: callbackRef, ...innerProps } = triggerProps;
            const ref = (element)=>{
                triggerRef.current = element;
                if (typeof callbackRef === 'function') callbackRef(element);
            };
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ...containerListeners,
                ref: ref,
                "data-testid": testId,
                "aria-labelledby": ariaLabelledBy,
                ...disabledAriaAttributes ? {} : {
                    role: 'button',
                    tabIndex: 0,
                    'aria-label': (0, $l2W2J.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                }
            }, children);
        },
        zIndex: (0, $lcnyw.layers).modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: autoFocus ?? trigger === 'click'
    }), shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx7Op.GiveKudosLauncherLazy), {
        isOpen: kudosDrawerOpen,
        recipient: {
            type: (0, $btCBO.KudosType).INDIVIDUAL,
            recipientId: userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        addFlag: addFlag,
        onClose: closeKudosDrawer
    })));
}
const $d9a11e1a2b837fef$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqibQ.CardWrapper), {
        "data-testId": "profilecard.profilecardtrigger.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ijWKk.default), {
        fireAnalytics: fireAnalytics
    }));

});
parcelRegister("l2W2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $02881092ed20fd17$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $02881092ed20fd17$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($02881092ed20fd17$var$messages.label, {
        fullName: fullName
    }) : formatMessage($02881092ed20fd17$var$messages.fallbackLabel);
};
const $02881092ed20fd17$var$messages = (0, $90IgZ.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $02881092ed20fd17$export$2e2bcd8739ae039 = $02881092ed20fd17$var$getLabelMessage;

});

parcelRegister("hSM1E", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $79ec67bb4c36fbd6$export$403d297463f226af);

var $eUqFw = parcelRequire("eUqFw");

const $79ec67bb4c36fbd6$export$403d297463f226af = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("ehM5E"))));

});


parcelRegister("icLG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3275fd86a923b35a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $3275fd86a923b35a$export$2e2bcd8739ae039(Component) {
    return class WithOuterListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, this.props);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (evt)=>{
                const { handleClickOutside: handleClickOutside } = this.props;
                if (handleClickOutside) {
                    const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
                    if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                }
            };
            this.handleKeydown = (evt)=>{
                const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
            };
        }
    };
}

});

parcelRegister("b5p0p", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3vXh8 = parcelRequire("3vXh8");

var $6oOPK = parcelRequire("6oOPK");

var $4CtB0 = parcelRequire("4CtB0");

var $i6n3V = parcelRequire("i6n3V");
const $a90530629aa60146$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
    const { resourceClient: resourceClient, userId: userId, cloudId: cloudId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const getCreator = async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId = (0, $6oOPK.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId || !cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${userId}`,
                        id: userId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentInfo = await resourceClient.getRovoAgentProfile({
            type: 'agent',
            value: userId
        }, fireAnalytics);
        const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, isLoading: isLoading, error: error })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6n3V.AgentProfileCardLazy), {
            agent: profileData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: profileData?.creatorInfo?.id === viewingUserId,
            cloudId: props.cloudId,
            product: product,
            errorType: error,
            onOpenChat: props.onOpenChat
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CtB0.default), {
        ...props,
        trigger: "hover",
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalytics: fireAnalytics,
        profileCardType: "agent"
    });
};

});
parcelRegister("4CtB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d11892819ca4415$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $3vXh8 = parcelRequire("3vXh8");

var $4Ytsq = parcelRequire("4Ytsq");

var $dU1zo = parcelRequire("dU1zo");
const $8d11892819ca4415$var$DELAY_MS_SHOW = 800;
const $8d11892819ca4415$var$DELAY_MS_HIDE = 200;
function $8d11892819ca4415$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
    const showDelay = trigger === 'click' ? 0 : $8d11892819ca4415$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $8d11892819ca4415$var$DELAY_MS_HIDE;
    const showTimer = (0, $eUqFw.useRef)(0);
    const hideTimer = (0, $eUqFw.useRef)(0);
    const [visible, setVisible] = (0, $eUqFw.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $4Ytsq.useProfileInfo)({
        fetchUserProfile: fetchProfile
    });
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $eUqFw.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    const showProfilecard = (0, $eUqFw.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(async ()=>{
            if (!visible) {
                await getProfileData?.();
                setVisible(true);
                if (fireAnalytics) fireAnalytics((0, $3vXh8.cardTriggered)(profileCardType, trigger));
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger
    ]);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $lcnyw.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU1zo.PopupTrigger), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                forwardRef: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger
            });
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard
            }, renderProfileCard({
                profileData: profileData,
                isLoading: isLoading,
                error: error
            }))
    });
}
var $8d11892819ca4415$export$2e2bcd8739ae039 = $8d11892819ca4415$var$ProfileCardTrigger;

});
parcelRegister("4Ytsq", function(module, exports) {

$parcel$export(module.exports, "useProfileInfo", () => $b18841adfa594cc7$export$6cace87f7d7a9738);

var $eUqFw = parcelRequire("eUqFw");
const $b18841adfa594cc7$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [profileData, setProfileData] = (0, $eUqFw.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData = await fetchUserProfile?.();
            setProfileData(profileData);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(true);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};

});

parcelRegister("dU1zo", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $0abfc530bf195494$export$95d4acdbab2fc6ef);

var $eUqFw = parcelRequire("eUqFw");
const $0abfc530bf195494$export$95d4acdbab2fc6ef = ({ children: children, trigger: trigger, forwardRef: forwardRef, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props })=>{
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $eUqFw.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props,
        ...containerListeners,
        ref: forwardRef,
        "aria-labelledby": ariaLabelledBy
    }, children);
};

});


parcelRegister("i6n3V", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $05a0ac107f346903$export$ed0ca9c1d49ea0bf);

var $eUqFw = parcelRequire("eUqFw");

const $05a0ac107f346903$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>Promise.resolve((parcelRequire("6uyUT"))));

});


parcelRegister("eKJ5n", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3vXh8 = parcelRequire("3vXh8");

var $6oOPK = parcelRequire("6oOPK");

var $4ga2m = parcelRequire("4ga2m");

var $kCTG1 = parcelRequire("kCTG1");

var $i6n3V = parcelRequire("i6n3V");
const $f174a152b20761e7$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $3vXh8.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eUqFw.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $6oOPK.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $eUqFw.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const getAgentInfo = (0, $eUqFw.useCallback)(()=>{
        return props.resourceClient.getRovoAgentProfile({
            type: 'identity',
            value: props.accountId
        }, fireAnalytics);
    }, [
        fireAnalytics,
        props.accountId,
        props.resourceClient
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        const getAgentData = async ()=>{
            const profileData = await getAgentInfo();
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            return {
                ...profileData,
                creatorInfo: agentCreatorInfo
            };
        };
        const agentData = await getAgentData();
        setAgentData(agentData);
        setIsLoading(false);
    }, [
        getAgentInfo,
        getCreator
    ]);
    (0, $eUqFw.useEffect)(()=>{
        try {
            fetchData();
        } catch (error) {
            setIsLoading(false);
            setError(error);
        }
    }, [
        fetchData,
        getAgentInfo,
        getCreator,
        props.accountId,
        props.cloudId,
        props.resourceClient
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCTG1.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ga2m.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: ()=>{}
    }));
    if (agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6n3V.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        isCreatedByViewingUser: creatorUserId === props.viewingUserId,
        product: props.product
    });
    return null;
};

});


parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("70r4x")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("70r4x")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("70r4x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

const $7543475b40b0a31d$export$a1455360a24a2234 = 'profileCardNextView';


parcelRegister("4w3h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $125d5ecff4714394$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");
parcelRequire("j2NCp");
var $icLG8 = parcelRequire("icLG8");

var $g8JvH = parcelRequire("g8JvH");

var $9Ibob = parcelRequire("9Ibob");
var $8Vu8p = parcelRequire("8Vu8p");

var $jxkjj = parcelRequire("jxkjj");


var $jVcNC = parcelRequire("jVcNC");
const $125d5ecff4714394$var$AnalyticsWrapper = (0, $g8JvH.AnalyticsEventToProps)((0, $099971b93b758534$export$a1455360a24a2234), {
    onAnalytics: 'fired'
});
const $125d5ecff4714394$export$23f88898e1cb6da9 = $125d5ecff4714394$var$AnalyticsWrapper((0, $icLG8.default)((0, $jVcNC.default)));
const $125d5ecff4714394$var$eventListenerOptions = {
    passive: true
};
const $125d5ecff4714394$export$dd0591e04a6e8ce6 = ({ baseUrl: baseUrl, profileClient: profileClient, cloudId: cloudId, onGetActions: onGetActions, onProfileClick: onProfileClick })=>{
    (0, $asu8X.di)(setTimeout);
    // Hooks
    const [userData, setUserData] = (0, $eUqFw.useState)(null);
    const [referenceElement, setReferenceElement] = (0, $eUqFw.useState)(null);
    const [showProfileCard, setShowProfileCard] = (0, $eUqFw.useState)(false);
    const [offset, setOffset] = (0, $eUqFw.useState)(null);
    const showTimeoutId = (0, $eUqFw.useRef)(null);
    const onMouseLeaveCancelShowCard = ()=>{
        if (showTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(showTimeoutId.current);
    };
    const onHideProfileCard = ()=>{
        setShowProfileCard(false);
        onMouseLeaveCancelShowCard();
    };
    const { setTriggerRef: setTriggerRef, setCardRef: setCardRef, unsetTriggerRef: unsetTriggerRef, unsetCardRef: unsetCardRef, getTimeoutId: getTimeoutId } = (0, $8Vu8p.useHideProfileCardDelayed)(true, false, onHideProfileCard);
    // Add event listener using our hook
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $8Vu8p.useEventListener)('mouseleave', unsetTriggerRef, referenceElement, $125d5ecff4714394$var$eventListenerOptions);
    (0, $8Vu8p.useEventListener)('mouseleave', onMouseLeaveCancelShowCard, // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
    referenceElement, $125d5ecff4714394$var$eventListenerOptions);
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $8Vu8p.useEventListener)('mouseenter', setTriggerRef, referenceElement, $125d5ecff4714394$var$eventListenerOptions);
    // @ts-expect-error - TS2345 - Argument of type 'Window & typeof globalThis' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $8Vu8p.useEventListener)('scroll', onHideProfileCard, window, $125d5ecff4714394$var$eventListenerOptions);
    const clearHideCardTimeout = (timeoutId)=>{
        if (timeoutId) clearTimeout(timeoutId);
    };
    const setShowProfileCardDelayed = ()=>setTimeout(()=>setShowProfileCard(true), (0, $515c9dbc88c31cf4$export$5b956b542f1bc1b3));
    const setData = (data, ref, offsetValue)=>{
        clearHideCardTimeout(getTimeoutId());
        setOffset(offsetValue || '0, 8px');
        setUserData(data);
        setReferenceElement(ref);
        showTimeoutId.current = setShowProfileCardDelayed();
    };
    const api = {
        setData: setData,
        hideProfileCard: onHideProfileCard
    };
    (0, $jxkjj.default)(api);
    return showProfileCard && referenceElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ibob.ProfileCardLegacyWrapper), {
        onMouseEnter: setCardRef,
        onMouseLeave: unsetCardRef,
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'HTMLElement'.
        referenceElement: referenceElement,
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string | null'.
        offset: offset
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($125d5ecff4714394$export$23f88898e1cb6da9, {
            baseUrl: baseUrl,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            accountId: userData && userData.accountId,
            cloudId: cloudId,
            handleEscapeKeydown: onHideProfileCard,
            handleClickOutside: onHideProfileCard,
            profileClient: profileClient,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            actions: onGetActions(userData ? userData.accountId : '', ()=>{
                clearHideCardTimeout(getTimeoutId());
                onHideProfileCard();
            }),
            onProfileClick: onProfileClick
        }));
};
var $125d5ecff4714394$export$2e2bcd8739ae039 = $125d5ecff4714394$export$dd0591e04a6e8ce6;

});
parcelRegister("9Ibob", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacyWrapper", () => $6a55628c53a0dae8$export$6ef7d4845cf112be);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $i6BC8 = parcelRequire("i6BC8");

var $8Vu8p = parcelRequire("8Vu8p");
// Updated version of popper requires tuple but provided value may be a string
const $6a55628c53a0dae8$var$parsePopperOffsetValue = (offset)=>{
    let offsetArray = [
        0,
        0
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(offset)) return offsetArray;
    if (typeof offset === 'string') // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset.split(',').map((pxValue)=>parseInt(pxValue.replace('px', ''), 10));
    else if (Array.isArray(offset) && offset.length === 2) // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset;
    return offsetArray.some(Number.isNaN) ? [
        0,
        0
    ] : offsetArray;
};
const $6a55628c53a0dae8$export$6ef7d4845cf112be = ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, referenceElement: referenceElement, offset: offset, children: children, placement: placement })=>{
    const offsetTuple = $6a55628c53a0dae8$var$parsePopperOffsetValue(offset);
    const modifiers = [
        {
            name: 'offset',
            options: {
                offset: offsetTuple
            }
        },
        {
            name: 'preventOverflow',
            options: {
                tether: true
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        referenceElement: referenceElement,
        placement: placement || (0, $8Vu8p.getPlacement)(referenceElement),
        modifiers: modifiers
    }, ({ ref: ref, style: style, forceUpdate: forceUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "profilecard-next.common.ui.legacy-profile-card.div",
            ref: ref,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...style
            },
            onMouseLeave: onMouseLeave,
            onMouseEnter: onMouseEnter
        }, children(forceUpdate)));
};

});
parcelRegister("8Vu8p", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $9f1ecee81bf1a8fe$export$7080b3e976bc91ab);
$parcel$export(module.exports, "useHideProfileCardDelayed", () => $9f1ecee81bf1a8fe$export$30416a530a92ed77);
$parcel$export(module.exports, "getPlacement", () => $9f1ecee81bf1a8fe$export$a9fe23cfa43a7b55);

var $eUqFw = parcelRequire("eUqFw");
const $9f1ecee81bf1a8fe$export$7080b3e976bc91ab = (eventName, handler, element, // @ts-expect-error - TS2304 - Cannot find name 'EventListenerOptionsOrUseCapture'.
options)=>{
    // Create a ref that stores handler
    const savedHandler = (0, $eUqFw.useRef)();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    (0, $eUqFw.useEffect)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Create event listener that calls handler function stored in ref
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const eventListener = ()=>savedHandler.current && savedHandler.current();
        // Add event listener
        element && element.addEventListener(eventName, eventListener, options);
        // Remove event listener on cleanup
        return ()=>{
            element && element.removeEventListener(eventName, eventListener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
};
const $9f1ecee81bf1a8fe$export$30416a530a92ed77 = (initialfirst, initialSecond, callback)=>{
    const triggerRef = (0, $eUqFw.useRef)(initialfirst);
    const cardRef = (0, $eUqFw.useRef)(initialSecond);
    const timeoutId = (0, $eUqFw.useRef)(null);
    const setStateDelayed = ()=>{
        if (timeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(()=>{
            if (!triggerRef.current && !cardRef.current) callback();
        }, 400);
    };
    const setTriggerRef = ()=>{
        triggerRef.current = true;
        setStateDelayed();
    };
    const unsetTriggerRef = ()=>{
        triggerRef.current = false;
        setStateDelayed();
    };
    const setCardRef = ()=>{
        cardRef.current = true;
        setStateDelayed();
    };
    const unsetCardRef = ()=>{
        cardRef.current = false;
        setStateDelayed();
    };
    const getTimeoutId = ()=>timeoutId.current;
    return {
        setTriggerRef: setTriggerRef,
        setCardRef: setCardRef,
        unsetTriggerRef: unsetTriggerRef,
        unsetCardRef: unsetCardRef,
        getTimeoutId: // @ts-expect-error - TS2322 - Type '() => unknown' is not assignable to type '() => number | null'.
        getTimeoutId
    };
};
const $9f1ecee81bf1a8fe$export$a9fe23cfa43a7b55 = (referenceElement)=>{
    if (referenceElement && typeof referenceElement.id === 'string' && referenceElement.id.indexOf('issue_summary') > -1) return 'left-start';
    return 'top-start';
};

});


parcelRegister("jxkjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced5b8453ce5e364$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $ds5Im = parcelRequire("ds5Im");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ced5b8453ce5e364$export$2e2bcd8739ae039 = (api)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $ds5Im.loadBridgeWeak)({
        name: 'jira/profilecard/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(api);
    });
};

});
parcelRegister("ds5Im", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $1b3123f198513ce0$export$3cefda82396756a1);

var $1gau4 = parcelRequire("1gau4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $1b3123f198513ce0$var$pollingSingleton = null;
const $1b3123f198513ce0$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = $1b3123f198513ce0$var$pollingSingleton ?? (0, $1gau4.createPollingCollection)((v)=>window.require(v), 100);
    $1b3123f198513ce0$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("1gau4", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $9f3ee0cd5dcb553b$export$f163446a982a8077);

var $asu8X = parcelRequire("asu8X");

var $eFUPR = parcelRequire("eFUPR");
const $9f3ee0cd5dcb553b$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $asu8X.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $eFUPR.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $eFUPR.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("eFUPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bee8fab77b1b942$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $8bee8fab77b1b942$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




const $099971b93b758534$export$a1455360a24a2234 = 'profileCardNextLegacyView';

parcelRegister("jVcNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df69c97362405f1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j2NCp = parcelRequire("j2NCp");

var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $bv8gI = parcelRequire("bv8gI");
const $1df69c97362405f1$export$6f67c636e2e30540 = ({ cloudId: cloudId, profileClient: profileClient, accountId: accountId, actions: actions, onProfileClick: onProfileClick })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onReportingLinesClick = onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : undefined;
    const profileCardProps = {
        userId: accountId,
        cloudId: cloudId,
        actions: (0, $bv8gI.isCustomerAccount)(accountId) ? [] : actions,
        resourceClient: profileClient,
        onReportingLinesClick: onReportingLinesClick
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2NCp.default), {
        ...profileCardProps,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $eo17r.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        }
    });
};
const $1df69c97362405f1$var$ProfileCardResourced = $1df69c97362405f1$export$6f67c636e2e30540;
var $1df69c97362405f1$export$2e2bcd8739ae039 = $1df69c97362405f1$var$ProfileCardResourced;

});
parcelRegister("bv8gI", function(module, exports) {

$parcel$export(module.exports, "restResponseToUserData", () => $cd9a986ac0e3329e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $cd9a986ac0e3329e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $cd9a986ac0e3329e$export$518f47d656cb4e1a);


var $bncoh = parcelRequire("bncoh");
const $cd9a986ac0e3329e$export$66691b1affeb3bc5 = (userData)=>({
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        avatarUrl: userData.avatarUrls['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $cd9a986ac0e3329e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $cd9a986ac0e3329e$var$getSpaViewProfileAction = (// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
intl, baseUrl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`${baseUrl}/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `${baseUrl}/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getAssignedIssuesAction = (intl, baseUrl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `${baseUrl}/issues/?jql=${jql}`;
            window.open(url, '_blank');
        }
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getReportedIssuesAction = (intl, baseUrl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `${baseUrl}/issues/?jql=${jql}`;
            window.open(url, '_blank');
        }
    });
// @ts-expect-error - TS7006 - Parameter 'intl' implicitly has an 'any' type.
const $cd9a986ac0e3329e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $bncoh.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            window.open(url, '_blank');
        }
    });
const $cd9a986ac0e3329e$export$518f47d656cb4e1a = (accountId, baseUrl, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $2f37035f7aaf1787$export$23cedd3261bd8015:
                return $cd9a986ac0e3329e$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup);
            case 0, $2f37035f7aaf1787$export$6bef782d14a92db8:
                return $cd9a986ac0e3329e$var$getAssignedIssuesAction(intl, baseUrl, accountId);
            case 0, $2f37035f7aaf1787$export$6b36f20db7a18a86:
                return $cd9a986ac0e3329e$var$getReportedIssuesAction(intl, baseUrl, accountId);
            case 0, $2f37035f7aaf1787$export$56da0dd0b0aa67b9:
                return $cd9a986ac0e3329e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $cd9a986ac0e3329e$var$getSpaViewProfileAction(intl, baseUrl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("bncoh", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $daa0299e513e1d61$export$49f2d2ccb123fddf);

var $90IgZ = parcelRequire("90IgZ");
const $daa0299e513e1d61$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $daa0299e513e1d61$export$49f2d2ccb123fddf = (0, $90IgZ.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    }
});

});




parcelRegister("NILIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c4cd19c15bc811$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $g8JvH = parcelRequire("g8JvH");

var $dWLk9 = parcelRequire("dWLk9");
var $d9epm = parcelRequire("d9epm");
var $gd0Sp = parcelRequire("gd0Sp");


var $5lWRu = parcelRequire("5lWRu");
const $14c4cd19c15bc811$var$ProfileCardWrapper = (props)=>{
    const { TenantContextSubscriber: TenantContextSubscriberComponent, externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError } = props;
    const teamCentralUrl = (0, $d9epm.useTeamCentralUrl)();
    const teamCentralBaseUrl = (0, $d9epm.useTeamCentralBaseUrl)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const renderProfileClientContainerWrapper = (0, $eUqFw.useCallback)((tenantContext)=>{
        if (tenantContext && tenantContext.atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lWRu.ProfileClientContainer), {
            fabricPfDirUrl: tenantContext.fabricPfDirUrl,
            baseUrl: tenantContext.baseUrl,
            profileClient: externalProfileClient || null,
            onLoadError: onLoadError,
            isGlobal: true,
            teamCentralUrl: teamCentralUrl,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lWRu.ProfileClientSubscriber), null, ({ profileClient: profileClient })=>children(tenantContext.atlassianAccountId, profileClient, tenantContext.cloudId, tenantContext.baseUrl)));
        // When there is no tenantContext, this will cause the child
        // component of <ProfileCard> to render without being wrapped by
        // a profile card and it will do nothing on hover
        return children('', null, '', '');
    }, [
        children,
        externalProfileClient,
        onLoadError,
        teamCentralBaseUrl,
        teamCentralUrl,
        cloudId
    ]);
    if (TenantContextSubscriberComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TenantContextSubscriberComponent, null, ({ tenantContext: tenantContext })=>renderProfileClientContainerWrapper(tenantContext));
    // Here we conditionally call hooks which is frowned upon by React.
    // However this is safe as the value of TenantContextSubscriberComponent doesn't change dynamically
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return renderProfileClientContainerWrapper(tenantContext);
};
$14c4cd19c15bc811$var$ProfileCardWrapper.defaultProps = {
    externalProfileClient: null,
    sourceName: null,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$14c4cd19c15bc811$export$2e2bcd8739ae039 = (0, $g8JvH.AnalyticsEventToProps)((0, $2f37035f7aaf1787$export$3145fc6c544ad7bf), {
    onLoadError: (0, $2f37035f7aaf1787$export$2549357601611c61)
})($14c4cd19c15bc811$var$ProfileCardWrapper);

});
parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("d9epm", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralUrl", () => $27fe3a2e52ea675c$export$12bf0987a96bab08);
$parcel$export(module.exports, "useTeamCentralBaseUrl", () => $27fe3a2e52ea675c$export$b49e0105c58cb761);

var $3e9vj = parcelRequire("3e9vj");
const $27fe3a2e52ea675c$export$12bf0987a96bab08 = ()=>'/gateway/api/watermelon/graphql';
const $27fe3a2e52ea675c$export$b49e0105c58cb761 = ()=>{
    const env = (0, $3e9vj.useEnvironment)();
    if (env === 'staging' || env === 'dev' || env === 'local') return 'https://team.stg.atlassian.com';
    return 'https://team.atlassian.com';
};

});
parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});


parcelRegister("5lWRu", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $d57808c9e3ca761c$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientSubscriber", () => $d57808c9e3ca761c$export$10cad281024d43c8);
$parcel$export(module.exports, "useProfileClient", () => $d57808c9e3ca761c$export$d43dc22a8337ee9f);
$parcel$export(module.exports, "ProfileClientContainer", () => $d57808c9e3ca761c$export$d816ba2709570028);

var $WBLbN = parcelRequire("WBLbN");
parcelRequire("j2NCp");
var $lsiAJ = parcelRequire("lsiAJ");

var $2vQty = parcelRequire("2vQty");
const $d57808c9e3ca761c$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $d57808c9e3ca761c$export$c4393c51e6d104c3 = (fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, gatewayGraphqlUrl, cloudId)=>{
    const userClient = new (0, $2vQty.CustomProfileClient)(fabricPfDirUrl, baseUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $lsiAJ.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        teamCentralUrl: teamCentralUrl,
        teamCentralBaseUrl: teamCentralBaseUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId
    }, {
        userClient: userClient
    });
};
const $d57808c9e3ca761c$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, baseUrl: baseUrl, profileClient: profileClient, onLoadError: onLoadError, teamCentralUrl: teamCentralUrl, teamCentralBaseUrl: teamCentralBaseUrl, cloudId: cloudId })=>{
        const finalProfileClient = profileClient || $d57808c9e3ca761c$export$c4393c51e6d104c3(fabricPfDirUrl, baseUrl, onLoadError, teamCentralUrl, teamCentralBaseUrl, $d57808c9e3ca761c$var$GATEWAY_GRAPHQL_URL, cloudId);
        setState({
            profileClient: finalProfileClient
        });
    };
const $d57808c9e3ca761c$export$e324594224ef24da = {
    bootstrap: $d57808c9e3ca761c$export$36aff1fbb4f5dfc6
};
const $d57808c9e3ca761c$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $d57808c9e3ca761c$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    initialState: $d57808c9e3ca761c$export$d4c72bab9d6cc13a,
    actions: $d57808c9e3ca761c$export$e324594224ef24da
});
const $d57808c9e3ca761c$export$10cad281024d43c8 = (0, $WBLbN.createSubscriber)($d57808c9e3ca761c$export$6f57813fe9f31bf9);
const $d57808c9e3ca761c$export$d43dc22a8337ee9f = (0, $WBLbN.createHook)($d57808c9e3ca761c$export$6f57813fe9f31bf9);
const $d57808c9e3ca761c$export$d816ba2709570028 = (0, $WBLbN.createContainer)($d57808c9e3ca761c$export$6f57813fe9f31bf9, {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($d57808c9e3ca761c$export$e324594224ef24da.bootstrap())
});

});
parcelRegister("2vQty", function(module, exports) {

$parcel$export(module.exports, "CustomProfileClient", () => $1299391c5e75a14e$export$aa8db43941b8d3a7);
parcelRequire("j2NCp");
var $b4hs7 = parcelRequire("b4hs7");

var $2OdyW = parcelRequire("2OdyW");

var $bv8gI = parcelRequire("bv8gI");
class $1299391c5e75a14e$export$aa8db43941b8d3a7 extends (0, $b4hs7.default) {
    constructor(fabricPfDirUrl, baseUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        });
        this.makeRequest = async (cloudId, userId)=>{
            // call old profilerestendpoint
            try {
                if ((0, $bv8gI.isCustomerAccount)(userId)) {
                    const response = await (0, $2OdyW.default)(`${this.baseUrl}/rest/api/3/user?accountId=${userId}`);
                    return (0, $bv8gI.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.baseUrl = baseUrl;
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});






//# sourceMappingURL=async-profilecard.a843fab2.js.map
